export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date (isoformat) */
  Date: { input: string; output: string; }
  /** Date with time (isoformat) */
  DateTime: { input: string; output: string; }
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: { input: string | number; output: string | number; }
  /** A string-serialized scalar represents a set of fields that's passed to a federated directive, such as @key, @requires, or @provides */
  FieldSet: { input: any; output: any; }
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](https://ecma-international.org/wp-content/uploads/ECMA-404_2nd_edition_december_2017.pdf). */
  JSON: { input: any; output: any; }
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: { input: any; output: any; }
  /**
   * The `Time` scalar type represents a Time value as
   * specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Time: { input: string; output: string; }
  /**
   * Leverages the internal Python implementation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: { input: string; output: string; }
  /**
   * Create scalar that ignores normal serialization/deserialization, since
   * that will be handled by the multipart request spec
   */
  Upload: { input: any; output: any; }
  _Any: { input: any; output: any; }
  /** This string-serialized scalar represents an authorization policy. */
  federation__Policy: { input: any; output: any; }
  /** This string-serialized scalar represents a JWT scope */
  federation__Scope: { input: any; output: any; }
};

export type ApiTokenType = {
  __typename?: 'APITokenType';
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  rolesCompany: Array<RoleCompanyType>;
  rolesCorporate: Array<RoleCorporateType>;
  rolesCustomer: Array<RoleCustomerType>;
};

export type AtcCodesInfo = {
  __typename?: 'ATCCodesInfo';
  atcs: Array<Maybe<AtcType>>;
  codeSystem?: Maybe<CodeSystemType>;
};

/** Value belongs to codesystem 1.2.246.537.6.32 values. */
export type AtcType = {
  __typename?: 'ATCType';
  code: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/**
 * Records that the acting user accepted the current terms of use version
 * (settings.TERMS_OF_USE_VERSION). The row's owner check runs in UserSettings.save().
 */
export type AcceptTermsOfUse = {
  __typename?: 'AcceptTermsOfUse';
  userSettings: UserSettingsType;
};

export type AcknowledgmentType = {
  __typename?: 'AcknowledgmentType';
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<CustomerType>;
  employee?: Maybe<UserType>;
  id: Scalars['ID']['output'];
  type: AcknowledgmentsAcknowledgmentTypeChoices;
  user: UserType;
};

/** An enumeration. */
export enum AcknowledgmentTypeChoices {
  Custom = 'CUSTOM',
  EmployeeInformation = 'EMPLOYEE_INFORMATION',
  EmployeeInsurances = 'EMPLOYEE_INSURANCES',
  EmployeeList = 'EMPLOYEE_LIST',
  OrganizationInsurances = 'ORGANIZATION_INSURANCES',
  ServiceSettings = 'SERVICE_SETTINGS'
}

/** An enumeration. */
export enum AcknowledgmentsAcknowledgmentTypeChoices {
  /** Custom */
  Custom = 'CUSTOM',
  /** Employee Information */
  EmployeeInformation = 'EMPLOYEE_INFORMATION',
  /** Employee Insurances */
  EmployeeInsurances = 'EMPLOYEE_INSURANCES',
  /** Employee List */
  EmployeeList = 'EMPLOYEE_LIST',
  /** Organization Insurances */
  OrganizationInsurances = 'ORGANIZATION_INSURANCES',
  /** Service Settings */
  ServiceSettings = 'SERVICE_SETTINGS'
}

export type ActionPlanType = {
  __typename?: 'ActionPlanType';
  createdAt: Scalars['DateTime']['output'];
  customer: CustomerType;
  dateAccepted?: Maybe<Scalars['Date']['output']>;
  dateValidFrom: Scalars['Date']['output'];
  dateValidTo: Scalars['Date']['output'];
  exposureAccident: Scalars['Boolean']['output'];
  exposureBiological: Scalars['Boolean']['output'];
  exposureChemical: Scalars['Boolean']['output'];
  exposureErgonomic: Scalars['Boolean']['output'];
  exposureNightWork: Scalars['Boolean']['output'];
  exposurePhysical: Scalars['Boolean']['output'];
  exposurePsychological: Scalars['Boolean']['output'];
  exposureSocial: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  relatedWorkPlaceAssessmentUpdatedAt?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum ActionType {
  Create = 'CREATE',
  Delete = 'DELETE',
  HardDelete = 'HARD_DELETE',
  Update = 'UPDATE'
}

export type ActiveIngredientType = {
  __typename?: 'ActiveIngredientType';
  atcCode?: Maybe<Scalars['String']['output']>;
  ingredientNumber?: Maybe<Scalars['Int']['output']>;
  intensity?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderNumber?: Maybe<Scalars['Int']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

/** Value belongs to codesystem 1.2.246.537.5.40300 values. */
export type ActiveStatus = {
  __typename?: 'ActiveStatus';
  code: Scalars['String']['output'];
  codeSystem?: Maybe<CodeSystemType>;
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
};

/** An enumeration. */
export enum ActivityReportedChoices {
  Euros = 'EUROS',
  EurosActivity = 'EUROS_ACTIVITY'
}

export type AcuteBillableEventInputType = {
  amountMultiplier?: InputMaybe<Scalars['Decimal']['input']>;
  customerId: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
  eventId: Scalars['String']['input'];
  eventName: Scalars['String']['input'];
  isInsuranceBilled?: InputMaybe<Scalars['Boolean']['input']>;
  kelaCode?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Decimal']['input'];
  priceListId: Scalars['String']['input'];
  professionalClass: Scalars['String']['input'];
  professionalName: Scalars['String']['input'];
  reimbursementClass: Scalars['String']['input'];
  sessionDuration: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  time: Scalars['Time']['input'];
  timeMultiplier?: InputMaybe<Scalars['Decimal']['input']>;
};

export type AddCampaignSurveyRespondent = {
  __typename?: 'AddCampaignSurveyRespondent';
  campaign?: Maybe<CampaignType>;
};

export type AddHealthCheck = {
  __typename?: 'AddHealthCheck';
  healthCheck: HealthCheckBasicInformation;
};

export type AddMultiSignatureValueToPrescriptions = {
  __typename?: 'AddMultiSignatureValueToPrescriptions';
  /** List of signed prescription oid codes. */
  signedPrescriptionOidCodes: Array<Maybe<Scalars['String']['output']>>;
};

export type AddNorrePackageInterface = {
  norrePackage: NorrePackageType;
};

export type AddPatient = {
  __typename?: 'AddPatient';
  email?: Maybe<Scalars['String']['output']>;
};

export type AddPaymentCommitmentPurchase = {
  __typename?: 'AddPaymentCommitmentPurchase';
  paymentCommitmentPurchase: PaymentCommitmentPurchaseType;
};

export type AddSignatureValueToPrescription = {
  __typename?: 'AddSignatureValueToPrescription';
  prescriptionOid: Scalars['String']['output'];
};

export type AddSurveyAnswer = {
  __typename?: 'AddSurveyAnswer';
  treeResult: TreeResultType;
};

export type AddUserEmploymentInformation = {
  __typename?: 'AddUserEmploymentInformation';
  userEmploymentInformation?: Maybe<UserEmploymentInformationType>;
};

export type AddUserInformationViewReasonLog = {
  __typename?: 'AddUserInformationViewReasonLog';
  logEntry?: Maybe<UserInformationViewLogType>;
};

export type AlvType = {
  __typename?: 'AlvType';
  id: Scalars['ID']['output'];
  percent: Scalars['Decimal']['output'];
  validFrom: Scalars['Date']['output'];
};

export type ApproveInvoicePurchases = {
  __typename?: 'ApproveInvoicePurchases';
  invoicePurchases?: Maybe<Array<Maybe<InvoicePurchaseType>>>;
};

/** Value belongs to codesystem 1.2.246.537.5.40301 values. */
export type ArchiveStatus = {
  __typename?: 'ArchiveStatus';
  code: Scalars['String']['output'];
  codeSystem?: Maybe<CodeSystemType>;
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
};

/** An enumeration. */
export enum AssignedAmountRepresentation {
  PackageRepresentation = 'PACKAGE_REPRESENTATION',
  TimeRepresentation = 'TIME_REPRESENTATION',
  TotalAmountRepresentation = 'TOTAL_AMOUNT_REPRESENTATION'
}

export type AuthUserType = {
  __typename?: 'AuthUserType';
  calledByName?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  firstNames: Array<Scalars['String']['output']>;
  language: Scalars['String']['output'];
  lastIdentification?: Maybe<Scalars['DateTime']['output']>;
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  primarySite?: Maybe<SiteType>;
  sitesAware: Array<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

/** Value belongs to codesystem 1.2.246.537.5.40006 values. */
export type AuthorDefinerType = {
  __typename?: 'AuthorDefinerType';
  code: Scalars['String']['output'];
  codeSystem?: Maybe<CodeSystemType>;
  displayName: Scalars['String']['output'];
};

export type AuthorGeneralInfo = {
  __typename?: 'AuthorGeneralInfo';
  familyNames: Array<Maybe<Scalars['String']['output']>>;
  firstNames: Array<Maybe<Scalars['String']['output']>>;
  svNumber?: Maybe<Scalars['String']['output']>;
};

export type AvailabilityFailure = {
  __typename?: 'AvailabilityFailure';
  fromDate: Scalars['Date']['output'];
  toDate: Scalars['Date']['output'];
};

export type BillablePatientInputType = {
  date: Scalars['Date']['input'];
  personalId: Scalars['String']['input'];
};

export type BillablePatientType = {
  __typename?: 'BillablePatientType';
  date: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  laboratorybillableeventSet: Array<LaboratoryBillableEventType>;
  patient?: Maybe<PatientType>;
};

export type BillablePatientUserRowType = {
  __typename?: 'BillablePatientUserRowType';
  email: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type BillableReportEventType = {
  __typename?: 'BillableReportEventType';
  date: Scalars['Date']['output'];
  eventName: Scalars['String']['output'];
  reimbursementClass: Scalars['String']['output'];
};

export type BillableReportPatientType = {
  __typename?: 'BillableReportPatientType';
  name: Scalars['String']['output'];
};

export type BillableReportPeriodType = {
  __typename?: 'BillableReportPeriodType';
  endDate: Scalars['Date']['output'];
  startDate: Scalars['Date']['output'];
};

export type BillableType = {
  __typename?: 'BillableType';
  amountMultiplier: Scalars['Decimal']['output'];
  customer?: Maybe<MedicalCustomerType>;
  customerId: Scalars['Int']['output'];
  date: Scalars['Date']['output'];
  eventId: Scalars['String']['output'];
  eventName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isInsuranceBilled: Scalars['Boolean']['output'];
  kelaCode: Scalars['String']['output'];
  price: Scalars['Decimal']['output'];
  priceListId: Scalars['String']['output'];
  professionalClass: Scalars['String']['output'];
  professionalName: Scalars['String']['output'];
  reimbursementClass: Scalars['String']['output'];
  sessionDuration: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  time: Scalars['Time']['output'];
  timeMultiplier: Scalars['Decimal']['output'];
};

/** An enumeration. */
export enum BillablesBillingPeriodInvoiceRowTypeChoices {
  /** Customer Monthly Costs */
  CustomerMonthlyCosts = 'CUSTOMER_MONTHLY_COSTS',
  /** Exposure User Monthly Additional Costs */
  ExposureUserMonthlyAdditionalCosts = 'EXPOSURE_USER_MONTHLY_ADDITIONAL_COSTS',
  /** User Monthly Costs */
  UserMonthlyCosts = 'USER_MONTHLY_COSTS'
}

/** An enumeration. */
export enum BillablesBillingPeriodInvoiceRowUnitChoices {
  /** Day */
  Day = 'DAY',
  /** Month */
  Month = 'MONTH',
  /** Week */
  Week = 'WEEK'
}

/** An enumeration. */
export enum BillablesLaboratoryBillableEventSupplierChoices {
  /** Nordlab */
  Nordlab = 'NORDLAB',
  /** Synlab */
  Synlab = 'SYNLAB'
}

/** An enumeration. */
export enum BillablesStartUpCostsInvoiceRowTypeChoices {
  /** Customer Start Up */
  CustomerStartUp = 'CUSTOMER_START_UP',
  /** Extra Services Customer Start Up */
  ExtraServicesCustomerStartUp = 'EXTRA_SERVICES_CUSTOMER_START_UP',
  /** Extra Services User Start Up */
  ExtraServicesUserStartUp = 'EXTRA_SERVICES_USER_START_UP',
  /** Office Start Up */
  OfficeStartUp = 'OFFICE_START_UP',
  /** User Start Up */
  UserStartUp = 'USER_START_UP'
}

export type BillingPeriodInvoiceRowType = {
  __typename?: 'BillingPeriodInvoiceRowType';
  additionalInformation: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invoiceRow: InvoiceSaleRowType;
  periodEnd?: Maybe<Scalars['Date']['output']>;
  periodStart?: Maybe<Scalars['Date']['output']>;
  product?: Maybe<SalesExtraServiceType>;
  quantity: Scalars['Decimal']['output'];
  retrospectivelyFixedFrom?: Maybe<Scalars['Date']['output']>;
  retrospectivelyFixedTo?: Maybe<Scalars['Date']['output']>;
  salesPackage?: Maybe<SalesPackageType>;
  type: BillablesBillingPeriodInvoiceRowTypeChoices;
  unit: BillablesBillingPeriodInvoiceRowUnitChoices;
  unitPrice: Scalars['Decimal']['output'];
};

export type BodyCompositionMeasurementResultInfo = {
  bodyFat?: InputMaybe<Scalars['Decimal']['input']>;
  deviceId?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Decimal']['input']>;
  restingMetabolism?: InputMaybe<Scalars['Int']['input']>;
  skeletalMuscleMass?: InputMaybe<Scalars['Decimal']['input']>;
  visceralFat?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Decimal']['input']>;
};

export type BodyCompositionMeasurementResultType = {
  __typename?: 'BodyCompositionMeasurementResultType';
  bodyFat: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  deviceId: Scalars['Int']['output'];
  fitnessTest: FitnessTestType;
  fitnessTestDevice?: Maybe<FitnessTestDeviceType>;
  height: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  restingMetabolism: Scalars['Int']['output'];
  skeletalMuscleMass: Scalars['Decimal']['output'];
  updatedAt: Scalars['DateTime']['output'];
  visceralFat: Scalars['Int']['output'];
  weight: Scalars['Decimal']['output'];
};

/** An enumeration. */
export enum BranchBranchTypeChoices {
  Basic = 'BASIC',
  Condition = 'CONDITION',
  Link = 'LINK',
  Selection = 'SELECTION'
}

export type BranchType = {
  __typename?: 'BranchType';
  branchType: BranchesBranchBranchTypeChoices;
  condition?: Maybe<ConditionType>;
  conditionFormula: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  nextNode: NodeType;
  previousNode: NodeType;
  shorthand: Scalars['String']['output'];
  tag: Scalars['String']['output'];
};

/** An enumeration. */
export enum BranchesBranchBranchTypeChoices {
  /** Basic */
  Basic = 'BASIC',
  /** Condition */
  Condition = 'CONDITION',
  /** Link */
  Link = 'LINK',
  /** Selection */
  Selection = 'SELECTION'
}

export type BulkCreateAcuteBillableEvents = {
  __typename?: 'BulkCreateAcuteBillableEvents';
  results: Array<BulkCreateResult>;
};

export type BulkCreateBillablePatients = {
  __typename?: 'BulkCreateBillablePatients';
  results: Array<BulkCreateResult>;
};

export type BulkCreateLaboratoryBillableEvents = {
  __typename?: 'BulkCreateLaboratoryBillableEvents';
  results: Array<BulkCreateResult>;
};

export type BulkCreatePartnerProcedurePrices = {
  __typename?: 'BulkCreatePartnerProcedurePrices';
  results: Array<ProcedurePartnerPriceOrError>;
};

export type BulkCreatePartners = {
  __typename?: 'BulkCreatePartners';
  results: Array<PartnerOrError>;
};

export type BulkCreateReimbursementConversions = {
  __typename?: 'BulkCreateReimbursementConversions';
  results: Array<ErrorOrReimbursementConversion>;
};

export type BulkCreateResult = {
  __typename?: 'BulkCreateResult';
  error?: Maybe<Scalars['String']['output']>;
  isCreated: Scalars['Boolean']['output'];
  isUpdated: Scalars['Boolean']['output'];
};

export type BulkCreateUsers = {
  __typename?: 'BulkCreateUsers';
  results: Array<UserOrError>;
};

/** Value belongs to codesystem 1.2.246.537.6.12 values. */
export type CdaViewType = {
  __typename?: 'CDAViewType';
  OID?: Maybe<Scalars['String']['output']>;
  abbreviation: Scalars['String']['output'];
  code: Scalars['String']['output'];
  codeSystem?: Maybe<CodeSystemType>;
  displayName?: Maybe<Scalars['String']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
};

export type CampaignSurveyType = {
  __typename?: 'CampaignSurveyType';
  /** Users with completed answers */
  answeredBy?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  campaign: CampaignType;
  id: Scalars['ID']['output'];
  /** Users who will not have an answer to this survey */
  notAnsweredBy?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  respondents: Array<UserType>;
  survey: TreeType;
};

export type CampaignType = {
  __typename?: 'CampaignType';
  company?: Maybe<CompanyType>;
  createdAt: Scalars['DateTime']['output'];
  documentTemplates: Array<DocumentTemplateType>;
  end?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  start?: Maybe<Scalars['DateTime']['output']>;
  surveys: Array<CampaignSurveyType>;
  user?: Maybe<UserType>;
};

export type CancelLaboratoryOrder = {
  __typename?: 'CancelLaboratoryOrder';
  laboratoryOrder?: Maybe<LaboratoryOrderType>;
};

export type CareGuidanceCustomerType = {
  __typename?: 'CareGuidanceCustomerType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CareGuidanceInsuranceCompanyType = {
  __typename?: 'CareGuidanceInsuranceCompanyType';
  businessId: Scalars['String']['output'];
  instructions: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CareGuidancePartnerServiceType = {
  __typename?: 'CareGuidancePartnerServiceType';
  maxCasesPerYear?: Maybe<Scalars['Int']['output']>;
  maxVisitsPerCase?: Maybe<Scalars['Int']['output']>;
  procedureName?: Maybe<Scalars['String']['output']>;
  serviceType: PartnerServiceChoices;
  usageAllowed: Scalars['Boolean']['output'];
};

export type CareGuidanceType = {
  __typename?: 'CareGuidanceType';
  customerId: Scalars['ID']['output'];
  customerName: Scalars['String']['output'];
  isLegacyContract: Scalars['Boolean']['output'];
  maxDaysPerAbsencePeriod: Scalars['Int']['output'];
  maxDaysPerReport: Scalars['Int']['output'];
  mentalWellbeingCover: Scalars['Boolean']['output'];
  partnerServices: Array<CareGuidancePartnerServiceType>;
  physicalIllnessCover: Scalars['Boolean']['output'];
  selfReportAdditionalInstructions: Scalars['String']['output'];
  voluntaryHealthCheck: Scalars['Boolean']['output'];
  voluntaryInsuranceTypes: Array<InsuranceTypeChoices>;
  workAccidentInsuranceCompany?: Maybe<CareGuidanceInsuranceCompanyType>;
};

/** Value belongs to codesystem 1.2.246.537.6.13 values. */
export type CareStageType = {
  __typename?: 'CareStageType';
  OID: Scalars['String']['output'];
  code: Scalars['String']['output'];
  codeSystem?: Maybe<CodeSystemType>;
  displayName: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/** Value belongs to codesystem 1.2.246.537.5.40101 values. */
export type CaringType = {
  __typename?: 'CaringType';
  OID?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  codeSystem?: Maybe<CodeSystemType>;
  displayName: Scalars['String']['output'];
};

export type ChangeLaboratoryOrder = {
  __typename?: 'ChangeLaboratoryOrder';
  laboratoryOrder?: Maybe<LaboratoryOrderType>;
};

/** An enumeration. */
export enum CheckupLengthChoices {
  Min_30 = 'MIN_30',
  Min_45 = 'MIN_45',
  Min_60 = 'MIN_60',
  Min_90 = 'MIN_90',
  Min_120 = 'MIN_120'
}

/** An enumeration. */
export enum CheckupTypeChoices {
  Doctor = 'DOCTOR',
  Nurse = 'NURSE'
}

export type CodeSystemType = {
  __typename?: 'CodeSystemType';
  classificationIdentifier?: Maybe<Scalars['String']['output']>;
  lastModified?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  regLevel?: Maybe<Scalars['Int']['output']>;
  validFrom?: Maybe<Scalars['Date']['output']>;
  validTo?: Maybe<Scalars['Date']['output']>;
  versionNumber?: Maybe<Scalars['String']['output']>;
};

export type CompanyAddressType = {
  __typename?: 'CompanyAddressType';
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  company: CompanyType;
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  phone: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  useremploymentinformationSet: Array<UserEmploymentInformationType>;
};

export type CompanyReportToManagementType = {
  __typename?: 'CompanyReportToManagementType';
  company: CompanyType;
  companyId: Scalars['ID']['output'];
  customersContractSignedAmount: Scalars['Int']['output'];
  customersServicesOngoingAmount: Scalars['Int']['output'];
  time: Scalars['DateTime']['output'];
  usersContractSignedAmount: Scalars['Int']['output'];
  usersServicesOngoingAmount: Scalars['Int']['output'];
};

export type CompanyType = {
  __typename?: 'CompanyType';
  addresses: Array<CompanyAddressType>;
  businessId: Scalars['String']['output'];
  campaigns: Array<CampaignType>;
  companyRoles: Array<RoleCompanyType>;
  costcenterSet: Array<CostCenterType>;
  createdAt: Scalars['DateTime']['output'];
  customerSet: Array<CustomerType>;
  documentcategorySet: Array<DocumentCategoryType>;
  healthcareteams: Array<HealthcareTeamType>;
  id: Scalars['ID']['output'];
  invoiceinterface?: Maybe<InvoiceInterfaceType>;
  invoicepurchaseSet: Array<InvoicePurchaseType>;
  isPrimary: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  profileSet: Array<ProfileType>;
  usersCompany: Array<UserType>;
};

export type CompleteHealthCheck = {
  __typename?: 'CompleteHealthCheck';
  healthCheck: HealthCheckBasicInformation;
};

export type CompleteTask = {
  __typename?: 'CompleteTask';
  task: TaskType;
};

/**
 * Recomputes the peer cost benchmarks (costreports/benchmark.py). Run nightly by the Cloud
 * Scheduler job with an API token whose role grants only compute_cost_benchmarks (plus the
 * add/delete_costbenchmark write permissions the rows need). The request's own credentials are
 * forwarded to the medical backend for the payment commitment categories, which is why the job
 * runs inside the request instead of a management command.
 */
export type ComputeCostBenchmarks = {
  __typename?: 'ComputeCostBenchmarks';
  customers: Scalars['Int']['output'];
  groups: Scalars['Int']['output'];
  rows: Scalars['Int']['output'];
};

export type ConditionType = {
  __typename?: 'ConditionType';
  branch?: Maybe<BranchType>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  statementGroups: Array<StatementGroupType>;
};

/** Value belongs to codesystem 1.2.246.537.5.40119 values. */
export type ConsentType = {
  __typename?: 'ConsentType';
  code: Scalars['String']['output'];
  codeSystem?: Maybe<CodeSystemType>;
  displayName: Scalars['String']['output'];
};

export type ContactPersonExportRowType = {
  __typename?: 'ContactPersonExportRowType';
  businessId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  responsibleNurse: Scalars['String']['output'];
};

export type ContactPersonInputType = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type ContactPersonType = {
  __typename?: 'ContactPersonType';
  contactType: OrganizationsContactPersonContactTypeChoices;
  contactUser?: Maybe<UserType>;
  customer: CustomerType;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type ContactPersonsInputType = {
  contract: ContactPersonInputType;
  invoicing: ContactPersonInputType;
  occupationalHealth: ContactPersonInputType;
};

export type ContractBaseInfoInputType = {
  discounts: DiscountsInputType;
  extraServices: Array<SalesExtraServiceProductChoices>;
  isLegacyContract?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfPersonsExposure?: InputMaybe<Scalars['Int']['input']>;
  numberOfPersonsNonExposure?: InputMaybe<Scalars['Int']['input']>;
  prices: ContractPricesInputType;
  receptionType?: InputMaybe<ReceptionChoices>;
  salesPackageLevel: SalesPackageLevelChoices;
  salesmanEmail: Scalars['String']['input'];
  signedAt: Scalars['DateTime']['input'];
  validFrom: Scalars['Date']['input'];
};

export type ContractPricesInputType = {
  extraPriceExposure?: InputMaybe<Scalars['Decimal']['input']>;
  firstHealthCheckPrice?: InputMaybe<Scalars['Decimal']['input']>;
  initialCostExtraServicesPerCompany?: InputMaybe<Scalars['Decimal']['input']>;
  initialCostExtraServicesPerPerson?: InputMaybe<Scalars['Decimal']['input']>;
  initialCostPerCompany?: InputMaybe<Scalars['Decimal']['input']>;
  initialCostPerOffice?: InputMaybe<Scalars['Decimal']['input']>;
  initialCostPerPerson?: InputMaybe<Scalars['Decimal']['input']>;
  numberOfOffices?: InputMaybe<Scalars['Int']['input']>;
};

export type ContractTerminationReasonType = {
  __typename?: 'ContractTerminationReasonType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  salescontractSet: Array<SalesContractType>;
};

/** An enumeration. */
export enum CostBenchmarkTier {
  All = 'ALL',
  Exact = 'EXACT',
  ExtraServices = 'EXTRA_SERVICES'
}

/** An enumeration. */
export enum CostCategory {
  ExposureMonthlyFees = 'EXPOSURE_MONTHLY_FEES',
  HealthChecks = 'HEALTH_CHECKS',
  Kela_1Appointments = 'KELA_1_APPOINTMENTS',
  Kela_2Appointments = 'KELA_2_APPOINTMENTS',
  Laboratory = 'LABORATORY',
  MonthlyFees = 'MONTHLY_FEES',
  Other = 'OTHER',
  Physiotherapy = 'PHYSIOTHERAPY',
  Specialist = 'SPECIALIST',
  StartUp = 'START_UP',
  TherapyPsychology = 'THERAPY_PSYCHOLOGY'
}

export type CostCenterInvoiceRowType = {
  __typename?: 'CostCenterInvoiceRowType';
  amount: Scalars['Decimal']['output'];
  amountVatTaxable: Scalars['Decimal']['output'];
  amountVatZero: Scalars['Decimal']['output'];
  amountWithVat: Scalars['Decimal']['output'];
  costCenter?: Maybe<CostCenterType>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invoiceRow: InvoiceSaleRowType;
  vatAmount: Scalars['Decimal']['output'];
};

export type CostCenterType = {
  __typename?: 'CostCenterType';
  company?: Maybe<CompanyType>;
  costCenterInvoiceRows: Array<CostCenterInvoiceRowType>;
  customer?: Maybe<CustomerType>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  remoteId?: Maybe<Scalars['String']['output']>;
  userSet: Array<UserType>;
};

/** An enumeration. */
export enum CostReportBasis {
  Estimate = 'ESTIMATE',
  Preliminary = 'PRELIMINARY',
  Realized = 'REALIZED'
}

/** An enumeration. */
export enum CostReportBucket {
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Year = 'YEAR'
}

/**
 * Aggregate report type, no direct model — one time bucket of the cost report. Access is
 * verified in the query resolver and re-verified on every list field of CostReportType.
 */
export type CostReportBucketRangeType = {
  __typename?: 'CostReportBucketRangeType';
  dateFrom: Scalars['Date']['output'];
  dateTo: Scalars['Date']['output'];
  isPast: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  notYetInvoiced: Scalars['Boolean']['output'];
  personMonths: Scalars['Decimal']['output'];
};

/**
 * Aggregate report type, no direct model — the costs of one bucket × group × category. The
 * category is null when the category split is suppressed for the viewer.
 */
export type CostReportCellType = {
  __typename?: 'CostReportCellType';
  basis: CostReportBasis;
  bucketKey: Scalars['String']['output'];
  category?: Maybe<CostCategory>;
  estimated: Scalars['Decimal']['output'];
  groupKey: Scalars['String']['output'];
  merged: Scalars['Boolean']['output'];
  preliminary: Scalars['Decimal']['output'];
  realized: Scalars['Decimal']['output'];
};

/** An enumeration. */
export enum CostReportEstimateBasis {
  Benchmark = 'BENCHMARK',
  None = 'NONE',
  OwnHistory = 'OWN_HISTORY'
}

/**
 * Aggregate report type, no direct model — one group of the cost center split (ALL / cost
 * center id / NONE = users without a cost center / OTHER = merged small cost centers).
 */
export type CostReportGroupType = {
  __typename?: 'CostReportGroupType';
  averageHeadcount: Scalars['Decimal']['output'];
  key: Scalars['String']['output'];
  merged: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/**
 * Aggregate configuration type, no direct model — range limits of the cost report
 * (costreports/periods.py). Not sensitive; shown in the UI.
 */
export type CostReportLimitsType = {
  __typename?: 'CostReportLimitsType';
  maxFutureMonths: Scalars['Int']['output'];
  maxRangeMonths: Scalars['Int']['output'];
};

/**
 * Aggregate report type, no direct model — a category merged into OTHER in one bucket (every
 * group of the bucket) because fewer than minContributors employees were behind it.
 */
export type CostReportMergedCellType = {
  __typename?: 'CostReportMergedCellType';
  bucketKey: Scalars['String']['output'];
  category: CostCategory;
};

/** Aggregate report type, no direct model — the KPIs of the cost report (costreports/reporting.py). */
export type CostReportSummaryType = {
  __typename?: 'CostReportSummaryType';
  averageHeadcount: Scalars['Decimal']['output'];
  benchmarkCostPerPersonYear?: Maybe<Scalars['Decimal']['output']>;
  benchmarkPeerCount?: Maybe<Scalars['Int']['output']>;
  benchmarkTier?: Maybe<CostBenchmarkTier>;
  costPerPersonYearEstimated?: Maybe<Scalars['Decimal']['output']>;
  costPerPersonYearRealized?: Maybe<Scalars['Decimal']['output']>;
  estimateBasis: CostReportEstimateBasis;
  estimateTotal: Scalars['Decimal']['output'];
  estimatedTotal: Scalars['Decimal']['output'];
  fennoaDataUsed: Scalars['Boolean']['output'];
  latestRealizedMonth?: Maybe<Scalars['Date']['output']>;
  personMonthsRealized: Scalars['Decimal']['output'];
  personMonthsTotal: Scalars['Decimal']['output'];
  preliminaryTotal: Scalars['Decimal']['output'];
  realizedTotal: Scalars['Decimal']['output'];
};

/**
 * Aggregate report type, no direct model — the customer's cost report (costreports/reporting.py).
 * The query resolver verifies access and every field re-verifies it (verify_permission_cost_report
 * via the default resolver), so the dict can never leak through a cached or re-used object.
 */
export type CostReportType = {
  __typename?: 'CostReportType';
  bucket: CostReportBucket;
  buckets: Array<CostReportBucketRangeType>;
  byCostCenter: Scalars['Boolean']['output'];
  categories: Array<CostCategory>;
  categoryBreakdownSuppressed: Scalars['Boolean']['output'];
  cells: Array<CostReportCellType>;
  costCenterBreakdownSuppressed: Scalars['Boolean']['output'];
  currentMonth: Scalars['Date']['output'];
  customerId: Scalars['ID']['output'];
  dateFrom: Scalars['Date']['output'];
  dateTo: Scalars['Date']['output'];
  groups: Array<CostReportGroupType>;
  mergedCategoryCells: Array<CostReportMergedCellType>;
  mergedGroupKeys: Array<Scalars['String']['output']>;
  minCohort: Scalars['Int']['output'];
  minContributors: Scalars['Int']['output'];
  summary: CostReportSummaryType;
  warnings: Array<Scalars['String']['output']>;
};

export type CostSettingsType = {
  __typename?: 'CostSettingsType';
  accidentSpecificDeductible: Scalars['Decimal']['output'];
  accidentSpecificExpenseCeiling: Scalars['Decimal']['output'];
  customerServiceSetting: CustomerServiceSettingsType;
  yearlyExpenseCeilingPerEmployee: Scalars['Decimal']['output'];
};

export type CreateAcknowledgment = {
  __typename?: 'CreateAcknowledgment';
  acknowledgment: AcknowledgmentType;
};

export type CreateActionPlan = {
  __typename?: 'CreateActionPlan';
  actionPlan: ActionPlanType;
};

export type CreateAndSendLaboratoryOrder = {
  __typename?: 'CreateAndSendLaboratoryOrder';
  laboratoryOrder?: Maybe<LaboratoryOrderType>;
};

export type CreateApiToken = {
  __typename?: 'CreateApiToken';
  token: Scalars['String']['output'];
  tokenObject: ApiTokenType;
};

export type CreateBranch = {
  __typename?: 'CreateBranch';
  branch?: Maybe<BranchType>;
};

export type CreateCampaign = {
  __typename?: 'CreateCampaign';
  campaign?: Maybe<CampaignType>;
};

export type CreateChoiceBranch = {
  __typename?: 'CreateChoiceBranch';
  branch?: Maybe<BranchType>;
};

export type CreateCompanyAndSetAddresses = {
  __typename?: 'CreateCompanyAndSetAddresses';
  company?: Maybe<CompanyType>;
};

export type CreateCostCenter = {
  __typename?: 'CreateCostCenter';
  costCenter?: Maybe<CostCenterType>;
};

export type CreateCustomer = {
  __typename?: 'CreateCustomer';
  customer?: Maybe<CustomerType>;
};

export type CreateCustomerAddress = {
  __typename?: 'CreateCustomerAddress';
  address: CustomerAddressType;
};

export type CreateCustomerInvoiceDraft = {
  __typename?: 'CreateCustomerInvoiceDraft';
  invoice: InvoiceSaleType;
};

export type CreateCustomerInvoiceDraftInput = {
  acuteEvents?: InputMaybe<Scalars['Boolean']['input']>;
  billingPeriodMonthlyFeesInAdvance?: InputMaybe<InvoicingBillingPeriodInput>;
  billingPeriodPastEvents?: InputMaybe<InvoicingBillingPeriodInput>;
  billingPeriodPastMonthlyFeesFixing?: InputMaybe<InvoicingBillingPeriodInput>;
  costCenterBreakdown?: InputMaybe<Scalars['Boolean']['input']>;
  customerId: Scalars['ID']['input'];
  initialCosts?: InputMaybe<Scalars['Boolean']['input']>;
  laboratoryEvents?: InputMaybe<Scalars['Boolean']['input']>;
  monthlyFeesFixingRetrospectively?: InputMaybe<Scalars['Boolean']['input']>;
  monthlyFeesInAdvance?: InputMaybe<Scalars['Boolean']['input']>;
  paymentCommitments?: InputMaybe<Scalars['Boolean']['input']>;
  shippingDate: Scalars['Date']['input'];
};

export type CreateCustomerWithContract = {
  __typename?: 'CreateCustomerWithContract';
  contract: SalesContractType;
};

export type CreateDocument = {
  __typename?: 'CreateDocument';
  document?: Maybe<DocumentType>;
};

export type CreateDocumentCategory = {
  __typename?: 'CreateDocumentCategory';
  documentCategory?: Maybe<DocumentCategoryType>;
};

export type CreateDocumentTemplate = {
  __typename?: 'CreateDocumentTemplate';
  template?: Maybe<DocumentTemplateType>;
};

export type CreateDocumentTemplateItem = {
  __typename?: 'CreateDocumentTemplateItem';
  item?: Maybe<DocumentTemplateItemType>;
};

export type CreateDocumentVersion = {
  __typename?: 'CreateDocumentVersion';
  documentVersion?: Maybe<DocumentVersionType>;
};

export type CreateEmployeeGroup = {
  __typename?: 'CreateEmployeeGroup';
  employeeGroup: EmployeeGroupType;
};

export type CreateEmptyLaboratoryCatalog = {
  __typename?: 'CreateEmptyLaboratoryCatalog';
  laboratoryCatalog: LaboratoryCatalogType;
};

export type CreateExposure = {
  __typename?: 'CreateExposure';
  exposure: ExposureType;
};

export type CreateFitnessTest = {
  __typename?: 'CreateFitnessTest';
  fitnessTest: FitnessTestType;
};

export type CreateFitnessTestDevice = {
  __typename?: 'CreateFitnessTestDevice';
  fitnessTestDevice: FitnessTestDeviceType;
};

export type CreateHealthCheckContentConfiguration = {
  __typename?: 'CreateHealthCheckContentConfiguration';
  contentConfiguration: HealthCheckContentConfigurationType;
};

export type CreateHealthcareTeam = {
  __typename?: 'CreateHealthcareTeam';
  healthcareTeam?: Maybe<HealthcareTeamType>;
};

export type CreateInsuranceCompany = {
  __typename?: 'CreateInsuranceCompany';
  insuranceCompany: InsuranceCompanyType;
};

export type CreateInvoiceInterface = {
  __typename?: 'CreateInvoiceInterface';
  invoiceInterface?: Maybe<InvoiceInterfaceType>;
};

export type CreateInvoicePurchaseComment = {
  __typename?: 'CreateInvoicePurchaseComment';
  invoicePurchaseComment?: Maybe<InvoicePurchaseCommentType>;
};

export type CreateLaboratoryCatalogBasedOnExisting = {
  __typename?: 'CreateLaboratoryCatalogBasedOnExisting';
  laboratoryCatalog: LaboratoryCatalogType;
};

export type CreateLaboratorySupplier = {
  __typename?: 'CreateLaboratorySupplier';
  laboratorySupplier?: Maybe<LaboratorySupplierType>;
};

export type CreateMedicalApiToken = {
  __typename?: 'CreateMedicalApiToken';
  token: Scalars['String']['output'];
  tokenObject: MedicalApiTokenType;
};

export type CreateNorrePackage = {
  __typename?: 'CreateNorrePackage';
  norrePackage?: Maybe<NorrePackageType>;
};

export type CreateOrUpdateLaboratorySalesPrice = {
  __typename?: 'CreateOrUpdateLaboratorySalesPrice';
  laboratoryCatalogSalesPrice?: Maybe<LaboratoryCatalogSalesPriceType>;
};

export type CreateOrganization = {
  __typename?: 'CreateOrganization';
  businessId?: Maybe<Scalars['String']['output']>;
};

export type CreatePartner = {
  __typename?: 'CreatePartner';
  partner?: Maybe<PartnerType>;
};

export type CreatePaymentCommitment = {
  __typename?: 'CreatePaymentCommitment';
  paymentCommitment?: Maybe<PaymentCommitmentType>;
};

export type CreatePaymentCommitmentPatientInfo = {
  __typename?: 'CreatePaymentCommitmentPatientInfo';
  paymentCommitmentPatientInfo: PaymentCommitmentPatientInfoType;
};

export type CreatePrescription = {
  __typename?: 'CreatePrescription';
  /** Unique identifier of the created prescription. */
  prescriptionOid?: Maybe<Scalars['String']['output']>;
};

export type CreateProcedure = {
  __typename?: 'CreateProcedure';
  procedure?: Maybe<ProcedureType>;
};

export type CreateProcedurePartnerPrice = {
  __typename?: 'CreateProcedurePartnerPrice';
  procedurePartnerPrice?: Maybe<ProcedurePartnerPriceType>;
};

export type CreateProfessionalGroup = {
  __typename?: 'CreateProfessionalGroup';
  professionalGroup?: Maybe<ProfessionalGroupType>;
};

export type CreateProfile = {
  __typename?: 'CreateProfile';
  profile?: Maybe<ProfileType>;
};

export type CreateQuestion = {
  __typename?: 'CreateQuestion';
  question: QuestionType;
};

export type CreateReimbursementConversion = {
  __typename?: 'CreateReimbursementConversion';
  reimbursementConversion?: Maybe<ReimbursementConversionType>;
};

export type CreateRoleCompany = {
  __typename?: 'CreateRoleCompany';
  roleCompany?: Maybe<RoleCompanyType>;
};

export type CreateRoleCorporate = {
  __typename?: 'CreateRoleCorporate';
  roleCorporate?: Maybe<RoleCorporateType>;
};

export type CreateRoleInfoInputType = {
  orgId: Scalars['ID']['input'];
  profileId: Scalars['ID']['input'];
};

export type CreateSalesCatalog = {
  __typename?: 'CreateSalesCatalog';
  salesCatalog: SalesCatalogType;
};

export type CreateSalesContractVersion = {
  __typename?: 'CreateSalesContractVersion';
  salesContractVersion: SalesContractVersionType;
};

export type CreateServiceEvent = {
  __typename?: 'CreateServiceEvent';
  serviceEvent?: Maybe<ServiceEvent>;
};

export type CreateSickLeaveCategory = {
  __typename?: 'CreateSickLeaveCategory';
  sickLeaveCategory?: Maybe<SickLeaveCategoryType>;
};

/**
 * Names a person who handles sick leave notices of every employee of the customer for the
 * given reasons. The user may belong to another customer if they hold a role in this one.
 */
export type CreateSickLeaveHandler = {
  __typename?: 'CreateSickLeaveHandler';
  sickLeaveHandler: SickLeaveHandlerType;
};

export type CreateSickLeaveNotice = {
  __typename?: 'CreateSickLeaveNotice';
  sickLeaveNotice?: Maybe<SickLeaveNoticeType>;
};

export type CreateSickLeavePeriodSetting = {
  __typename?: 'CreateSickLeavePeriodSetting';
  sickLeavePeriodSetting?: Maybe<SickLeavePeriodSettingType>;
};

/**
 * Adds a recurrent absence rule (at least `periods` periods within `months` months) to the
 * customer's early support settings.
 */
export type CreateSickLeaveRecurrentAbsenceThreshold = {
  __typename?: 'CreateSickLeaveRecurrentAbsenceThreshold';
  sickLeaveRecurrentAbsenceThreshold: SickLeaveRecurrentAbsenceThresholdType;
};

export type CreateSickLeaveSelfReportReason = {
  __typename?: 'CreateSickLeaveSelfReportReason';
  sickLeaveSelfReportReason?: Maybe<SickLeaveSelfReportReasonType>;
};

export type CreateSupplierPackage = {
  __typename?: 'CreateSupplierPackage';
  supplierPackage?: Maybe<SupplierPackageType>;
};

export type CreateTaskInput = {
  assignment?: InputMaybe<TaskAssignmentInput>;
  completeDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedBy?: InputMaybe<Scalars['ID']['input']>;
  completedNow?: InputMaybe<Scalars['Boolean']['input']>;
  customerId: Scalars['ID']['input'];
  removeDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
  /** With an explicit completed_at: delete the customer's completed tasks of the same type whose completed_at is later than the given one, so a corrected (earlier) completion becomes the latest one. */
  removeLaterCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  scheduling?: InputMaybe<TaskSchedulingInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: TaskTypeChoices;
};

export type CreateTitleTemplate = {
  __typename?: 'CreateTitleTemplate';
  titleTemplate?: Maybe<TitleTemplateType>;
};

export type CreateTree = {
  __typename?: 'CreateTree';
  tree: TreeType;
};

export type CreateUser = {
  __typename?: 'CreateUser';
  user: UserType;
};

export type CreateView = {
  __typename?: 'CreateView';
  view: ViewType;
};

export type CreateZefSurveyConfigurationVersion = {
  __typename?: 'CreateZEFSurveyConfigurationVersion';
  configuration: ZefSurveyConfigurationVersionType;
};

export type CustomerAddressType = {
  __typename?: 'CustomerAddressType';
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer: CustomerType;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  phone: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  useremploymentinformationSet: Array<UserEmploymentInformationType>;
};

export type CustomerAnnualPlanningStatus = {
  __typename?: 'CustomerAnnualPlanningStatus';
  businessId: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CustomerBaseInfoInputType = {
  accountingPeriodEnd?: InputMaybe<Scalars['Date']['input']>;
  accountingPeriodStart?: InputMaybe<Scalars['Date']['input']>;
  address: Scalars['String']['input'];
  businessId: Scalars['String']['input'];
  city: Scalars['String']['input'];
  contractContactPerson: ContactPersonInputType;
  invoicing: InvoicingBaseInfoInputType;
  name: Scalars['String']['input'];
  occupationalHealthContactPerson: ContactPersonInputType;
  parentCompanyBusinessId: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
};

export type CustomerBillableUncompletedReason = {
  __typename?: 'CustomerBillableUncompletedReason';
  customerId: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
};

export type CustomerBillableUncompletedType = {
  __typename?: 'CustomerBillableUncompletedType';
  customers: Array<CustomerType>;
  reasons: Array<CustomerBillableUncompletedReason>;
};

export type CustomerBillingStatus = {
  __typename?: 'CustomerBillingStatus';
  contractEndDate?: Maybe<Scalars['Date']['output']>;
  contractStartDate?: Maybe<Scalars['Date']['output']>;
  currentContract?: Maybe<SalesContractVersionType>;
  customer: CustomerType;
  isCostCentersDefined: Scalars['Boolean']['output'];
  lastAcuteEvent?: Maybe<Scalars['DateTime']['output']>;
  lastBillingPeriodInvoice?: Maybe<BillingPeriodInvoiceRowType>;
  lastLaboratoryEventInvoice?: Maybe<LaboratoryEventSalesInvoiceRowType>;
  lastLaboratoryPurchase?: Maybe<Scalars['Date']['output']>;
  lastPaymentCommitment?: Maybe<Scalars['Date']['output']>;
  lastPaymentCommitmentInvoice?: Maybe<PaymentCommitmentSalesInvoiceRowType>;
  lastPaymentCommitmentPurchase?: Maybe<Scalars['Date']['output']>;
  lastStartUpCostsInvoice?: Maybe<StartUpCostsInvoiceRowType>;
  usersMissingCostCenter: Array<UserType>;
};

export type CustomerEmployeeList = {
  __typename?: 'CustomerEmployeeList';
  customerId: Scalars['ID']['output'];
  employees: Array<EmployeeForCustomerUserType>;
  employeesWithoutSupervisor: Array<UserOrganizationalStructureInfo>;
  includeDeleted: Scalars['Boolean']['output'];
  includeInactive: Scalars['Boolean']['output'];
  profiles: Array<EmployeeProfileInfoForCustomerUserType>;
};

/** Value belongs to codesystem 1.2.246.537.6.240 values. */
export type CustomerInformationViewReasonType = {
  __typename?: 'CustomerInformationViewReasonType';
  code: Scalars['String']['output'];
  codeSystem?: Maybe<CodeSystemType>;
  displayName: Scalars['String']['output'];
  userinformationviewlogSet: Array<UserInformationViewLogType>;
};

export type CustomerInternalNotesType = {
  __typename?: 'CustomerInternalNotesType';
  customer: CustomerType;
  id: Scalars['ID']['output'];
  nursing: Scalars['String']['output'];
  occupationalHealthCare: Scalars['String']['output'];
  sales: Scalars['String']['output'];
};

/** An enumeration. */
export enum CustomerInvoicingMethod {
  Email = 'EMAIL',
  EInvoice = 'E_INVOICE',
  Post = 'POST'
}

export type CustomerServiceSettingsType = {
  __typename?: 'CustomerServiceSettingsType';
  costSettings: CostSettingsType;
  customer: CustomerType;
  partnerNetworkUsage: PartnerservicesCustomerServiceSettingsPartnerNetworkUsageChoices;
  partnerServiceSettings: Array<PartnerServiceSettingType>;
  voluntaryHealthCheck: Scalars['Boolean']['output'];
};

export type CustomerServicesOverview = {
  __typename?: 'CustomerServicesOverview';
  customerId: Scalars['ID']['output'];
  extraServices: Array<SalesExtraServiceType>;
  isLegacyContract?: Maybe<Scalars['Boolean']['output']>;
  legacyServicesDescription?: Maybe<Scalars['String']['output']>;
  legacyServicesName?: Maybe<Scalars['String']['output']>;
  salesPackage?: Maybe<SalesPackageType>;
};

export type CustomerTaskStatus = {
  __typename?: 'CustomerTaskStatus';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  customerId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: TaskTypeChoices;
};

export type CustomerType = {
  __typename?: 'CustomerType';
  accountingPeriodEnd?: Maybe<Scalars['Date']['output']>;
  accountingPeriodStart?: Maybe<Scalars['Date']['output']>;
  acknowledgments: Array<AcknowledgmentType>;
  actionplanSet: Array<ActionPlanType>;
  addedToAcuteAt?: Maybe<Scalars['DateTime']['output']>;
  addresses: Array<CustomerAddressType>;
  attachmentAddressCity: Scalars['String']['output'];
  attachmentAddressEmail: Scalars['String']['output'];
  attachmentAddressPostCode: Scalars['String']['output'];
  attachmentAddressStreetAddress: Scalars['String']['output'];
  bic: Scalars['String']['output'];
  billingPeriods: Array<StartUpCostsInvoiceRowType>;
  businessId: Scalars['String']['output'];
  company: CompanyType;
  contactPersons: Array<ContactPersonType>;
  contractContact?: Maybe<ContactPersonType>;
  contracts: Array<SalesContractType>;
  costcenterSet: Array<CostCenterType>;
  createdAt: Scalars['DateTime']['output'];
  customerRoles: Array<RoleCustomerType>;
  departments: Array<DepartmentType>;
  descriptionOfOperations: Scalars['String']['output'];
  descriptionOfOrganization: Scalars['String']['output'];
  descriptionOfStaff: Scalars['String']['output'];
  documentSet: Array<DocumentType>;
  dueDateWorkplaceAssessment?: Maybe<Scalars['DateTime']['output']>;
  eInvoicingAddress: Scalars['String']['output'];
  eInvoicingOperator: Scalars['String']['output'];
  employeegroupSet: Array<EmployeeGroupType>;
  entrepreneurInsuranceType: OrganizationsCustomerEntrepreneurInsuranceTypeChoices;
  fennoaCustomerNo: Scalars['String']['output'];
  iban: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  idAcute: Scalars['String']['output'];
  industryCode: Scalars['String']['output'];
  industryName: Scalars['String']['output'];
  insurances: Array<InsuranceType>;
  internalNotes?: Maybe<CustomerInternalNotesType>;
  invoicesaleSet: Array<InvoiceSaleType>;
  invoicingAddressCity: Scalars['String']['output'];
  invoicingAddressPostCode: Scalars['String']['output'];
  invoicingAddressStreetAddress: Scalars['String']['output'];
  invoicingContact?: Maybe<ContactPersonType>;
  invoicingEmail: Scalars['String']['output'];
  invoicingMethod: OrganizationsCustomerInvoicingMethodChoices;
  marketingName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  occupationalHealthContact?: Maybe<ContactPersonType>;
  occupationalHealthNeeds: Scalars['String']['output'];
  occupationalSafetyNeeds: Scalars['String']['output'];
  paymentcommitmentpurchaseSet: Array<PaymentCommitmentPurchaseType>;
  phone: Scalars['String']['output'];
  previousInvoiceCreated?: Maybe<Scalars['DateTime']['output']>;
  previousKelaReportFrom?: Maybe<Scalars['Date']['output']>;
  previousKelaReportTo?: Maybe<Scalars['Date']['output']>;
  profileSet: Array<ProfileType>;
  responsibleDoctor?: Maybe<UserType>;
  responsibleNurse?: Maybe<UserType>;
  responsibleTeam?: Maybe<HealthcareTeamType>;
  serviceSettings?: Maybe<CustomerServiceSettingsType>;
  sickLeaveHandlers: Array<SickLeaveHandlerType>;
  sickLeaveSetting?: Maybe<SickLeaveSettingsCustomerType>;
  startDate?: Maybe<Scalars['Date']['output']>;
  taskSet: Array<TaskType>;
  taxFreeBenefitsInstructionsGiven: Scalars['Boolean']['output'];
  usersCustomer: Array<UserType>;
};

export type CustomerUserAccidentInsuranceInfoInput = {
  insuranceCompany?: InputMaybe<Scalars['String']['input']>;
  insuranceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerUserAdditionalInfo = {
  closestSupervisor?: InputMaybe<Scalars['ID']['input']>;
  costCenter?: InputMaybe<Scalars['ID']['input']>;
  department?: InputMaybe<Scalars['ID']['input']>;
  employeeGroupId?: InputMaybe<Scalars['ID']['input']>;
  hasExposure?: InputMaybe<Scalars['Boolean']['input']>;
  isEntrepreneurWithoutHealthcareUsage?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  nextCheckDate?: InputMaybe<Scalars['Date']['input']>;
  previousCheckDate?: InputMaybe<Scalars['Date']['input']>;
  previousCheckUnknown?: InputMaybe<Scalars['Boolean']['input']>;
  supervisorSubstitute?: InputMaybe<Scalars['ID']['input']>;
  supervisorSubstituteEndDate?: InputMaybe<Scalars['Date']['input']>;
  supervisorSubstituteStartDate?: InputMaybe<Scalars['Date']['input']>;
};

export type CustomerUserAmountsType = {
  __typename?: 'CustomerUserAmountsType';
  amountWithExposure: Scalars['Int']['output'];
  amountWithoutExposure: Scalars['Int']['output'];
};

export type CustomerUserContactPersonInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerUserHealthCheckInfo = {
  nextCheckDate?: InputMaybe<Scalars['Date']['input']>;
  previousCheckDate?: InputMaybe<Scalars['Date']['input']>;
  previousCheckUnknown?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomerUserHealthcareServices = {
  benefitsCustomRestrictionReason?: InputMaybe<Scalars['String']['input']>;
  benefitsRestrictedUntil?: InputMaybe<Scalars['Date']['input']>;
  benefitsRestrictionReason?: InputMaybe<Scalars['String']['input']>;
  kelaTwoServicesInUse?: InputMaybe<Scalars['Boolean']['input']>;
  kelaTwoServicesRestrictionReason?: InputMaybe<Scalars['String']['input']>;
  personnelBenefitsInUse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomerUserMedicalInsuranceInfoInput = {
  insuranceCompany?: InputMaybe<Scalars['String']['input']>;
  insuranceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerUserSuborganizationStructure = {
  __typename?: 'CustomerUserSuborganizationStructure';
  customerId: Scalars['ID']['output'];
  directSubordinates: Array<UserOrganizationalStructureInfo>;
  profiles: Array<EmployeeProfileInfoForCustomerUserType>;
  subordinates: Array<UserOrganizationalStructureInfo>;
  user: UserOrganizationalStructureInfo;
  userId: Scalars['ID']['output'];
};

export type CustomersHealthcareSummaryType = {
  __typename?: 'CustomersHealthcareSummaryType';
  accountingPeriodExpiredOrUndefined: Scalars['Int']['output'];
  healthcareTeamNotSpecified: Scalars['Int']['output'];
  kelaReportsNotDone: Scalars['Int']['output'];
  userNextHealthCheckNotScheduled: Scalars['Int']['output'];
  usersPreviousHealthCheckNotClarified: Scalars['Int']['output'];
  workPlaceAssessmentsNotScheduled: Scalars['Int']['output'];
};

/** An enumeration. */
export enum DataTypes {
  FitnessTest = 'FITNESS_TEST',
  InsuranceInvoicing = 'INSURANCE_INVOICING',
  LabResults = 'LAB_RESULTS',
  Other = 'OTHER',
  PaymentCommitment = 'PAYMENT_COMMITMENT'
}

/**
 * The employee declines a pending request to submit the certificate: the task is cancelled.
 * A handler may request again later, and the employee may still submit proactively.
 */
export type DeclineSickLeaveCertificateSubmission = {
  __typename?: 'DeclineSickLeaveCertificateSubmission';
  sickLeaveNotice: SickLeaveNoticeType;
};

export type DeleteActionPlan = {
  __typename?: 'DeleteActionPlan';
  id?: Maybe<Scalars['ID']['output']>;
};

export type DeleteApiToken = {
  __typename?: 'DeleteApiToken';
  id: Scalars['ID']['output'];
};

export type DeleteBranch = {
  __typename?: 'DeleteBranch';
  branchId?: Maybe<Scalars['ID']['output']>;
};

export type DeleteCampaign = {
  __typename?: 'DeleteCampaign';
  campaignId?: Maybe<Scalars['ID']['output']>;
};

export type DeleteCompany = {
  __typename?: 'DeleteCompany';
  id?: Maybe<Scalars['ID']['output']>;
};

export type DeleteCostCenter = {
  __typename?: 'DeleteCostCenter';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCustomer = {
  __typename?: 'DeleteCustomer';
  id?: Maybe<Scalars['ID']['output']>;
};

export type DeleteDocument = {
  __typename?: 'DeleteDocument';
  id?: Maybe<Scalars['ID']['output']>;
};

export type DeleteDocumentCategory = {
  __typename?: 'DeleteDocumentCategory';
  id?: Maybe<Scalars['ID']['output']>;
};

export type DeleteDocumentTemplate = {
  __typename?: 'DeleteDocumentTemplate';
  id?: Maybe<Scalars['ID']['output']>;
};

export type DeleteDocumentTemplateItem = {
  __typename?: 'DeleteDocumentTemplateItem';
  id?: Maybe<Scalars['ID']['output']>;
};

export type DeleteDocumentVersion = {
  __typename?: 'DeleteDocumentVersion';
  id?: Maybe<Scalars['ID']['output']>;
};

export type DeleteEmployeeGroup = {
  __typename?: 'DeleteEmployeeGroup';
  id?: Maybe<Scalars['ID']['output']>;
};

export type DeleteExposure = {
  __typename?: 'DeleteExposure';
  id: Scalars['ID']['output'];
};

export type DeleteFitnessTest = {
  __typename?: 'DeleteFitnessTest';
  fitnessTest?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteFitnessTestDevice = {
  __typename?: 'DeleteFitnessTestDevice';
  id?: Maybe<Scalars['ID']['output']>;
};

export type DeleteHealthCheck = {
  __typename?: 'DeleteHealthCheck';
  id: Scalars['ID']['output'];
};

export type DeleteHealthCheckContentConfiguration = {
  __typename?: 'DeleteHealthCheckContentConfiguration';
  id: Scalars['ID']['output'];
};

export type DeleteHealthcareTeam = {
  __typename?: 'DeleteHealthcareTeam';
  id?: Maybe<Scalars['ID']['output']>;
};

export type DeleteInvoiceInterface = {
  __typename?: 'DeleteInvoiceInterface';
  id?: Maybe<Scalars['ID']['output']>;
};

export type DeleteLaboratoryCatalog = {
  __typename?: 'DeleteLaboratoryCatalog';
  id: Scalars['ID']['output'];
};

export type DeleteLaboratoryOrder = {
  __typename?: 'DeleteLaboratoryOrder';
  laboratoryOrderId?: Maybe<Scalars['ID']['output']>;
};

export type DeleteLaboratorySalesPrice = {
  __typename?: 'DeleteLaboratorySalesPrice';
  id?: Maybe<Scalars['ID']['output']>;
};

export type DeleteLaboratorySupplier = {
  __typename?: 'DeleteLaboratorySupplier';
  id?: Maybe<Scalars['ID']['output']>;
};

export type DeleteMedicalApiToken = {
  __typename?: 'DeleteMedicalApiToken';
  id: Scalars['ID']['output'];
};

export type DeleteMedicalFile = {
  __typename?: 'DeleteMedicalFile';
  ok: Scalars['Boolean']['output'];
};

export type DeleteNode = {
  __typename?: 'DeleteNode';
  id: Scalars['ID']['output'];
};

export type DeleteNorrePackage = {
  __typename?: 'DeleteNorrePackage';
  id?: Maybe<Scalars['ID']['output']>;
};

export type DeletePartner = {
  __typename?: 'DeletePartner';
  id?: Maybe<Scalars['ID']['output']>;
};

export type DeletePaymentCommitment = {
  __typename?: 'DeletePaymentCommitment';
  paymentCommitment?: Maybe<PaymentCommitmentType>;
};

export type DeletePaymentCommitmentPurchase = {
  __typename?: 'DeletePaymentCommitmentPurchase';
  success: Scalars['Boolean']['output'];
};

export type DeleteProcedure = {
  __typename?: 'DeleteProcedure';
  id?: Maybe<Scalars['ID']['output']>;
};

export type DeleteProcedurePartnerPrice = {
  __typename?: 'DeleteProcedurePartnerPrice';
  id?: Maybe<Scalars['ID']['output']>;
};

export type DeleteProfessionalGroup = {
  __typename?: 'DeleteProfessionalGroup';
  id?: Maybe<Scalars['ID']['output']>;
};

export type DeleteProfile = {
  __typename?: 'DeleteProfile';
  deleted?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteReimbursementConversion = {
  __typename?: 'DeleteReimbursementConversion';
  id?: Maybe<Scalars['ID']['output']>;
};

export type DeleteSalesCatalog = {
  __typename?: 'DeleteSalesCatalog';
  id?: Maybe<Scalars['ID']['output']>;
};

export type DeleteSalesInvoiceDraft = {
  __typename?: 'DeleteSalesInvoiceDraft';
  id: Scalars['ID']['output'];
};

export type DeleteSickLeaveCategory = {
  __typename?: 'DeleteSickLeaveCategory';
  id?: Maybe<Scalars['ID']['output']>;
};

export type DeleteSickLeaveHandler = {
  __typename?: 'DeleteSickLeaveHandler';
  id: Scalars['ID']['output'];
  ok: Scalars['Boolean']['output'];
};

/**
 * Deletes a sick leave notice and cleans up any attached certificate (its medical file and
 * submission task). Permission is enforced per object: certificate notices can only be deleted by
 * their creating occupational health user.
 */
export type DeleteSickLeaveNotice = {
  __typename?: 'DeleteSickLeaveNotice';
  id?: Maybe<Scalars['ID']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeleteSickLeavePeriodSetting = {
  __typename?: 'DeleteSickLeavePeriodSetting';
  id?: Maybe<Scalars['ID']['output']>;
};

export type DeleteSickLeaveRecurrentAbsenceThreshold = {
  __typename?: 'DeleteSickLeaveRecurrentAbsenceThreshold';
  id: Scalars['ID']['output'];
};

export type DeleteSickLeaveSelfReportReason = {
  __typename?: 'DeleteSickLeaveSelfReportReason';
  id?: Maybe<Scalars['ID']['output']>;
};

export type DeleteSupplierPackage = {
  __typename?: 'DeleteSupplierPackage';
  id?: Maybe<Scalars['ID']['output']>;
};

export type DeleteTitleTemplate = {
  __typename?: 'DeleteTitleTemplate';
  titleTemplateId?: Maybe<Scalars['ID']['output']>;
};

export type DeleteTree = {
  __typename?: 'DeleteTree';
  treeId?: Maybe<Scalars['ID']['output']>;
};

/**
 * Manually removes an unmatched booking the nurse does not want to link.
 *
 * Permission (owning nurse or sync) is enforced automatically by delete().
 */
export type DeleteUnmatchedCalendarBooking = {
  __typename?: 'DeleteUnmatchedCalendarBooking';
  id: Scalars['ID']['output'];
};

export type DeleteUser = {
  __typename?: 'DeleteUser';
  userId?: Maybe<Scalars['ID']['output']>;
};

export type DeleteView = {
  __typename?: 'DeleteView';
  id: Scalars['ID']['output'];
};

export type DepartmentType = {
  __typename?: 'DepartmentType';
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<CustomerType>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  userSet: Array<UserType>;
};

/** An enumeration. */
export enum DeviceTypes {
  BodyComposition = 'BODY_COMPOSITION',
  FitnessTest = 'FITNESS_TEST'
}

export type DiscountType = {
  __typename?: 'DiscountType';
  discountType: SalescatalogsDiscountDiscountTypeChoices;
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  percent: Scalars['Decimal']['output'];
  salesContractVersionPrice: SalesContractVersionPricesType;
};

export type DiscountsInputType = {
  discountDurationBase?: InputMaybe<Scalars['Int']['input']>;
  discountDurationExtraServices?: InputMaybe<Scalars['Int']['input']>;
  discountDurationHealthCareReception?: InputMaybe<Scalars['Int']['input']>;
  discountPercentBase?: InputMaybe<Scalars['Decimal']['input']>;
  discountPercentExtraServices?: InputMaybe<Scalars['Decimal']['input']>;
  discountPercentHealthCareReception?: InputMaybe<Scalars['Decimal']['input']>;
};

/** Value belongs to codesystem 1.2.246.537.5.40123 values. */
export type DispenseStatus = {
  __typename?: 'DispenseStatus';
  code: Scalars['String']['output'];
  codeSystem?: Maybe<CodeSystemType>;
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
};

export type DocumentCategoryType = {
  __typename?: 'DocumentCategoryType';
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  documentCategoryParent?: Maybe<DocumentCategoryType>;
  documentSet: Array<DocumentType>;
  documentcategorySet: Array<DocumentCategoryType>;
  hideOldVersions: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  showForCustomerUsers: Scalars['Boolean']['output'];
  showForCustomers: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: DocumentsDocumentCategoryTypeChoices;
};

export type DocumentTemplateItemType = {
  __typename?: 'DocumentTemplateItemType';
  condition?: Maybe<StatementGroupType>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  template?: Maybe<DocumentTemplateType>;
  type: DocumenttemplatesDocumentTemplateItemTypeChoices;
  value: Scalars['String']['output'];
};

export type DocumentTemplateType = {
  __typename?: 'DocumentTemplateType';
  campaigns: Array<CampaignType>;
  createdAt: Scalars['DateTime']['output'];
  documentTemplateItems: Array<DocumentTemplateItemType>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  treeIds: Array<TreeType>;
};

export type DocumentType = {
  __typename?: 'DocumentType';
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<CustomerType>;
  documentCategory: DocumentCategoryType;
  documentversionSet: Array<DocumentVersionType>;
  id: Scalars['ID']['output'];
  periodFrom?: Maybe<Scalars['Date']['output']>;
  periodTo?: Maybe<Scalars['Date']['output']>;
  title: Scalars['String']['output'];
  user?: Maybe<UserType>;
};

export type DocumentVersionType = {
  __typename?: 'DocumentVersionType';
  createdAt: Scalars['DateTime']['output'];
  createdBy: UserType;
  document: DocumentType;
  file: Scalars['String']['output'];
  fileThumbnail: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  versionNumber: Scalars['Int']['output'];
};

/** An enumeration. */
export enum DocumentsDocumentCategoryTypeChoices {
  /** Sv98Tth */
  Sv98Tth = 'SV98TTH',
  /** Upload */
  Upload = 'UPLOAD'
}

/** An enumeration. */
export enum DocumenttemplatesDocumentTemplateItemTypeChoices {
  /** Header */
  A_1 = 'A_1',
  /** Text */
  A_2 = 'A_2',
  /** Table */
  A_3 = 'A_3'
}

/** Value belongs to codesystem 1.2.246.537.6.138 values. */
export type DoseUnit = {
  __typename?: 'DoseUnit';
  code: Scalars['String']['output'];
  codeSystem?: Maybe<CodeSystemType>;
  displayName: Scalars['String']['output'];
};

export type DrugContainerType = {
  __typename?: 'DrugContainerType';
  code: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** Value belongs to codesystem 1.2.246.537.5.40183 values. */
export type DrugExchangeProhibitionReasonType = {
  __typename?: 'DrugExchangeProhibitionReasonType';
  code: Scalars['String']['output'];
  codeSystem?: Maybe<CodeSystemType>;
  displayName: Scalars['String']['output'];
};

export type DrugPackageDetailsState = {
  __typename?: 'DrugPackageDetailsState';
  /** Specifies drug amount in package or package size. */
  quantity: Scalars['Float']['output'];
  /** Specifies unit for drug quantity. */
  unit: Scalars['String']['output'];
};

export type DrugPackageInfo = {
  __typename?: 'DrugPackageInfo';
  asText?: Maybe<Scalars['String']['output']>;
  multiplier?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type DrugRegisterExternalPrescriptionCreationArguments = {
  /** Name of medicinal product */
  productName: Scalars['String']['input'];
  /** Type of medicinal product, the value belongs to codeserver 1.2.246.537.6.604 codes. */
  productType: Scalars['String']['input'];
};

/** An enumeration. */
export enum DrugRegisterInternalMedicineAssign {
  ByActiveIngredient = 'BY_ACTIVE_INGREDIENT',
  ByTradeName = 'BY_TRADE_NAME'
}

export type DrugRegisterInternalPrescriptionCreationArguments = {
  /** If assigned medicine is biological medicine and there is similar alternative medicines that are cheaper, doctor should/can write an argument of using not the cheapest one. */
  argumentToNotUseCheapestBiologicalMedicine?: InputMaybe<Scalars['String']['input']>;
  /** If assigned by active ingderient, no detailed drug package is defined, but instead only the active ingredient of the selected package is defined */
  assignBy: DrugRegisterInternalMedicineAssign;
  /** Specifies drug package id in drug register */
  packageId: Scalars['Int']['input'];
  /** Special clarification. Doctor should be asked for special clarification if selected medicine have one. */
  specialClarification?: InputMaybe<SpecialClarificationInput>;
};

export type DrugRelatedCodeSystems = {
  __typename?: 'DrugRelatedCodeSystems';
  ATC?: Maybe<CodeSystemType>;
  PKV?: Maybe<CodeSystemType>;
  VNR?: Maybe<CodeSystemType>;
  careStage?: Maybe<CodeSystemType>;
  caringType?: Maybe<CodeSystemType>;
  container?: Maybe<CodeSystemType>;
  drugs?: Maybe<CodeSystemType>;
  finLoinc?: Maybe<CodeSystemType>;
  gender?: Maybe<CodeSystemType>;
  header?: Maybe<CodeSystemType>;
  medicineType?: Maybe<CodeSystemType>;
  prescriptionType?: Maybe<CodeSystemType>;
  technicalStructures?: Maybe<CodeSystemType>;
  typeOfCaring?: Maybe<CodeSystemType>;
  view?: Maybe<CodeSystemType>;
};

export type DrugTextType = {
  __typename?: 'DrugTextType';
  doseMultiplier?: Maybe<Scalars['String']['output']>;
  doseNumber?: Maybe<Scalars['String']['output']>;
  doseTimePeriod?: Maybe<Scalars['String']['output']>;
  doseType?: Maybe<Scalars['String']['output']>;
  guide?: Maybe<Scalars['String']['output']>;
  info?: Maybe<Scalars['String']['output']>;
  ingredientTypeName?: Maybe<Scalars['String']['output']>;
  langCode?: Maybe<Scalars['String']['output']>;
  packageAdditionalInfo?: Maybe<Scalars['String']['output']>;
};

/** Medicine from medicine database provided by Multirec Oy. */
export type DrugType = {
  __typename?: 'DrugType';
  ALV?: Maybe<Scalars['String']['output']>;
  ATC?: Maybe<AtcType>;
  KELAId?: Maybe<Scalars['Int']['output']>;
  KELAIdType?: Maybe<Scalars['String']['output']>;
  PKV?: Maybe<PkvType>;
  VNR?: Maybe<Scalars['String']['output']>;
  activeIngredient?: Maybe<Array<Maybe<ActiveIngredientType>>>;
  availabilityFailure?: Maybe<AvailabilityFailure>;
  biologicalMedicine?: Maybe<ToBeOrNotToBe>;
  biologicalMedicineGroups: Array<Scalars['String']['output']>;
  biosimilar?: Maybe<ToBeOrNotToBe>;
  bloodAndPlasmaDerivedProduct?: Maybe<ToBeOrNotToBe>;
  codeSystems?: Maybe<DrugRelatedCodeSystems>;
  container?: Maybe<DrugContainerType>;
  containerCode?: Maybe<Scalars['String']['output']>;
  dosageUnit?: Maybe<DoseUnit>;
  drugExchange: Scalars['Boolean']['output'];
  drugKey: Scalars['Int']['output'];
  drugTexts?: Maybe<Array<Maybe<DrugTextType>>>;
  drugType?: Maybe<MedicinalProductType>;
  ingredientText?: Maybe<Scalars['String']['output']>;
  ingredientType?: Maybe<IngredientGraphQlType>;
  intensity?: Maybe<Scalars['String']['output']>;
  marketer?: Maybe<Scalars['String']['output']>;
  marketingAuthorizationName?: Maybe<Scalars['String']['output']>;
  nacrotic?: Maybe<Scalars['String']['output']>;
  officialConfirmedTradePrice?: Maybe<Scalars['String']['output']>;
  packageId: Scalars['Int']['output'];
  packageMultiplier?: Maybe<Scalars['Decimal']['output']>;
  packageSize?: Maybe<Scalars['Decimal']['output']>;
  packageText?: Maybe<Scalars['String']['output']>;
  packageUnit?: Maybe<Scalars['String']['output']>;
  pharmaceuticalForm?: Maybe<Scalars['String']['output']>;
  priceWithTaxes?: Maybe<Scalars['String']['output']>;
  priceWithoutTaxes?: Maybe<Scalars['String']['output']>;
  restrictedPrivileges?: Maybe<RestrictedPrivilege>;
  specialClarifications?: Maybe<Array<Maybe<SpecialClarificationInfo>>>;
  substituteDrugPackagesCode?: Maybe<Scalars['String']['output']>;
  substituteMedicinesCode?: Maybe<Scalars['String']['output']>;
  tradeName: Scalars['String']['output'];
  tradePrice?: Maybe<Scalars['String']['output']>;
  trafficHazard?: Maybe<Scalars['String']['output']>;
  underAdditionalMonitoring?: Maybe<ToBeOrNotToBe>;
  vaccineAbbreviation?: Maybe<Scalars['String']['output']>;
};

export type EducationOutput = {
  __typename?: 'EducationOutput';
  code: Scalars['String']['output'];
  examinationDate?: Maybe<Scalars['DateTime']['output']>;
};

/** Value belongs to codesystem 1.2.246.537.6.148 values. */
export type EducationType = {
  __typename?: 'EducationType';
  code: Scalars['String']['output'];
  codeSystem?: Maybe<CodeSystemType>;
  displayName: Scalars['String']['output'];
  examination?: Maybe<Scalars['String']['output']>;
  public: Scalars['Boolean']['output'];
  specification?: Maybe<Scalars['String']['output']>;
};

/**
 * Payload of the anonymous notification-settings operations behind the emailed link.
 *
 * Plain ObjectType on purpose: served without an authenticated user (the token is the
 * authorization), so it must not run the model type's per-field view checks and carries only
 * the switch values. `ok` is false for an unknown token and every switch is then null.
 */
export type EmailNotificationSettingsByTokenPayload = {
  __typename?: 'EmailNotificationSettingsByTokenPayload';
  emailSickLeaveCertificateSubmissionRequest?: Maybe<Scalars['Boolean']['output']>;
  emailSickLeaveCertificateSubmitted?: Maybe<Scalars['Boolean']['output']>;
  emailSickLeaveNoticeCreated?: Maybe<Scalars['Boolean']['output']>;
  emailSickLeaveNoticeDecision?: Maybe<Scalars['Boolean']['output']>;
  emailSickLeaveNoticePendingApproval?: Maybe<Scalars['Boolean']['output']>;
  emailSickLeaveNoticePendingHandling?: Maybe<Scalars['Boolean']['output']>;
  emailSickLeaveRecurrentAbsenceThreshold?: Maybe<Scalars['Boolean']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EmployeeForCustomerUserType = {
  __typename?: 'EmployeeForCustomerUserType';
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employeeGroupId?: Maybe<Scalars['ID']['output']>;
  employeeGroupName?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  hasExposure: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isActiveEmployee: Scalars['Boolean']['output'];
  isSupervisor: Scalars['Boolean']['output'];
  jobTitle: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  nationalIdKnown: Scalars['Boolean']['output'];
  phoneNumber: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type EmployeeGroupType = {
  __typename?: 'EmployeeGroupType';
  createdAt: Scalars['DateTime']['output'];
  customer: CustomerType;
  exposures: Array<ExposureType>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  userSet: Array<UserType>;
};

export type EmployeeHealthCheckStatuses = {
  __typename?: 'EmployeeHealthCheckStatuses';
  clarifiedNotKnownHealthChecks: Array<Maybe<HealthCheckBasicInformation>>;
  completedHealthChecks: Array<HealthCheckBasicInformation>;
  id: Scalars['ID']['output'];
  plannedHealthChecks: Array<Maybe<HealthCheckBasicInformation>>;
};

export type EmployeeInternalNotesType = {
  __typename?: 'EmployeeInternalNotesType';
  id: Scalars['ID']['output'];
  nursing: Scalars['String']['output'];
  occupationalHealthCare: Scalars['String']['output'];
  sales: Scalars['String']['output'];
  user: UserType;
};

export type EmployeeProfileInfoForCustomerUserType = {
  __typename?: 'EmployeeProfileInfoForCustomerUserType';
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  profileId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type EndCampaign = {
  __typename?: 'EndCampaign';
  campaign?: Maybe<CampaignType>;
};

/** An enumeration. */
export enum EntrepreneurInsuranceType {
  Myel = 'MYEL',
  Yel = 'YEL'
}

export type ErrorOrReimbursementConversion = {
  __typename?: 'ErrorOrReimbursementConversion';
  error?: Maybe<Scalars['String']['output']>;
  isCreated: Scalars['Boolean']['output'];
  reimbursementConversion?: Maybe<ReimbursementConversionType>;
};

export type ExposureInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  healthCheckConfigs: Array<HealthCheckConfigurationInput>;
  name: Scalars['String']['input'];
};

export type ExposureType = {
  __typename?: 'ExposureType';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  healthCheckConfigs: Array<HealthCheckConfigurationType>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ExtemporePrescriptionCreationArguments = {
  /** Describes ingredients for prepared custom mixture. */
  ingredients: Array<InputMaybe<IngredientInput>>;
  /** Specifies custom mixture name. */
  mixtureName: Scalars['String']['input'];
  /** Describes guidance for preparing custom mixture. */
  preparationGuide: Scalars['String']['input'];
};

/** Value belongs to codesystem 1.2.246.537.6.96 values. */
export type FinLoincType = {
  __typename?: 'FinLoincType';
  OID?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  codeSystem?: Maybe<CodeSystemType>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionEn?: Maybe<Scalars['String']['output']>;
  descriptionSwe?: Maybe<Scalars['String']['output']>;
  hierarchy?: Maybe<Scalars['String']['output']>;
  leafKnot?: Maybe<Scalars['Boolean']['output']>;
  longName?: Maybe<Scalars['String']['output']>;
  longNameEn?: Maybe<Scalars['String']['output']>;
  longNameSwe?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  physiologicalGrouping?: Maybe<Scalars['String']['output']>;
  questionkey?: Maybe<QuestionKeyOutputType>;
  replacementCode?: Maybe<Scalars['String']['output']>;
  shortName: Scalars['String']['output'];
  toSummaryScreen?: Maybe<Scalars['Boolean']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type FitnessDeviceResultInfo = {
  absoluteOxygenUptakeCapacity?: InputMaybe<Scalars['Decimal']['input']>;
  deviceId?: InputMaybe<Scalars['Int']['input']>;
  relativeOxygenUptakeCapacity?: InputMaybe<Scalars['Decimal']['input']>;
  targetHeartRate?: InputMaybe<Scalars['Int']['input']>;
};

export type FitnessDeviceResultType = {
  __typename?: 'FitnessDeviceResultType';
  absoluteOxygenUptakeCapacity: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  deviceId: Scalars['Int']['output'];
  fitnessTest: FitnessTestType;
  fitnessTestDevice?: Maybe<FitnessTestDeviceType>;
  id: Scalars['ID']['output'];
  relativeOxygenUptakeCapacity: Scalars['Decimal']['output'];
  targetHeartRate: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FitnessTestDeviceType = {
  __typename?: 'FitnessTestDeviceType';
  createdAt: Scalars['DateTime']['output'];
  deviceType: FitnesstestsFitnessTestDeviceDeviceTypeChoices;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type FitnessTestType = {
  __typename?: 'FitnessTestType';
  bodycompositionmeasurementresult?: Maybe<BodyCompositionMeasurementResultType>;
  fitnessdeviceresult?: Maybe<FitnessDeviceResultType>;
  id: Scalars['ID']['output'];
  patient: PatientType;
  patientUser?: Maybe<MedicalUserType>;
  testDate: Scalars['Date']['output'];
};

/** An enumeration. */
export enum FitnesstestsFitnessTestDeviceDeviceTypeChoices {
  /** Body composition */
  BodyComposition = 'BODY_COMPOSITION',
  /** Fitness test */
  FitnessTest = 'FITNESS_TEST'
}

export type FollowUpMeasuresType = {
  __typename?: 'FollowUpMeasuresType';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  task: TaskType;
};

export type Functionality = {
  __typename?: 'Functionality';
  companies: Array<UserRoleCompanyBaseInfo>;
  customers: Array<UserRoleCustomerBaseInfo>;
  isHealthcareWorker: Scalars['Boolean']['output'];
  isSupplier: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  perms: Array<Scalars['String']['output']>;
  primaryUi: ViewViewTypeChoices;
  showCorporateAdminViews: Scalars['Boolean']['output'];
  showCustomerAdminViews: Scalars['Boolean']['output'];
  showHealthcareWorkerViews: Scalars['Boolean']['output'];
  showRegionalAdminViews: Scalars['Boolean']['output'];
  showSupplierViews: Scalars['Boolean']['output'];
};

export enum GenderInputType {
  Female = 'FEMALE',
  Male = 'MALE',
  Undefined = 'UNDEFINED',
  Unknown = 'UNKNOWN'
}

/** Value belongs to codesystem 1.2.246.537.5.1 values. */
export type GenderType = {
  __typename?: 'GenderType';
  code: Scalars['String']['output'];
  codeSystem?: Maybe<CodeSystemType>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
};

export type GetDigestsForMultiSignature = {
  __typename?: 'GetDigestsForMultiSignature';
  /** Digest OID-pairs of the documents to be added to multi-signature. */
  documentDigests: Array<Maybe<OidDigestPair>>;
};

export type GetPdfFormSv98Tth = {
  __typename?: 'GetPdfFormSv98Tth';
  url: Scalars['String']['output'];
};

export type GrantSuitabilityStatementEmployerView = {
  __typename?: 'GrantSuitabilityStatementEmployerView';
  suitabilityStatement: SuitabilityStatementType;
};

export type HandleSickLeaveNotice = {
  __typename?: 'HandleSickLeaveNotice';
  sickLeaveNotice?: Maybe<SickLeaveNoticeType>;
};

/** Value belongs to codesystem 1.2.246.537.6.14 values. */
export type HeaderType = {
  __typename?: 'HeaderType';
  OID?: Maybe<Scalars['String']['output']>;
  carestage?: Maybe<CareStageType>;
  code: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  orderNumber?: Maybe<Scalars['String']['output']>;
};

export type HealthCheckBasicInformation = {
  __typename?: 'HealthCheckBasicInformation';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  contents: Array<Scalars['ID']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  implementationMethod?: Maybe<HealthCheckImplementationMethod>;
  invitationCount: Scalars['Int']['output'];
  invitations: Array<HealthCheckInvitationInfo>;
  status: HealthCheckStatus;
  userCustomerId: Scalars['ID']['output'];
  userEmail?: Maybe<Scalars['String']['output']>;
  userFirstName: Scalars['String']['output'];
  userHasExposure: Scalars['Boolean']['output'];
  userId: Scalars['ID']['output'];
  userJobTitle: Scalars['String']['output'];
  userLastName: Scalars['String']['output'];
  userPhoneNumber: Scalars['String']['output'];
  userPhoneNumberJob: Scalars['String']['output'];
};

export type HealthCheckBookingSettingsType = {
  __typename?: 'HealthCheckBookingSettingsType';
  bookingPageUrl: Scalars['String']['output'];
  calendarId: Scalars['String']['output'];
  calendarLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  calendarSyncError: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type HealthCheckConfigurationInput = {
  appliesAfterAge?: InputMaybe<Scalars['Int']['input']>;
  appliesBeforeAge?: InputMaybe<Scalars['Int']['input']>;
  checkType: HealthCheckTypeChoices;
  checkupLength: CheckupLengthChoices;
  checkupType: CheckupTypeChoices;
  contentDescription: Scalars['String']['input'];
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  intervalYears?: InputMaybe<Scalars['Int']['input']>;
  laboratory: LaboratoryChoices;
  laboratoryTestsNordlab?: InputMaybe<Scalars['String']['input']>;
  laboratoryTestsSynlab?: InputMaybe<Scalars['String']['input']>;
  reasonOrGoal: Scalars['String']['input'];
  triggerAge?: InputMaybe<Scalars['Int']['input']>;
  useSameTestsForBoth?: InputMaybe<Scalars['Boolean']['input']>;
  zefQuestionnaireLink?: InputMaybe<Scalars['String']['input']>;
};

export type HealthCheckConfigurationType = {
  __typename?: 'HealthCheckConfigurationType';
  appliesAfterAge?: Maybe<Scalars['Int']['output']>;
  appliesBeforeAge?: Maybe<Scalars['Int']['output']>;
  checkType: HealthCheckTypeChoices;
  checkupLength: CheckupLengthChoices;
  checkupType: CheckupTypeChoices;
  contentDescription: Scalars['String']['output'];
  displayOrder: Scalars['Int']['output'];
  exposure: ExposureType;
  id: Scalars['ID']['output'];
  intervalYears?: Maybe<Scalars['Int']['output']>;
  laboratory: LaboratoryChoices;
  laboratoryTestsNordlab: Scalars['String']['output'];
  laboratoryTestsSynlab: Scalars['String']['output'];
  reasonOrGoal: Scalars['String']['output'];
  triggerAge?: Maybe<Scalars['Int']['output']>;
  useSameTestsForBoth: Scalars['Boolean']['output'];
  zefQuestionnaireLink?: Maybe<Scalars['String']['output']>;
};

export type HealthCheckContentConfigurationType = {
  __typename?: 'HealthCheckContentConfigurationType';
  /** Enter a color in hex format, like #RRGGBB. */
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

/** An enumeration. */
export enum HealthCheckImplementationMethod {
  Questionnaire = 'QUESTIONNAIRE',
  Reception = 'RECEPTION',
  ReceptionAtTheCustomerPremises = 'RECEPTION_AT_THE_CUSTOMER_PREMISES',
  RemoteReception = 'REMOTE_RECEPTION'
}

export type HealthCheckInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contents?: InputMaybe<Array<Scalars['ID']['input']>>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  implementationMethod?: InputMaybe<HealthCheckImplementationMethod>;
  userId: Scalars['ID']['input'];
};

/** An enumeration. */
export enum HealthCheckInvitationFilter {
  Invitable = 'INVITABLE',
  MaxReached = 'MAX_REACHED'
}

export type HealthCheckInvitationInfo = {
  __typename?: 'HealthCheckInvitationInfo';
  appointmentEnd?: Maybe<Scalars['DateTime']['output']>;
  appointmentStart?: Maybe<Scalars['DateTime']['output']>;
  bookedAt?: Maybe<Scalars['DateTime']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  manualBooking: Scalars['Boolean']['output'];
  matchMethod?: Maybe<HealthCheckInvitationMatchMethod>;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  reference: Scalars['String']['output'];
  sentAt: Scalars['DateTime']['output'];
};

/** An enumeration. */
export enum HealthCheckInvitationMatchMethod {
  Email = 'EMAIL',
  Manual = 'MANUAL',
  Name = 'NAME',
  Phone = 'PHONE'
}

/** An enumeration. */
export enum HealthCheckStatus {
  Completed = 'COMPLETED',
  NeverDone = 'NEVER_DONE',
  Planned = 'PLANNED',
  Unclarified = 'UNCLARIFIED'
}

/** An enumeration. */
export enum HealthCheckTypeChoices {
  AgeBased = 'AGE_BASED',
  Initial = 'INITIAL',
  Periodic = 'PERIODIC'
}

/**
 * Aggregate type, no direct model — the query resolver only passes the parameters through;
 * every field resolver verifies the company view permission before computing the figures.
 */
export type HealthCheckWorkQueueSummary = {
  __typename?: 'HealthCheckWorkQueueSummary';
  accruedWorkLiabilityEuros: Scalars['Decimal']['output'];
  scheduledAmountForNextMonth: Scalars['Int']['output'];
  uncompletedAmount: Scalars['Int']['output'];
  unscheduledAmount: Scalars['Int']['output'];
};

export type HealthcareTeamType = {
  __typename?: 'HealthcareTeamType';
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  description: Scalars['String']['output'];
  healthcareWorkers: Array<UserType>;
  id: Scalars['ID']['output'];
  responsibleTeamCustomers: Array<CustomerType>;
  taskSet: Array<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<UserType>;
};

export type HealthcareWorkerAdditionalInfo = {
  healthcareTeamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  professionalGroupId?: InputMaybe<Scalars['ID']['input']>;
};

/** Value belongs to codesystem 1.2.246.537.6.1 values. */
export type Icd10Type = {
  __typename?: 'ICD10Type';
  OID?: Maybe<Scalars['String']['output']>;
  abbreviation: Scalars['String']['output'];
  anm?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  codeFirstPart?: Maybe<Scalars['String']['output']>;
  codeSecondPart?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionEn?: Maybe<Scalars['String']['output']>;
  descriptionSwe?: Maybe<Scalars['String']['output']>;
  excludes?: Maybe<Scalars['String']['output']>;
  excludesSwe?: Maybe<Scalars['String']['output']>;
  hierarchy?: Maybe<Scalars['String']['output']>;
  icpcCode?: Maybe<Scalars['String']['output']>;
  includes?: Maybe<Scalars['String']['output']>;
  includesSwe?: Maybe<Scalars['String']['output']>;
  info?: Maybe<Scalars['String']['output']>;
  joiningMark?: Maybe<Scalars['String']['output']>;
  latinName?: Maybe<Scalars['String']['output']>;
  leafKnot?: Maybe<Scalars['Boolean']['output']>;
  longName?: Maybe<Scalars['String']['output']>;
  longNameEn?: Maybe<Scalars['String']['output']>;
  longNameSwe?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  persistence?: Maybe<Scalars['String']['output']>;
  primaryIcpcMen?: Maybe<Scalars['String']['output']>;
  primaryIcpcWomen?: Maybe<Scalars['String']['output']>;
  psychiatry?: Maybe<Scalars['Boolean']['output']>;
  questionkey?: Maybe<QuestionKeyOutputType>;
  replacementCode?: Maybe<Scalars['String']['output']>;
  riskLevel?: Maybe<Scalars['String']['output']>;
  riskPersistence?: Maybe<Scalars['String']['output']>;
  riskType?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  sickLeaveCategories: Array<SickLeaveCategoryType>;
  sickLeaveCertificates: Array<SickLeaveCertificateType>;
  sickleavecategoryicd10?: Maybe<SickLeaveCategoryIcd10Type>;
};

/** Result of importing a single row. */
export type ImportPaymentCommitmentResultType = {
  __typename?: 'ImportPaymentCommitmentResultType';
  message: Scalars['String']['output'];
  paymentCommitmentId?: Maybe<Scalars['ID']['output']>;
  rowNum: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

/** Import payment commitments from an Excel file. */
export type ImportPaymentCommitmentsFromExcel = {
  __typename?: 'ImportPaymentCommitmentsFromExcel';
  errorCount: Scalars['Int']['output'];
  results: Array<ImportPaymentCommitmentResultType>;
  successCount: Scalars['Int']['output'];
};

export type IngredientGraphQlType = {
  __typename?: 'IngredientGraphQLType';
  code: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type IngredientInput = {
  atcCode?: InputMaybe<Scalars['String']['input']>;
  freeText?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Float']['input'];
  unit: Scalars['String']['input'];
};

export type IngredientOutput = {
  __typename?: 'IngredientOutput';
  atcCode?: Maybe<Scalars['String']['output']>;
  freeText?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
  unit: Scalars['String']['output'];
};

export type InsertTempField = {
  __typename?: 'InsertTempField';
  id?: Maybe<Scalars['ID']['output']>;
};

export type InsuranceCompanyType = {
  __typename?: 'InsuranceCompanyType';
  businessId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  instructions: Scalars['String']['output'];
  insuranceSet: Array<InsuranceType>;
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type InsuranceInputType = {
  description?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  insuranceCompanyId?: InputMaybe<Scalars['ID']['input']>;
  insuranceNumber?: InputMaybe<Scalars['String']['input']>;
  insuranceType: InsuranceTypeChoices;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type InsuranceType = {
  __typename?: 'InsuranceType';
  customer?: Maybe<CustomerType>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  instructions: Scalars['String']['output'];
  insuranceCompany?: Maybe<InsuranceCompanyType>;
  insuranceNumber: Scalars['String']['output'];
  insuranceType: InsurancesInsuranceInsuranceTypeChoices;
  url: Scalars['String']['output'];
  user?: Maybe<UserType>;
};

/** An enumeration. */
export enum InsuranceTypeChoices {
  Accident = 'ACCIDENT',
  AccidentWork = 'ACCIDENT_WORK',
  EmploymentPension = 'EMPLOYMENT_PENSION',
  MedicalExpense = 'MEDICAL_EXPENSE'
}

/** An enumeration. */
export enum InsurancesInsuranceInsuranceTypeChoices {
  /** Accident */
  Accident = 'ACCIDENT',
  /** Accident Work */
  AccidentWork = 'ACCIDENT_WORK',
  /** Employment Pension */
  EmploymentPension = 'EMPLOYMENT_PENSION',
  /** Medical Expense */
  MedicalExpense = 'MEDICAL_EXPENSE'
}

export type InvoiceInterfaceType = {
  __typename?: 'InvoiceInterfaceType';
  apiKey: Scalars['String']['output'];
  apiUser: Scalars['String']['output'];
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
};

export type InvoicePurchaseAttachmentType = {
  __typename?: 'InvoicePurchaseAttachmentType';
  createdAt: Scalars['DateTime']['output'];
  data: Scalars['String']['output'];
  file: Scalars['String']['output'];
  filesize: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  idRemote: Scalars['String']['output'];
  invoicePurchase: InvoicePurchaseType;
  mimetype: Scalars['String']['output'];
};

export type InvoicePurchaseCommentType = {
  __typename?: 'InvoicePurchaseCommentType';
  comment: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invoicePurchase: InvoicePurchaseType;
  stateNew?: Maybe<InvoicesInvoicePurchaseCommentStateNewChoices>;
  user: UserType;
  userOwner?: Maybe<UserType>;
  variant: InvoicesInvoicePurchaseCommentVariantChoices;
};

export type InvoicePurchaseRowType = {
  __typename?: 'InvoicePurchaseRowType';
  articleIdentifier: Scalars['String']['output'];
  articleName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  discountPercent?: Maybe<Scalars['Decimal']['output']>;
  discountValue?: Maybe<Scalars['Decimal']['output']>;
  freetext: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ignoredInSales: Scalars['Boolean']['output'];
  invoicePurchase: InvoicePurchaseType;
  invoiceSaleRow?: Maybe<InvoiceSaleRowType>;
  quantity: Scalars['Decimal']['output'];
  sumGross: Scalars['Decimal']['output'];
  sumGrossOverride?: Maybe<Scalars['Decimal']['output']>;
  sumNet: Scalars['Decimal']['output'];
  unit: Scalars['String']['output'];
  unitPrice: Scalars['Decimal']['output'];
  vatpercent: Scalars['Decimal']['output'];
};

/** An enumeration. */
export enum InvoicePurchaseState {
  Approved = 'APPROVED',
  Invalid = 'INVALID',
  New = 'NEW',
  Ok = 'OK',
  Rejected = 'REJECTED'
}

export type InvoicePurchaseType = {
  __typename?: 'InvoicePurchaseType';
  adjustedGrossSum: Scalars['Decimal']['output'];
  approvalIdRemote: Scalars['String']['output'];
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  bankAccount: Scalars['String']['output'];
  bankBic: Scalars['String']['output'];
  bankMessage: Scalars['String']['output'];
  bankReference: Scalars['String']['output'];
  company: CompanyType;
  costSettingsCategory?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  currencyRate: Scalars['Decimal']['output'];
  dueDate: Scalars['Date']['output'];
  entryDate: Scalars['Date']['output'];
  finvoiceAvailable: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  idRemote: Scalars['String']['output'];
  information: Scalars['String']['output'];
  invoiceDate: Scalars['Date']['output'];
  invoiceNumber: Scalars['String']['output'];
  invoicepurchaseattachmentSet: Array<InvoicePurchaseAttachmentType>;
  invoicepurchasecommentSet: Array<InvoicePurchaseCommentType>;
  invoicepurchaserowSet: Array<InvoicePurchaseRowType>;
  isFirstInvoice: Scalars['Boolean']['output'];
  isReceipt: Scalars['Boolean']['output'];
  orderNumber: Scalars['String']['output'];
  ourReference: Scalars['String']['output'];
  state: InvoicesInvoicePurchaseStateChoices;
  supplierBusinessId: Scalars['String']['output'];
  supplierName: Scalars['String']['output'];
  termsOfPayment: Scalars['String']['output'];
  totalGross: Scalars['Decimal']['output'];
  totalNet: Scalars['Decimal']['output'];
  user?: Maybe<UserType>;
  yourReference: Scalars['String']['output'];
};

export type InvoiceSaleRowType = {
  __typename?: 'InvoiceSaleRowType';
  billingPeriods: Array<BillingPeriodInvoiceRowType>;
  costCenterRows: Array<CostCenterInvoiceRowType>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  discountPercent: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  invoiceSale: InvoiceSaleType;
  invoicepurchaserowSet: Array<InvoicePurchaseRowType>;
  laboratoryEvents: Array<LaboratoryEventSalesInvoiceRowType>;
  name: Scalars['String']['output'];
  paymentCommitments: Array<PaymentCommitmentSalesInvoiceRowType>;
  quantity: Scalars['Decimal']['output'];
  remoteProductId: Scalars['String']['output'];
  startUpCosts: Array<StartUpCostsInvoiceRowType>;
  totalPrice: Scalars['Decimal']['output'];
  unit: Scalars['String']['output'];
  unitPrice: Scalars['Decimal']['output'];
  vat?: Maybe<Scalars['Decimal']['output']>;
};

export type InvoiceSaleType = {
  __typename?: 'InvoiceSaleType';
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customer: CustomerType;
  id: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
  invoicesalerowSet: Array<InvoiceSaleRowType>;
  manualActualNet?: Maybe<Scalars['Decimal']['output']>;
  manualHandlingReason: Scalars['String']['output'];
  manuallyHandledAt?: Maybe<Scalars['DateTime']['output']>;
  manuallyHandledBy?: Maybe<UserType>;
  notesBefore: Scalars['String']['output'];
  remoteId: Scalars['Int']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  shippingDate: Scalars['Date']['output'];
};

/** An enumeration. */
export enum InvoicesInvoicePurchaseCommentStateNewChoices {
  /** Approved */
  Approved = 'APPROVED',
  /** Invalid */
  Invalid = 'INVALID',
  /** New */
  New = 'NEW',
  /** Ok */
  Ok = 'OK',
  /** Rejected */
  Rejected = 'REJECTED'
}

/** An enumeration. */
export enum InvoicesInvoicePurchaseCommentVariantChoices {
  /** Message */
  Message = 'MESSAGE',
  /** Owner */
  Owner = 'OWNER',
  /** State */
  State = 'STATE'
}

/** An enumeration. */
export enum InvoicesInvoicePurchaseStateChoices {
  /** Approved */
  Approved = 'APPROVED',
  /** Invalid */
  Invalid = 'INVALID',
  /** New */
  New = 'NEW',
  /** Ok */
  Ok = 'OK',
  /** Rejected */
  Rejected = 'REJECTED'
}

export type InvoicingBaseInfoInputType = {
  city?: InputMaybe<Scalars['String']['input']>;
  eInvoicingAddress?: InputMaybe<Scalars['String']['input']>;
  eInvoicingOperator?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
};

export type InvoicingBillingPeriodInput = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type IterationInput = {
  intervalDays: Scalars['Int']['input'];
  repeat: Scalars['Int']['input'];
};

export type IterationOutput = {
  __typename?: 'IterationOutput';
  intervalDays: Scalars['Int']['output'];
  repeat: Scalars['Int']['output'];
};

/** An enumeration. */
export enum KantaDocumentType {
  PrescriptionAdd = 'PRESCRIPTION_ADD',
  PrescriptionReplacement = 'PRESCRIPTION_REPLACEMENT',
  PrescriptionRepudiation = 'PRESCRIPTION_REPUDIATION'
}

export type KelaActionCategoryInput = {
  kelaOneActionCategory?: InputMaybe<KelaOneActionCategories>;
  kelaTwoActionCategory?: InputMaybe<KelaTwoActionCategories>;
};

/** An enumeration. */
export enum KelaOneActionCategories {
  CustomHealthCheck = 'CUSTOM_HEALTH_CHECK',
  ExposureHealthCheck = 'EXPOSURE_HEALTH_CHECK',
  GroupAdviceAndGuidance = 'GROUP_ADVICE_AND_GUIDANCE',
  IndividualAdviceAndGuidance = 'INDIVIDUAL_ADVICE_AND_GUIDANCE',
  WorkplaceAssessment = 'WORKPLACE_ASSESSMENT'
}

/** An enumeration. */
export enum KelaReportResourceCategoryChoices {
  Agriculture = 'AGRICULTURE',
  Doctor = 'DOCTOR',
  Ergonomics = 'ERGONOMICS',
  Exercise = 'EXERCISE',
  Hygiene = 'HYGIENE',
  Imaging = 'IMAGING',
  Laboratory = 'LABORATORY',
  Nurse = 'NURSE',
  Nutrition = 'NUTRITION',
  OtherCosts = 'OTHER_COSTS',
  Physiotherapist = 'PHYSIOTHERAPIST',
  Psychologist = 'PSYCHOLOGIST',
  Social = 'SOCIAL',
  Specialist = 'SPECIALIST',
  SpeechTherapy = 'SPEECH_THERAPY',
  Technical = 'TECHNICAL',
  Vision = 'VISION'
}

/**
 * Aggregate type over one sent sales invoice, no direct model — every field
 * resolver verifies the sales invoice view permission for the customer.
 */
export type KelaSv98TthInvoicedCostsInvoiceType = {
  __typename?: 'KelaSv98TthInvoicedCostsInvoiceType';
  attributedCosts: Scalars['Decimal']['output'];
  customerId: Scalars['ID']['output'];
  fennoaDataUsed: Scalars['Boolean']['output'];
  fennoaFinalNet?: Maybe<Scalars['Decimal']['output']>;
  invoiceId: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
  localNet: Scalars['Decimal']['output'];
  shippingDate: Scalars['Date']['output'];
};

/**
 * Aggregate type, no direct model — the query resolver only passes the parameters
 * through; every field resolver verifies the sales invoice view permission before
 * computing the invoiced costs.
 */
export type KelaSv98TthInvoicedCostsType = {
  __typename?: 'KelaSv98TthInvoicedCostsType';
  accountingPeriodEnd: Scalars['Date']['output'];
  accountingPeriodStart: Scalars['Date']['output'];
  customerId: Scalars['ID']['output'];
  invoices: Array<KelaSv98TthInvoicedCostsInvoiceType>;
  total: Scalars['Decimal']['output'];
  warnings: Array<Scalars['String']['output']>;
};

/** An enumeration. */
export enum KelaTwoActionCategories {
  MedicalCare = 'MEDICAL_CARE',
  OtherHealthcare = 'OTHER_HEALTHCARE'
}

export type LaboratoryBillableEventInputType = {
  date: Scalars['Date']['input'];
  laboratoryEventCode: Scalars['String']['input'];
  laboratoryEventDescription?: InputMaybe<Scalars['String']['input']>;
  personalId: Scalars['String']['input'];
  price: Scalars['Decimal']['input'];
  supplier: LaboratorySupplierChoices;
};

export type LaboratoryBillableEventType = {
  __typename?: 'LaboratoryBillableEventType';
  billablePatient?: Maybe<BillablePatientType>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  laboratoryEventCode: Scalars['String']['output'];
  laboratoryEventDescription: Scalars['String']['output'];
  purchasePrice: Scalars['Decimal']['output'];
  supplier: BillablesLaboratoryBillableEventSupplierChoices;
};

export type LaboratoryCatalogContentsType = {
  __typename?: 'LaboratoryCatalogContentsType';
  laboratoryTests: Array<LaboratoryTestType>;
  norrePackages: Array<NorrePackageType>;
  supplierPackages: Array<SupplierPackageType>;
};

export type LaboratoryCatalogSalesPriceType = {
  __typename?: 'LaboratoryCatalogSalesPriceType';
  id: Scalars['ID']['output'];
  isAvailable: Scalars['Boolean']['output'];
  laboratoryCatalog: LaboratoryCatalogType;
  laboratoryTest?: Maybe<LaboratoryTestType>;
  norrePackage?: Maybe<NorrePackageType>;
  price: Scalars['Decimal']['output'];
  supplierPackage?: Maybe<SupplierPackageType>;
};

export type LaboratoryCatalogType = {
  __typename?: 'LaboratoryCatalogType';
  activeFrom?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  salesPrices: Array<LaboratoryCatalogSalesPriceType>;
  state: LaboratorycatalogsLaboratoryCatalogStateChoices;
};

/** An enumeration. */
export enum LaboratoryChoices {
  Both = 'BOTH',
  Nordlab = 'NORDLAB',
  Synlab = 'SYNLAB'
}

export type LaboratoryEventSalesInvoiceRowType = {
  __typename?: 'LaboratoryEventSalesInvoiceRowType';
  createdAt: Scalars['DateTime']['output'];
  eventDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  invoiceRow: InvoiceSaleRowType;
  laboratoryEventId: Scalars['String']['output'];
  purchasePrice?: Maybe<Scalars['Decimal']['output']>;
};

/** An enumeration. */
export enum LaboratoryLaboratoryOrderStateChoices {
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Changed */
  Changed = 'CHANGED',
  /** Draft */
  Draft = 'DRAFT',
  /** Results received */
  ResultsReceived = 'RESULTS_RECEIVED',
  /** Results reviewed */
  ResultsReviewed = 'RESULTS_REVIEWED',
  /** Sent */
  Sent = 'SENT'
}

export type LaboratoryOrderType = {
  __typename?: 'LaboratoryOrderType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  laboratoryOid: Scalars['String']['output'];
  patient: PatientType;
  professional?: Maybe<Professional>;
  reviewedByPatientAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedByPid?: Maybe<Professional>;
  reviewedByPidAt?: Maybe<Scalars['DateTime']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  serviceEvent: ServiceEvent;
  state: LaboratoryLaboratoryOrderStateChoices;
};

export type LaboratoryResultType = {
  __typename?: 'LaboratoryResultType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  limits: Scalars['String']['output'];
  rawDate: Scalars['String']['output'];
  result: Scalars['String']['output'];
  testDate: Scalars['Date']['output'];
  unit: Scalars['String']['output'];
};

export enum LaboratorySalesPriceModelTypenameChoices {
  Laboratorytesttype = 'LABORATORYTESTTYPE',
  Norrepackagetype = 'NORREPACKAGETYPE',
  Supplierpackagetype = 'SUPPLIERPACKAGETYPE'
}

/** An enumeration. */
export enum LaboratorySupplierChoices {
  Nordlab = 'NORDLAB',
  Synlab = 'SYNLAB'
}

export type LaboratorySupplierType = {
  __typename?: 'LaboratorySupplierType';
  address: Scalars['String']['output'];
  childLaboratories: Array<LaboratorySupplierType>;
  city: Scalars['String']['output'];
  code: LaboratoryType;
  createdAt: Scalars['DateTime']['output'];
  discountPercent: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentLaboratory?: Maybe<LaboratorySupplierType>;
  phoneNumber: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  pricePerVisit?: Maybe<Scalars['Decimal']['output']>;
  supplierpackagepriceSet: Array<SupplierPackagePriceType>;
  suppliertestpriceSet: Array<SupplierTestPriceType>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

export type LaboratoryTestCodeType = {
  codeId: Scalars['Int']['input'];
};

/** Value belongs to codesystem 1.2.246.537.6.3 values. */
export type LaboratoryTestNomenclatureType = {
  __typename?: 'LaboratoryTestNomenclatureType';
  abbreviation: Scalars['String']['output'];
  codeId: Scalars['String']['output'];
  codeSystem?: Maybe<CodeSystemType>;
  description?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['Date']['output']>;
  laboratorytest?: Maybe<LaboratoryTestType>;
  longName?: Maybe<Scalars['String']['output']>;
  longNameSwedish?: Maybe<Scalars['String']['output']>;
  replacementCodeIds?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type LaboratoryTestType = {
  __typename?: 'LaboratoryTestType';
  code?: Maybe<LaboratoryTestNomenclatureType>;
  createdAt: Scalars['DateTime']['output'];
  descriptionLong: Scalars['String']['output'];
  descriptionShort: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  norrepackagetestSet: Array<NorrePackageTestType>;
  salesPrices: Array<LaboratoryCatalogSalesPriceType>;
  supplierpackagetestSet: Array<SupplierPackageTestType>;
  suppliertestpriceSet: Array<SupplierTestPriceType>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

/** Value belongs to codesystem 1.2.246.537.6.202 values. */
export type LaboratoryType = {
  __typename?: 'LaboratoryType';
  abbreviation?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  beginDate?: Maybe<Scalars['Date']['output']>;
  businessId?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  codeId: Scalars['String']['output'];
  codeSystem?: Maybe<CodeSystemType>;
  expirationDate?: Maybe<Scalars['Date']['output']>;
  hierarchyLevel?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isHealthCareOperationalUnit?: Maybe<Scalars['Boolean']['output']>;
  isHealthCareServiceUnit?: Maybe<Scalars['Boolean']['output']>;
  isSocialCareOperationalUnit?: Maybe<Scalars['Boolean']['output']>;
  isSocialCareServiceUnit?: Maybe<Scalars['Boolean']['output']>;
  laboratorysupplierSet: Array<LaboratorySupplierType>;
  parentId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum LaboratorycatalogsLaboratoryCatalogStateChoices {
  /** Luonnos */
  Draft = 'DRAFT',
  /** Lukittu */
  Locked = 'LOCKED'
}

export enum LanguageEnum {
  En = 'en',
  Fi = 'fi'
}

/** Manually attributes an unmatched booking page reservation to an invitation. */
export type LinkCalendarBookingToInvitation = {
  __typename?: 'LinkCalendarBookingToInvitation';
  healthCheck: HealthCheckBasicInformation;
};

export type LockLaboratoryCatalog = {
  __typename?: 'LockLaboratoryCatalog';
  laboratoryCatalog?: Maybe<LaboratoryCatalogType>;
};

export type LockSalesCatalog = {
  __typename?: 'LockSalesCatalog';
  salesCatalog?: Maybe<SalesCatalogType>;
};

export type LogAcuteUserSyncType = {
  __typename?: 'LogAcuteUserSyncType';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  data: Scalars['String']['output'];
  error: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  method: Scalars['String']['output'];
  response: Scalars['String']['output'];
  responseStatusCode: Scalars['String']['output'];
  system: LogsLogAcuteUserSyncSystemChoices;
  url: Scalars['String']['output'];
  user?: Maybe<UserType>;
};

/** An enumeration. */
export enum LogsLogAcuteUserSyncSystemChoices {
  /** Acute */
  Acute = 'ACUTE',
  /** Zef */
  Zef = 'ZEF'
}

/**
 * Approve a local draft and mark it as sent to the customer without Fennoa, recording why
 * and the sum really invoiced.
 */
export type ManualApproveAndSendSalesInvoice = {
  __typename?: 'ManualApproveAndSendSalesInvoice';
  salesInvoice?: Maybe<InvoiceSaleType>;
};

/**
 * Records an appointment the nurse booked by phone or in person: creates an
 * invitation row that never sent an email (manual_booking=True, no tracking row).
 */
export type MarkHealthCheckBookedManually = {
  __typename?: 'MarkHealthCheckBookedManually';
  healthCheck: HealthCheckBasicInformation;
};

/** A PAYROLL/KELA handler marks an approved notice as handled; active certificate access ends. */
export type MarkSickLeaveNoticeHandled = {
  __typename?: 'MarkSickLeaveNoticeHandled';
  sickLeaveNotice: SickLeaveNoticeType;
};

export type MedicalApiTokenType = {
  __typename?: 'MedicalAPITokenType';
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
};

export type MedicalCustomerType = {
  __typename?: 'MedicalCustomerType';
  id: Scalars['ID']['output'];
};

export type MedicalFile = SickLeaveCertificateType | SuitabilityStatementType;

/** An enumeration. */
export enum MedicalFileKindChoices {
  SickLeaveCertificate = 'SICK_LEAVE_CERTIFICATE',
  SuitabilityStatement = 'SUITABILITY_STATEMENT'
}

export type MedicalFileOwnerRefs = {
  followUpMeasures?: InputMaybe<Scalars['String']['input']>;
  healthCheckId?: InputMaybe<Scalars['ID']['input']>;
  sickLeaveEndDate?: InputMaybe<Scalars['Date']['input']>;
  sickLeaveIcd10Code?: InputMaybe<Scalars['String']['input']>;
  sickLeaveNoticeId?: InputMaybe<Scalars['ID']['input']>;
  sickLeaveStartDate?: InputMaybe<Scalars['Date']['input']>;
  sickLeaveTypeId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MedicalFileSignedUrl = {
  __typename?: 'MedicalFileSignedUrl';
  expiresAt: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** An enumeration. */
export enum MedicalPermissionChoices {
  AddApitokenpermission = 'add_apitokenpermission',
  AddBillable = 'add_billable',
  AddCdadocument = 'add_cdadocument',
  AddContenttype = 'add_contenttype',
  AddFitnesstest = 'add_fitnesstest',
  AddGroup = 'add_group',
  AddLaboratoryorder = 'add_laboratoryorder',
  AddLaboratoryordertest = 'add_laboratoryordertest',
  AddLaboratoryordertestresult = 'add_laboratoryordertestresult',
  AddLogentry = 'add_logentry',
  AddMedicalapitoken = 'add_medicalapitoken',
  AddMedicalpermissionprofile = 'add_medicalpermissionprofile',
  AddNonce = 'add_nonce',
  AddOrganization = 'add_organization',
  AddPatient = 'add_patient',
  AddPatientrecord = 'add_patientrecord',
  AddPaymentcommitmentpatientinfo = 'add_paymentcommitmentpatientinfo',
  AddPermission = 'add_permission',
  AddPrescription = 'add_prescription',
  AddProfessional = 'add_professional',
  AddProfessionalright = 'add_professionalright',
  AddRepudiatedprescription = 'add_repudiatedprescription',
  AddServiceevent = 'add_serviceevent',
  AddSession = 'add_session',
  AddSmartcard = 'add_smartcard',
  AddUser = 'add_user',
  ChangeApitokenpermission = 'change_apitokenpermission',
  ChangeBillable = 'change_billable',
  ChangeCdadocument = 'change_cdadocument',
  ChangeContenttype = 'change_contenttype',
  ChangeFitnesstest = 'change_fitnesstest',
  ChangeGroup = 'change_group',
  ChangeLaboratoryorder = 'change_laboratoryorder',
  ChangeLaboratoryordertest = 'change_laboratoryordertest',
  ChangeLaboratoryordertestresult = 'change_laboratoryordertestresult',
  ChangeLogentry = 'change_logentry',
  ChangeMedicalpermissionprofile = 'change_medicalpermissionprofile',
  ChangeNonce = 'change_nonce',
  ChangeOrganization = 'change_organization',
  ChangePatient = 'change_patient',
  ChangePatientrecord = 'change_patientrecord',
  ChangePaymentcommitmentpatientinfo = 'change_paymentcommitmentpatientinfo',
  ChangePermission = 'change_permission',
  ChangePrescription = 'change_prescription',
  ChangeProfessional = 'change_professional',
  ChangeProfessionalright = 'change_professionalright',
  ChangeRepudiatedprescription = 'change_repudiatedprescription',
  ChangeServiceevent = 'change_serviceevent',
  ChangeSession = 'change_session',
  ChangeSmartcard = 'change_smartcard',
  ChangeUser = 'change_user',
  DeleteApitokenpermission = 'delete_apitokenpermission',
  DeleteBillable = 'delete_billable',
  DeleteCdadocument = 'delete_cdadocument',
  DeleteContenttype = 'delete_contenttype',
  DeleteFitnesstest = 'delete_fitnesstest',
  DeleteGroup = 'delete_group',
  DeleteLaboratoryorder = 'delete_laboratoryorder',
  DeleteLaboratoryordertest = 'delete_laboratoryordertest',
  DeleteLaboratoryordertestresult = 'delete_laboratoryordertestresult',
  DeleteLogentry = 'delete_logentry',
  DeleteMedicalapitoken = 'delete_medicalapitoken',
  DeleteMedicalpermissionprofile = 'delete_medicalpermissionprofile',
  DeleteNonce = 'delete_nonce',
  DeleteOrganization = 'delete_organization',
  DeletePatient = 'delete_patient',
  DeletePatientrecord = 'delete_patientrecord',
  DeletePaymentcommitmentpatientinfo = 'delete_paymentcommitmentpatientinfo',
  DeletePermission = 'delete_permission',
  DeletePrescription = 'delete_prescription',
  DeleteProfessional = 'delete_professional',
  DeleteProfessionalright = 'delete_professionalright',
  DeleteRepudiatedprescription = 'delete_repudiatedprescription',
  DeleteServiceevent = 'delete_serviceevent',
  DeleteSession = 'delete_session',
  DeleteSmartcard = 'delete_smartcard',
  DeleteUser = 'delete_user',
  ViewApitokenpermission = 'view_apitokenpermission',
  ViewBillable = 'view_billable',
  ViewCdadocument = 'view_cdadocument',
  ViewContenttype = 'view_contenttype',
  ViewFitnesstest = 'view_fitnesstest',
  ViewGroup = 'view_group',
  ViewLaboratoryorder = 'view_laboratoryorder',
  ViewLaboratoryordertest = 'view_laboratoryordertest',
  ViewLaboratoryordertestresult = 'view_laboratoryordertestresult',
  ViewLogentry = 'view_logentry',
  ViewMedicalapitoken = 'view_medicalapitoken',
  ViewMedicalpermissionprofile = 'view_medicalpermissionprofile',
  ViewNonce = 'view_nonce',
  ViewOrganization = 'view_organization',
  ViewPatient = 'view_patient',
  ViewPatientrecord = 'view_patientrecord',
  ViewPaymentcommitmentpatientinfo = 'view_paymentcommitmentpatientinfo',
  ViewPermission = 'view_permission',
  ViewPrescription = 'view_prescription',
  ViewProfessional = 'view_professional',
  ViewProfessionalright = 'view_professionalright',
  ViewRepudiatedprescription = 'view_repudiatedprescription',
  ViewServiceevent = 'view_serviceevent',
  ViewSession = 'view_session',
  ViewSmartcard = 'view_smartcard',
  ViewUser = 'view_user'
}

export type MedicalPermissionType = {
  __typename?: 'MedicalPermissionType';
  codename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  profiles?: Maybe<Array<Maybe<ProfileType>>>;
};

export type MedicalStaffSearchReturnType = {
  __typename?: 'MedicalStaffSearchReturnType';
  customers: Array<CustomerType>;
  users: Array<UserType>;
};

export type MedicalUserType = {
  __typename?: 'MedicalUserType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  /** Designates that this user has all permissions without explicitly assigning them. */
  isSuperuser: Scalars['Boolean']['output'];
  language: UsersUserLanguageChoices;
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  password: Scalars['String']['output'];
  patientInfo?: Maybe<PatientType>;
  professionalInfo?: Maybe<Professional>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type MedicationPeriodInfo = {
  __typename?: 'MedicationPeriodInfo';
  amount?: Maybe<Scalars['Int']['output']>;
  unit?: Maybe<TimeUnit>;
};

/** Value belongs to codesystem 1.2.246.537.6.604 values. */
export type MedicinalProductType = {
  __typename?: 'MedicinalProductType';
  code: Scalars['String']['output'];
  codeSystem?: Maybe<CodeSystemType>;
  displayName: Scalars['String']['output'];
};

export type MedicineList = {
  __typename?: 'MedicineList';
  medicines?: Maybe<Array<Maybe<PrescriptionMetadata>>>;
  patient?: Maybe<PatientGeneralInfo>;
};

export enum MedicineUsageInputType {
  Continuous = 'CONTINUOUS',
  FixedTerm = 'FIXED_TERM',
  IfNecessary = 'IF_NECESSARY'
}

export enum MedicineUsageType {
  Continuous = 'CONTINUOUS',
  FixedTerm = 'FIXED_TERM',
  IfNecessary = 'IF_NECESSARY'
}

export type MoontalkAverageStats = {
  __typename?: 'MoontalkAverageStats';
  callLengthSeconds: Scalars['Decimal']['output'];
  callbackTimeInServiceTimeSeconds?: Maybe<Scalars['Decimal']['output']>;
  callbackTimeOutsideServiceTimeSeconds?: Maybe<Scalars['Decimal']['output']>;
  callbackTimeTotalSeconds: Scalars['Decimal']['output'];
  responseRate: Scalars['Decimal']['output'];
  responseRateInServiceTime?: Maybe<Scalars['Decimal']['output']>;
  responseTimeFirstLineSeconds?: Maybe<Scalars['Decimal']['output']>;
  responseTimeSecondLineSeconds?: Maybe<Scalars['Decimal']['output']>;
  responseTimeSeconds: Scalars['Decimal']['output'];
};

export type MoontalkCallStats = {
  __typename?: 'MoontalkCallStats';
  inServiceTime?: Maybe<Scalars['Int']['output']>;
  inServiceTimeAnswered?: Maybe<Scalars['Int']['output']>;
  inServiceTimeUnanswered?: Maybe<Scalars['Int']['output']>;
  outsideServiceTime?: Maybe<Scalars['Int']['output']>;
  perWorkDay: Scalars['Decimal']['output'];
  total: Scalars['Int']['output'];
  unhandled: Scalars['Int']['output'];
};

export type MoontalkCredentialsType = {
  __typename?: 'MoontalkCredentialsType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  tokenNameStub: Scalars['String']['output'];
  tokenStub: Scalars['String']['output'];
};

export type MoontalkPersonalStats = {
  __typename?: 'MoontalkPersonalStats';
  callsAnswered: Scalars['Int']['output'];
  callsPostProcessed: Scalars['Int']['output'];
  moontalkUserId: Scalars['Int']['output'];
  stats: MoontalkAverageStats;
  user?: Maybe<UserType>;
};

export type MoontalkReport = {
  __typename?: 'MoontalkReport';
  endDate: Scalars['DateTime']['output'];
  healthCare: MoontalkStats;
  periodLengthDays: Scalars['Int']['output'];
  sales: MoontalkStats;
  startDate: Scalars['DateTime']['output'];
  workDaysInPeriod: Scalars['Int']['output'];
};

export type MoontalkStats = {
  __typename?: 'MoontalkStats';
  callStats: MoontalkCallStats;
  personalStats: Array<MoontalkPersonalStats>;
  stats: MoontalkAverageStats;
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Records that the acting user accepted the current terms of use version
   * (settings.TERMS_OF_USE_VERSION). The row's owner check runs in UserSettings.save().
   */
  acceptTermsOfUse: AcceptTermsOfUse;
  addCampaignSurveyRespondent?: Maybe<AddCampaignSurveyRespondent>;
  addHealthCheck: AddHealthCheck;
  /** Add multi-signature value to prescriptions. */
  addMultiSignatureValueToPrescriptions?: Maybe<AddMultiSignatureValueToPrescriptions>;
  addPatient?: Maybe<AddPatient>;
  addPaymentCommitmentPurchase: AddPaymentCommitmentPurchase;
  addSignatureValueToPrescription?: Maybe<AddSignatureValueToPrescription>;
  addSurveyAnswer?: Maybe<AddSurveyAnswer>;
  addUserEmploymentInformation?: Maybe<AddUserEmploymentInformation>;
  addUserInformationViewReasonLog?: Maybe<AddUserInformationViewReasonLog>;
  approveInvoicePurchases?: Maybe<ApproveInvoicePurchases>;
  bulkCreateAcuteBillableEvents: BulkCreateAcuteBillableEvents;
  bulkCreateBillablePatients: BulkCreateBillablePatients;
  bulkCreateLaboratoryBillableEvents: BulkCreateLaboratoryBillableEvents;
  bulkCreatePartnerProcedurePrices: BulkCreatePartnerProcedurePrices;
  bulkCreatePartners: BulkCreatePartners;
  bulkCreateReimbursementConversion: BulkCreateReimbursementConversions;
  bulkCreateUsers: BulkCreateUsers;
  cancelLaboratoryOrder?: Maybe<CancelLaboratoryOrder>;
  changeLaboratoryOrder?: Maybe<ChangeLaboratoryOrder>;
  completeHealthCheck: CompleteHealthCheck;
  completeTask: CompleteTask;
  /**
   * Recomputes the peer cost benchmarks (costreports/benchmark.py). Run nightly by the Cloud
   * Scheduler job with an API token whose role grants only compute_cost_benchmarks (plus the
   * add/delete_costbenchmark write permissions the rows need). The request's own credentials are
   * forwarded to the medical backend for the payment commitment categories, which is why the job
   * runs inside the request instead of a management command.
   */
  computeCostBenchmarks?: Maybe<ComputeCostBenchmarks>;
  confirmFetch: Scalars['Boolean']['output'];
  confirmMedicalFileUpload: MedicalFile;
  createAcknowledgment: CreateAcknowledgment;
  createActionPlan: CreateActionPlan;
  createAndSendLaboratoryOrder?: Maybe<CreateAndSendLaboratoryOrder>;
  createApiToken?: Maybe<CreateApiToken>;
  createAuthUser: AuthUserType;
  createBranch?: Maybe<CreateBranch>;
  createCampaign?: Maybe<CreateCampaign>;
  createChoiceBranch?: Maybe<CreateChoiceBranch>;
  createCompanyAndSetAddresses: CreateCompanyAndSetAddresses;
  createCostCenter?: Maybe<CreateCostCenter>;
  createCustomer: CreateCustomer;
  createCustomerAddress: CreateCustomerAddress;
  createCustomerInvoiceDraft: CreateCustomerInvoiceDraft;
  createCustomerWithContract: CreateCustomerWithContract;
  createDocument?: Maybe<CreateDocument>;
  createDocumentCategory?: Maybe<CreateDocumentCategory>;
  createDocumentTemplate?: Maybe<CreateDocumentTemplate>;
  createDocumentTemplateItem?: Maybe<CreateDocumentTemplateItem>;
  createDocumentVersion?: Maybe<CreateDocumentVersion>;
  createEmployeeGroup?: Maybe<CreateEmployeeGroup>;
  createEmptyLaboratoryCatalog?: Maybe<CreateEmptyLaboratoryCatalog>;
  createExposure: CreateExposure;
  createFitnessTest?: Maybe<CreateFitnessTest>;
  createFitnessTestDevice?: Maybe<CreateFitnessTestDevice>;
  createHealthCheckContentConfiguration: CreateHealthCheckContentConfiguration;
  createHealthcareTeam?: Maybe<CreateHealthcareTeam>;
  createInsuranceCompany: CreateInsuranceCompany;
  createInvoiceInterface: CreateInvoiceInterface;
  createInvoicePurchaseComment?: Maybe<CreateInvoicePurchaseComment>;
  createLaboratoryCatalogBasedOnExisting?: Maybe<CreateLaboratoryCatalogBasedOnExisting>;
  createLaboratorySupplier?: Maybe<CreateLaboratorySupplier>;
  createMedicalApiToken: CreateMedicalApiToken;
  createNorrePackage?: Maybe<CreateNorrePackage>;
  createOrUpdateLaboratorySalesPrice?: Maybe<CreateOrUpdateLaboratorySalesPrice>;
  createOrganization?: Maybe<CreateOrganization>;
  createPartner: CreatePartner;
  createPaymentCommitment: CreatePaymentCommitment;
  createPaymentCommitmentPatientInfo?: Maybe<CreatePaymentCommitmentPatientInfo>;
  createPrescription?: Maybe<CreatePrescription>;
  createProcedure?: Maybe<CreateProcedure>;
  createProcedurePartnerPrice?: Maybe<CreateProcedurePartnerPrice>;
  createProfessionalGroup?: Maybe<CreateProfessionalGroup>;
  createProfile?: Maybe<CreateProfile>;
  createQuestion?: Maybe<CreateQuestion>;
  createReimbursementConversion?: Maybe<CreateReimbursementConversion>;
  createRoleCompany?: Maybe<CreateRoleCompany>;
  createRoleCorporate?: Maybe<CreateRoleCorporate>;
  createSalesCatalog?: Maybe<CreateSalesCatalog>;
  createSalesContractVersion: CreateSalesContractVersion;
  createServiceEvent?: Maybe<CreateServiceEvent>;
  createSickLeaveCategory?: Maybe<CreateSickLeaveCategory>;
  /**
   * Names a person who handles sick leave notices of every employee of the customer for the
   * given reasons. The user may belong to another customer if they hold a role in this one.
   */
  createSickLeaveHandler: CreateSickLeaveHandler;
  createSickLeaveNotice?: Maybe<CreateSickLeaveNotice>;
  createSickLeavePeriodSetting?: Maybe<CreateSickLeavePeriodSetting>;
  /**
   * Adds a recurrent absence rule (at least `periods` periods within `months` months) to the
   * customer's early support settings.
   */
  createSickLeaveRecurrentAbsenceThreshold: CreateSickLeaveRecurrentAbsenceThreshold;
  createSickLeaveSelfReportReason?: Maybe<CreateSickLeaveSelfReportReason>;
  createSupplierPackage?: Maybe<CreateSupplierPackage>;
  createTitletemplate?: Maybe<CreateTitleTemplate>;
  createTree: CreateTree;
  createUser?: Maybe<CreateUser>;
  createView?: Maybe<CreateView>;
  createZefSurveyConfigurationVersion: CreateZefSurveyConfigurationVersion;
  /**
   * The employee declines a pending request to submit the certificate: the task is cancelled.
   * A handler may request again later, and the employee may still submit proactively.
   */
  declineSickLeaveCertificateSubmission: DeclineSickLeaveCertificateSubmission;
  deleteActionPlan: DeleteActionPlan;
  deleteApiToken?: Maybe<DeleteApiToken>;
  deleteAuthUser: Scalars['Boolean']['output'];
  deleteBranch?: Maybe<DeleteBranch>;
  deleteCampaign?: Maybe<DeleteCampaign>;
  deleteCompany: DeleteCompany;
  deleteCostCenter?: Maybe<DeleteCostCenter>;
  deleteCustomer: DeleteCustomer;
  deleteDocument?: Maybe<DeleteDocument>;
  deleteDocumentCategory?: Maybe<DeleteDocumentCategory>;
  deleteDocumentTemplate?: Maybe<DeleteDocumentTemplate>;
  deleteDocumentTemplateItem?: Maybe<DeleteDocumentTemplateItem>;
  deleteDocumentVersion?: Maybe<DeleteDocumentVersion>;
  deleteEmployeeGroup?: Maybe<DeleteEmployeeGroup>;
  deleteExposure: DeleteExposure;
  deleteFitnessTest?: Maybe<DeleteFitnessTest>;
  deleteFitnessTestDevice?: Maybe<DeleteFitnessTestDevice>;
  deleteHealthCheck: DeleteHealthCheck;
  deleteHealthCheckContentConfiguration: DeleteHealthCheckContentConfiguration;
  deleteHealthcareTeam?: Maybe<DeleteHealthcareTeam>;
  deleteInvoiceInterface: DeleteInvoiceInterface;
  deleteLaboratoryCatalog?: Maybe<DeleteLaboratoryCatalog>;
  deleteLaboratoryOrder?: Maybe<DeleteLaboratoryOrder>;
  deleteLaboratorySalesPrice?: Maybe<DeleteLaboratorySalesPrice>;
  deleteLaboratorySupplier?: Maybe<DeleteLaboratorySupplier>;
  deleteMedicalApiToken: DeleteMedicalApiToken;
  deleteMedicalFile: DeleteMedicalFile;
  deleteNode?: Maybe<DeleteNode>;
  deleteNorrePackage?: Maybe<DeleteNorrePackage>;
  deletePartner: DeletePartner;
  deletePaymentCommitment: DeletePaymentCommitment;
  deletePaymentCommitmentPurchase: DeletePaymentCommitmentPurchase;
  deleteProcedure?: Maybe<DeleteProcedure>;
  deleteProcedurePartnerPrice?: Maybe<DeleteProcedurePartnerPrice>;
  deleteProfessionalGroup?: Maybe<DeleteProfessionalGroup>;
  deleteProfile?: Maybe<DeleteProfile>;
  deleteReimbursementConversion?: Maybe<DeleteReimbursementConversion>;
  deleteSalesCatalog?: Maybe<DeleteSalesCatalog>;
  deleteSalesInvoiceDraft: DeleteSalesInvoiceDraft;
  deleteSickLeaveCategory?: Maybe<DeleteSickLeaveCategory>;
  deleteSickLeaveHandler: DeleteSickLeaveHandler;
  /**
   * Deletes a sick leave notice and cleans up any attached certificate (its medical file and
   * submission task). Permission is enforced per object: certificate notices can only be deleted by
   * their creating occupational health user.
   */
  deleteSickLeaveNotice: DeleteSickLeaveNotice;
  deleteSickLeavePeriodSetting?: Maybe<DeleteSickLeavePeriodSetting>;
  deleteSickLeaveRecurrentAbsenceThreshold: DeleteSickLeaveRecurrentAbsenceThreshold;
  deleteSickLeaveSelfReportReason?: Maybe<DeleteSickLeaveSelfReportReason>;
  deleteSupplierPackage?: Maybe<DeleteSupplierPackage>;
  deleteTitletemplate?: Maybe<DeleteTitleTemplate>;
  deleteTree?: Maybe<DeleteTree>;
  /**
   * Manually removes an unmatched booking the nurse does not want to link.
   *
   * Permission (owning nurse or sync) is enforced automatically by delete().
   */
  deleteUnmatchedCalendarBooking: DeleteUnmatchedCalendarBooking;
  deleteUser?: Maybe<DeleteUser>;
  deleteView?: Maybe<DeleteView>;
  endCampaign?: Maybe<EndCampaign>;
  /** Calculate digests of structuredBody for every document for multi-signature. */
  getDigestsForMultiSignature?: Maybe<GetDigestsForMultiSignature>;
  getPdfFormSv98tth?: Maybe<GetPdfFormSv98Tth>;
  grantSuitabilityStatementEmployerView: GrantSuitabilityStatementEmployerView;
  handleSickLeaveNotice?: Maybe<HandleSickLeaveNotice>;
  /** Import payment commitments from an Excel file. */
  importPaymentCommitmentsFromExcel: ImportPaymentCommitmentsFromExcel;
  insertTempStorage?: Maybe<InsertTempField>;
  /** Manually attributes an unmatched booking page reservation to an invitation. */
  linkCalendarBookingToInvitation: LinkCalendarBookingToInvitation;
  lockLaboratoryCatalog?: Maybe<LockLaboratoryCatalog>;
  lockSalesCatalog?: Maybe<LockSalesCatalog>;
  logout: Scalars['Boolean']['output'];
  /**
   * Approve a local draft and mark it as sent to the customer without Fennoa, recording why
   * and the sum really invoiced.
   */
  manualApproveAndSendSalesInvoice: ManualApproveAndSendSalesInvoice;
  /**
   * Records an appointment the nurse booked by phone or in person: creates an
   * invitation row that never sent an email (manual_booking=True, no tracking row).
   */
  markHealthCheckBookedManually: MarkHealthCheckBookedManually;
  /** A PAYROLL/KELA handler marks an approved notice as handled; active certificate access ends. */
  markSickLeaveNoticeHandled: MarkSickLeaveNoticeHandled;
  newSurveyAnswer?: Maybe<NewSurveyAnswer>;
  /**
   * Anonymous mutation behind the emailed invitation link.
   *
   * No authenticated user: possession of the unguessable tracking token is the
   * authorization. Writes only the plain-model tracking row (no permission machinery)
   * and reveals nothing but the booking page URL.
   */
  openHealthCheckInvitation: OpenHealthCheckInvitation;
  passkeyAuthenticationOptions: Scalars['JSON']['output'];
  passkeyAuthenticationVerify: PasskeyAuthResult;
  passkeyRegistrationOptions: Scalars['JSON']['output'];
  passkeyRegistrationVerify: Scalars['Boolean']['output'];
  passkeyRevoke: Scalars['Boolean']['output'];
  permanentlyDeleteAuthUser: Scalars['Boolean']['output'];
  permanentlyDeleteUser?: Maybe<PermanentlyDeleteUser>;
  preparePrescriptionForSigning?: Maybe<PreparePrescriptionForSigning>;
  /** Add multi-signature element with signed info to prescriptions to be signed. Returns multi-signature digest to be signed within a smartcard reader. */
  preparePrescriptionsForMultiSigning?: Maybe<PreparePrescriptionsForMultiSigning>;
  prepareSmartCardLogin?: Maybe<PrepareSmartCardLogin>;
  questionToNode?: Maybe<QuestionToNode>;
  refreshToken: PasskeyAuthResult;
  rejectInvoicePurchase?: Maybe<RejectInvoicePurchase>;
  removeCampaignSurveyRespondent?: Maybe<RemoveCampaignSurveyRespondent>;
  replacePrescription?: Maybe<ReplacePrescription>;
  /**
   * Mutation which creates prescription repudiation documents in medical-database.
   * Repudiation documents should still send to Kanta using sendDocumentToKanta mutation or sendPrescriptionRepudiations.
   */
  repudiatePrescriptions?: Maybe<RepudiatePrescriptions>;
  requestMedicalFileUpload: RequestMedicalFileUploadResult;
  /**
   * A handler asks the employee to submit the certificate to the employer.
   *
   * Creates the submission task assigned to the employee and notifies them by email.
   * Idempotent: an existing, uncancelled task is returned without creating another.
   *
   * Returns the notice: the handler cannot view the certificate object until it is submitted,
   * so the submission state is exposed through the notice's certificate metadata fields.
   */
  requestSickLeaveCertificateSubmission: RequestSickLeaveCertificateSubmission;
  resendLaboratoryOrder?: Maybe<ResendLaboratoryOrder>;
  revokeSuitabilityStatementEmployerView: RevokeSuitabilityStatementEmployerView;
  saveAnswers?: Maybe<SaveAnswers>;
  sendDocumentToKanta?: Maybe<SendDocumentToKanta>;
  sendHealthCheckInvitation: SendHealthCheckInvitation;
  /** Mutation which send prescription repudiations to Kanta. */
  sendPrescriptionRepudiations?: Maybe<SendPrescriptionRepudiations>;
  sendUserToAcute?: Maybe<SendUserToAcute>;
  setCondition?: Maybe<SetCondition>;
  setMoontalkCredentials: SetMoontalkCredentials;
  setOwnHealthCheckBookingUrl: SetOwnHealthCheckBookingUrl;
  setPermissionsEqual?: Maybe<SetPermissionsEqual>;
  smartCardLogin?: Maybe<SmartCardLogin>;
  smartCardLogout?: Maybe<SmartCardLogout>;
  startCampaign?: Maybe<StartCampaign>;
  /**
   * The employee submits the certificate to the employer, either by completing a pending
   * submission task or proactively (a completed task is then created). Who sees the certificate
   * is decided by the notice's state and the customer's named handlers.
   */
  submitSickLeaveCertificateToEmployer: SubmitSickLeaveCertificateToEmployer;
  syncAuthUsersMedical: SyncAuthUsersMedical;
  /**
   * Triggers the Google Calendar booking sync. Run by the Cloud Scheduler job with an
   * API token whose role grants only the narrow mark_health_check_booked permission.
   */
  syncHealthCheckBookings: SyncHealthCheckBookings;
  syncInvoicesSaleExternal: SyncInvoicesSaleExternal;
  terminateContract: TerminateContract;
  /**
   * Removes a (mis)attributed booking from an invitation; an active booking returns
   * to the unmatched list for re-linking or manual removal.
   */
  unlinkHealthCheckInvitationBooking: UnlinkHealthCheckInvitationBooking;
  updateActionPlan: UpdateActionPlan;
  updateAuthUser: AuthUserType;
  updateCampaign?: Maybe<UpdateCampaign>;
  updateClosestSupervisor: UpdateClosestSupervisor;
  updateCompanyAndSetAddresses: UpdateCompanyAndSetAddresses;
  updateCostCenter?: Maybe<UpdateCostCenter>;
  updateCustomer: UpdateCustomer;
  updateCustomerInsurances: UpdateCustomerInsurances;
  updateCustomerInternalNotes: UpdateCustomerInternalNotes;
  updateCustomerInvoicingInformation: UpdateCustomerInvoicingInformation;
  updateCustomerName: UpdateCustomerName;
  updateCustomerServiceSettings?: Maybe<UpdateCustomerServiceSettings>;
  updateCustomerTasks: UpdateCustomerTasks;
  updateDocument?: Maybe<UpdateDocument>;
  updateDocumentCategory?: Maybe<UpdateDocumentCategory>;
  updateDocumentTemplate?: Maybe<UpdateDocumentTemplate>;
  updateDocumentTemplateItem?: Maybe<UpdateDocumentTemplateItem>;
  /**
   * Anonymous counterpart of UpdateMyEmailNotificationSettings behind the emailed link.
   *
   * Possession of the unguessable per-user token is the authorization, so the row is written
   * acting as the token's owner: UserSettings' own owner checks still run, nothing is bypassed.
   * Unknown token returns ok=false and reveals nothing.
   */
  updateEmailNotificationSettingsByToken: EmailNotificationSettingsByTokenPayload;
  updateEmployeeGroup?: Maybe<UpdateEmployeeGroup>;
  updateEmployeeInternalNotes: UpdateEmployeeInternalNotes;
  updateExposure: UpdateExposure;
  updateFitnessTest?: Maybe<UpdateFitnessTest>;
  updateFitnessTestDevice?: Maybe<UpdateFitnessTestDevice>;
  updateHealthcareTeam?: Maybe<UpdateHealthcareTeam>;
  updateInsurance: UpdateInsurance;
  updateInsuranceCompany: UpdateInsuranceCompany;
  updateInvoiceInterface: UpdateInvoiceInterface;
  updateInvoicePurchase?: Maybe<UpdateInvoicePurchase>;
  updateInvoicePurchaseRow?: Maybe<UpdateInvoicePurchaseRow>;
  updateLaboratoryCatalog?: Maybe<UpdateLaboratoryCatalog>;
  updateLaboratorySalesPriceAvailability?: Maybe<UpdateLaboratorySalesPriceAvailability>;
  updateLaboratorySupplier?: Maybe<UpdateLaboratorySupplier>;
  updateLaboratoryTest?: Maybe<UpdateLaboratoryTest>;
  updateMedicalApiToken: UpdateMedicalApiToken;
  updateMedicalPermission?: Maybe<UpdateMedicalPermission>;
  /**
   * Updates the acting user's own email notification switches. Only arguments that are given
   * (non-null) are changed. The row's owner check runs in UserSettings.save().
   */
  updateMyEmailNotificationSettings: UpdateMyEmailNotificationSettings;
  updateNode?: Maybe<UpdateNode>;
  updateNorrePackage?: Maybe<UpdateNorrePackage>;
  updateOwnPersonalInformation?: Maybe<UpdateOwnPersonalInformation>;
  updatePartner: UpdatePartner;
  updatePaymentCommitment: UpdatePaymentCommitment;
  updatePaymentCommitmentPatientInfo?: Maybe<UpdatePaymentCommitmentPatientInfo>;
  updatePermissions?: Maybe<UpdatePermissions>;
  updateProcedure?: Maybe<UpdateProcedure>;
  updateProcedurePartnerPrice?: Maybe<UpdateProcedurePartnerPrice>;
  updateProfessionalGroup?: Maybe<UpdateProfessionalGroup>;
  updateProfileColor: UpdateProfileColor;
  updateProfileName: UpdateProfileName;
  updateProfileParent: UpdateProfileParent;
  updateQuestion?: Maybe<UpdateQuestion>;
  updateReimbursementConversion?: Maybe<UpdateReimbursementConversion>;
  updateSalesCatalog?: Maybe<UpdateSalesCatalog>;
  updateSalesPrice?: Maybe<UpdateSalesPrice>;
  updateSickLeaveCategory?: Maybe<UpdateSickLeaveCategory>;
  /**
   * Updates the diagnosis code of a certificate. Used by occupational health staff to edit
   * a certificate they uploaded without having to replace the file.
   */
  updateSickLeaveCertificate: UpdateSickLeaveCertificate;
  updateSickLeaveHandler: UpdateSickLeaveHandler;
  updateSickLeaveNotice?: Maybe<UpdateSickLeaveNotice>;
  updateSickLeavePeriodSetting?: Maybe<UpdateSickLeavePeriodSetting>;
  updateSickLeaveRecurrentAbsenceThreshold: UpdateSickLeaveRecurrentAbsenceThreshold;
  updateSickLeaveSelfReportReason?: Maybe<UpdateSickLeaveSelfReportReason>;
  updateSickLeaveSettingsCustomer?: Maybe<UpdateSickLeaveSettingsCustomer>;
  updateSupplierPackage?: Maybe<UpdateSupplierPackage>;
  updateTree?: Maybe<UpdateTree>;
  updateUser?: Maybe<UpdateUser>;
  updateUserExposure: UpdateUserExposure;
  updateUserInsurances?: Maybe<UpdateUserInsurances>;
  updateUserRoles?: Maybe<UpdateUserRoles>;
  updateView?: Maybe<UpdateView>;
  updateZefApiToken: UpdateZefapiToken;
};


export type MutationAddCampaignSurveyRespondentArgs = {
  campaignSurveyId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAddHealthCheckArgs = {
  healthCheckInput: HealthCheckInput;
};


export type MutationAddMultiSignatureValueToPrescriptionsArgs = {
  certificate: Scalars['String']['input'];
  prescriptionOidCodes: Array<InputMaybe<Scalars['String']['input']>>;
  signatureId: Scalars['String']['input'];
  signatureValue: Scalars['String']['input'];
};


export type MutationAddPatientArgs = {
  birthDate: Scalars['String']['input'];
  firstNames: Array<InputMaybe<Scalars['String']['input']>>;
  gender: GenderInputType;
  id: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  patientEmail: Scalars['String']['input'];
};


export type MutationAddPaymentCommitmentPurchaseArgs = {
  input: PaymentCommitmentPurchaseInputType;
  paymentCommitmentPurchaseId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAddSignatureValueToPrescriptionArgs = {
  certificate: Scalars['String']['input'];
  prescriptionOid: Scalars['String']['input'];
  signatureId: Scalars['String']['input'];
  signatureValue: Scalars['String']['input'];
};


export type MutationAddSurveyAnswerArgs = {
  answer: Scalars['String']['input'];
  questionId: Scalars['ID']['input'];
  treeResultId: Scalars['ID']['input'];
};


export type MutationAddUserEmploymentInformationArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationAddUserInformationViewReasonLogArgs = {
  otherReason?: InputMaybe<Scalars['String']['input']>;
  viewReasonId: Scalars['ID']['input'];
  viewedUserId: Scalars['ID']['input'];
};


export type MutationApproveInvoicePurchasesArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationBulkCreateAcuteBillableEventsArgs = {
  listOfBillables: Array<AcuteBillableEventInputType>;
};


export type MutationBulkCreateBillablePatientsArgs = {
  listOfBillablePatients: Array<BillablePatientInputType>;
};


export type MutationBulkCreateLaboratoryBillableEventsArgs = {
  listOfLaboratoryBillables: Array<LaboratoryBillableEventInputType>;
};


export type MutationBulkCreatePartnerProcedurePricesArgs = {
  partnerPrices: Array<ProcedurePartnerPriceInput>;
};


export type MutationBulkCreatePartnersArgs = {
  partners: Array<PartnerInput>;
};


export type MutationBulkCreateReimbursementConversionArgs = {
  reimbursementConversions: Array<ReimbursementConversionInputType>;
};


export type MutationBulkCreateUsersArgs = {
  customerId: Scalars['ID']['input'];
  listOfUsers: Array<UserFileUploadFieldsInputType>;
};


export type MutationCancelLaboratoryOrderArgs = {
  laboratoryOrderId: Scalars['ID']['input'];
};


export type MutationChangeLaboratoryOrderArgs = {
  laboratoryOrderId: Scalars['ID']['input'];
};


export type MutationCompleteHealthCheckArgs = {
  completedAt: Scalars['DateTime']['input'];
  completedBy?: InputMaybe<Scalars['ID']['input']>;
  healthCheckId: Scalars['ID']['input'];
};


export type MutationCompleteTaskArgs = {
  completedBy: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};


export type MutationConfirmFetchArgs = {
  newUser?: Scalars['Boolean']['input'];
  site: SiteType;
  uuid: Scalars['UUID']['input'];
};


export type MutationConfirmMedicalFileUploadArgs = {
  fileId: Scalars['ID']['input'];
  ownerRefs?: InputMaybe<MedicalFileOwnerRefs>;
};


export type MutationCreateAcknowledgmentArgs = {
  customerId: Scalars['ID']['input'];
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  type: AcknowledgmentTypeChoices;
  userId: Scalars['ID']['input'];
};


export type MutationCreateActionPlanArgs = {
  customerId: Scalars['ID']['input'];
  dateAccepted?: InputMaybe<Scalars['Date']['input']>;
  dateValidFrom: Scalars['Date']['input'];
  dateValidTo: Scalars['Date']['input'];
  exposureAccident: Scalars['Boolean']['input'];
  exposureBiological: Scalars['Boolean']['input'];
  exposureChemical: Scalars['Boolean']['input'];
  exposureErgonomic: Scalars['Boolean']['input'];
  exposureNightWork: Scalars['Boolean']['input'];
  exposurePhysical: Scalars['Boolean']['input'];
  exposurePsychological: Scalars['Boolean']['input'];
  exposureSocial: Scalars['Boolean']['input'];
  relatedWorkPlaceAssessmentUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationCreateAndSendLaboratoryOrderArgs = {
  laboratoryOid: Scalars['String']['input'];
  laboratoryTestCodes: Array<InputMaybe<LaboratoryTestCodeType>>;
  patientEmail: Scalars['String']['input'];
  professionalId: Scalars['ID']['input'];
  serviceEventId: Scalars['ID']['input'];
};


export type MutationCreateApiTokenArgs = {
  corporateProfiles: Array<Scalars['ID']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  name: Scalars['String']['input'];
  rolesCompany: Array<CreateRoleInfoInputType>;
  rolesCustomer: Array<CreateRoleInfoInputType>;
};


export type MutationCreateAuthUserArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  calledByName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstNames?: InputMaybe<Array<Scalars['String']['input']>>;
  gender?: InputMaybe<Scalars['String']['input']>;
  isCustomerUser?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  nationalId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postArea?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  site: SiteType;
};


export type MutationCreateBranchArgs = {
  branchType?: InputMaybe<BranchBranchTypeChoices>;
  nodeIdLink?: InputMaybe<Scalars['ID']['input']>;
  previousNodeId: Scalars['ID']['input'];
  shorthand?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCampaignArgs = {
  companyId: Scalars['ID']['input'];
  end?: InputMaybe<Scalars['Date']['input']>;
  name: Scalars['String']['input'];
  start?: InputMaybe<Scalars['Date']['input']>;
  templateId: Scalars['ID']['input'];
};


export type MutationCreateChoiceBranchArgs = {
  previousNodeId: Scalars['ID']['input'];
  shorthands?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreateCompanyAndSetAddressesArgs = {
  addresses: Array<InputMaybe<OrgAddressInputType>>;
  businessId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type MutationCreateCostCenterArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  remoteId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCustomerArgs = {
  addresses: Array<InputMaybe<OrgAddressInputType>>;
  businessId: Scalars['String']['input'];
  companyId: Scalars['ID']['input'];
  contactPersons: ContactPersonsInputType;
  eInvoicingAddress: Scalars['String']['input'];
  eInvoicingOperator: Scalars['String']['input'];
  industryCode?: InputMaybe<Scalars['String']['input']>;
  industryName?: InputMaybe<Scalars['String']['input']>;
  invoicingAddressCity: Scalars['String']['input'];
  invoicingAddressPostCode: Scalars['String']['input'];
  invoicingAddressStreetAddress: Scalars['String']['input'];
  marketingName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type MutationCreateCustomerAddressArgs = {
  address: OrgAddressInputType;
  customerId: Scalars['ID']['input'];
};


export type MutationCreateCustomerInvoiceDraftArgs = {
  input: CreateCustomerInvoiceDraftInput;
};


export type MutationCreateCustomerWithContractArgs = {
  contract: ContractBaseInfoInputType;
  customer: CustomerBaseInfoInputType;
};


export type MutationCreateDocumentArgs = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  documentCategoryId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateDocumentCategoryArgs = {
  companyId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  documentCategoryParentId?: InputMaybe<Scalars['ID']['input']>;
  hideOldVersions: Scalars['Boolean']['input'];
  showForCustomerUsers: Scalars['Boolean']['input'];
  showForCustomers: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
};


export type MutationCreateDocumentTemplateArgs = {
  name: Scalars['String']['input'];
  treeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationCreateDocumentTemplateItemArgs = {
  position?: InputMaybe<Scalars['Int']['input']>;
  templateId: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateDocumentVersionArgs = {
  documentId: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
};


export type MutationCreateEmployeeGroupArgs = {
  customerId: Scalars['ID']['input'];
  exposureIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
};


export type MutationCreateEmptyLaboratoryCatalogArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateExposureArgs = {
  exposureInput: ExposureInput;
};


export type MutationCreateFitnessTestArgs = {
  bodyCompositionMeasurementResultInfo: BodyCompositionMeasurementResultInfo;
  fitnessDeviceResultInfo: FitnessDeviceResultInfo;
  patientUuid: Scalars['UUID']['input'];
  testDate: Scalars['Date']['input'];
};


export type MutationCreateFitnessTestDeviceArgs = {
  deviceType: DeviceTypes;
  isDefault: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateHealthCheckContentConfigurationArgs = {
  color?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
};


export type MutationCreateHealthcareTeamArgs = {
  companyId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  healthcareWorkerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationCreateInsuranceCompanyArgs = {
  businessId: Scalars['String']['input'];
  instructions?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateInvoiceInterfaceArgs = {
  apiKey: Scalars['String']['input'];
  apiUser: Scalars['String']['input'];
  companyId: Scalars['ID']['input'];
};


export type MutationCreateInvoicePurchaseCommentArgs = {
  comment: Scalars['String']['input'];
  invoicePurchaseId: Scalars['ID']['input'];
};


export type MutationCreateLaboratoryCatalogBasedOnExistingArgs = {
  basedOnCatalogId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateLaboratorySupplierArgs = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  codeId: Scalars['ID']['input'];
  discountPercent?: InputMaybe<Scalars['Decimal']['input']>;
  name: Scalars['String']['input'];
  parentLaboratoryId?: InputMaybe<Scalars['ID']['input']>;
  phoneNumber: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
  pricePerVisit?: InputMaybe<Scalars['Decimal']['input']>;
};


export type MutationCreateMedicalApiTokenArgs = {
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCreateNorrePackageArgs = {
  contents: Array<InputMaybe<NorrePackageItem>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCreateOrUpdateLaboratorySalesPriceArgs = {
  catalogId: Scalars['ID']['input'];
  modelId: Scalars['ID']['input'];
  modelTypename: LaboratorySalesPriceModelTypenameChoices;
  price: Scalars['Decimal']['input'];
};


export type MutationCreateOrganizationArgs = {
  businessId: Scalars['String']['input'];
  businessName: Scalars['String']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  offices?: InputMaybe<Array<InputMaybe<OfficeInput>>>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreatePartnerArgs = {
  address: Scalars['String']['input'];
  businessId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  phone: Scalars['String']['input'];
};


export type MutationCreatePaymentCommitmentArgs = {
  costLimit: Scalars['Decimal']['input'];
  instructionsForPartner?: InputMaybe<Scalars['String']['input']>;
  invoicesForwardingToCustomer: Scalars['Boolean']['input'];
  kelaActionCategory?: InputMaybe<KelaActionCategoryInput>;
  nationalId: Scalars['String']['input'];
  partnerId: Scalars['ID']['input'];
  proceduresInput: Array<InputMaybe<PaymentCommitmentProcedureInputType>>;
  reimbursementClass: ReimbursementClasses;
  userId: Scalars['ID']['input'];
  validUntil: Scalars['Date']['input'];
};


export type MutationCreatePaymentCommitmentPatientInfoArgs = {
  costLimit: Scalars['Decimal']['input'];
  instructionsForPartner: Scalars['String']['input'];
  kelaActionCategory: KelaActionCategoryInput;
  patientUuid: Scalars['String']['input'];
  paymentCommitmentId: Scalars['String']['input'];
  procedures: Array<InputMaybe<PaymentCommitmentProcedureInputType>>;
  reimbursementClass: ReimbursementClasses;
};


export type MutationCreatePrescriptionArgs = {
  prescriptionArguments: PrescriptionCreationArguments;
};


export type MutationCreateProcedureArgs = {
  customerCanDisableUsage?: InputMaybe<Scalars['Boolean']['input']>;
  customerCanLimitTreatmentSeriesLength?: InputMaybe<Scalars['Boolean']['input']>;
  customerCanLimitYearlyUsage?: InputMaybe<Scalars['Boolean']['input']>;
  isEmployeeBenefit?: InputMaybe<Scalars['Boolean']['input']>;
  isKela0?: InputMaybe<Scalars['Boolean']['input']>;
  isKela1?: InputMaybe<Scalars['Boolean']['input']>;
  isKela2?: InputMaybe<Scalars['Boolean']['input']>;
  isRemote?: InputMaybe<Scalars['Boolean']['input']>;
  kelaReportResourceCategory?: InputMaybe<KelaReportResourceCategoryChoices>;
  name: Scalars['String']['input'];
  partnerServiceId: Scalars['ID']['input'];
  usageLimitControlledByCustomer?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateProcedurePartnerPriceArgs = {
  addAlv: Scalars['Boolean']['input'];
  partnerId: Scalars['ID']['input'];
  price: Scalars['Decimal']['input'];
  procedureId: Scalars['ID']['input'];
};


export type MutationCreateProfessionalGroupArgs = {
  title: Scalars['String']['input'];
};


export type MutationCreateProfileArgs = {
  anyCompany?: InputMaybe<Scalars['Boolean']['input']>;
  anyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  corporate?: InputMaybe<Scalars['Boolean']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  permissionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationCreateQuestionArgs = {
  answerChoices: Array<InputMaybe<Scalars['String']['input']>>;
  answerLimitMaximum?: InputMaybe<Scalars['Int']['input']>;
  answerLimitMinimum?: InputMaybe<Scalars['Int']['input']>;
  answerMultiplier?: InputMaybe<Scalars['Decimal']['input']>;
  answerScores?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  answerType: QuestionAnswerTypeChoices;
  file?: InputMaybe<Scalars['Upload']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  isSlider?: InputMaybe<Scalars['Boolean']['input']>;
  keyType?: InputMaybe<QuestionKeyTypeChoices>;
  mandatory: Scalars['Boolean']['input'];
  matrixQuestionFactors?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  matrixQuestions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: Scalars['String']['input'];
  question: Scalars['String']['input'];
  settingsReady: Scalars['Boolean']['input'];
  sliderStep?: InputMaybe<Scalars['Decimal']['input']>;
  textHelp?: InputMaybe<Scalars['String']['input']>;
  textInfo?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateReimbursementConversionArgs = {
  acuteEventName: Scalars['String']['input'];
  acutePriceListId: Scalars['String']['input'];
  ignoreInKelaReport: Scalars['Boolean']['input'];
  invoicingProductName?: InputMaybe<Scalars['String']['input']>;
  invoicingProductNoExternal?: InputMaybe<Scalars['String']['input']>;
  invoicingUnit?: InputMaybe<Scalars['String']['input']>;
  invoicingUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  invoicingUnitPriceRemote?: InputMaybe<Scalars['Decimal']['input']>;
  isRemote: Scalars['Boolean']['input'];
  kelaOneActionCategory?: InputMaybe<KelaOneActionCategories>;
  kelaOneActivityReportType?: InputMaybe<ActivityReportedChoices>;
  kelaReportResourceCategory?: InputMaybe<KelaReportResourceCategoryChoices>;
  kelaTwoActionCategory?: InputMaybe<KelaTwoActionCategories>;
  kelaTwoActivityReportType?: InputMaybe<ActivityReportedChoices>;
  priceForKela?: InputMaybe<Scalars['Decimal']['input']>;
  reimbursementClass?: InputMaybe<ReimbursementClasses>;
  showInCustomerReport?: InputMaybe<Scalars['Boolean']['input']>;
  titleForCustomer?: InputMaybe<Scalars['String']['input']>;
  useBillableReimbursementClass: Scalars['Boolean']['input'];
  useQuantityMultiplier?: InputMaybe<Scalars['Boolean']['input']>;
  useTimeMultiplier?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateRoleCompanyArgs = {
  companyId: Scalars['ID']['input'];
  profileId: Scalars['ID']['input'];
};


export type MutationCreateRoleCorporateArgs = {
  profileId: Scalars['ID']['input'];
};


export type MutationCreateSalesCatalogArgs = {
  basedOnCatalogId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCreateSalesContractVersionArgs = {
  contractContactPerson?: InputMaybe<ContactPersonInputType>;
  customerId: Scalars['ID']['input'];
  customerReferenceAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  discounts: DiscountsInputType;
  extraServiceIds: Array<InputMaybe<Scalars['ID']['input']>>;
  numberOfPersonsExposure?: InputMaybe<Scalars['Int']['input']>;
  numberOfPersonsNonExposure?: InputMaybe<Scalars['Int']['input']>;
  prices: ContractPricesInputType;
  receptionChoice?: InputMaybe<ReceptionChoices>;
  salesContractId?: InputMaybe<Scalars['ID']['input']>;
  salesPackageId: Scalars['ID']['input'];
  salesmanUserId: Scalars['ID']['input'];
  urlToPdf?: InputMaybe<Scalars['String']['input']>;
  validFrom: Scalars['Date']['input'];
};


export type MutationCreateServiceEventArgs = {
  businessId: Scalars['String']['input'];
  description: Scalars['String']['input'];
  officeNumber: Scalars['Int']['input'];
  patientEmail: Scalars['String']['input'];
  status?: InputMaybe<ServiceEventStatusInputType>;
};


export type MutationCreateSickLeaveCategoryArgs = {
  icd10Codes: Array<InputMaybe<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  overwriteExistingCategoriesCodes?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateSickLeaveHandlerArgs = {
  customerId: Scalars['ID']['input'];
  handlingStartDate?: InputMaybe<Scalars['Date']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  reasons: Array<SickLeaveHandlerReasonChoices>;
  userId: Scalars['ID']['input'];
};


export type MutationCreateSickLeaveNoticeArgs = {
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  acceptedById?: InputMaybe<Scalars['ID']['input']>;
  endDate: Scalars['Date']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  reasonId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Date']['input'];
  typeId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationCreateSickLeavePeriodSettingArgs = {
  allowedSelfReportPeriodMonths: Scalars['Int']['input'];
  allowedSelfReportTimesPerPeriod: Scalars['Int']['input'];
  customerId: Scalars['ID']['input'];
};


export type MutationCreateSickLeaveRecurrentAbsenceThresholdArgs = {
  customerId: Scalars['ID']['input'];
  months: Scalars['Int']['input'];
  periods: Scalars['Int']['input'];
};


export type MutationCreateSickLeaveSelfReportReasonArgs = {
  name: Scalars['String']['input'];
  sickLeaveCategoryId: Scalars['ID']['input'];
};


export type MutationCreateSupplierPackageArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  priceSupplierAndMainTestList?: InputMaybe<Array<InputMaybe<PriceSupplierAndMainTest>>>;
  tests: Array<InputMaybe<TestAndOrder>>;
};


export type MutationCreateTitletemplateArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  template?: InputMaybe<Array<InputMaybe<TitleInputType>>>;
};


export type MutationCreateTreeArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCreateUserArgs = {
  additionalInfo?: InputMaybe<CustomerUserAdditionalInfo>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  contactInfo?: InputMaybe<UserContactInfoInput>;
  contactPerson?: InputMaybe<CustomerUserContactPersonInput>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  employmentInfo?: InputMaybe<UserEmploymentInformationInput>;
  healthCheckInfo?: InputMaybe<CustomerUserHealthCheckInfo>;
  healthcareServices?: InputMaybe<CustomerUserHealthcareServices>;
  healthcareWorkerAdditionalInfo?: InputMaybe<HealthcareWorkerAdditionalInfo>;
  isHealthcareWorker?: InputMaybe<Scalars['Boolean']['input']>;
  personalInfo?: InputMaybe<UserPersonalInfoInput>;
  profileInfo?: InputMaybe<ProfileInfoInput>;
};


export type MutationCreateViewArgs = {
  title: Scalars['String']['input'];
  viewType: ViewViewTypeChoices;
};


export type MutationCreateZefSurveyConfigurationVersionArgs = {
  config: ZefSurveyConfigurationVersionInput;
};


export type MutationDeclineSickLeaveCertificateSubmissionArgs = {
  sickLeaveCertificateId: Scalars['ID']['input'];
};


export type MutationDeleteActionPlanArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteApiTokenArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAuthUserArgs = {
  site: SiteType;
  uuid: Scalars['UUID']['input'];
};


export type MutationDeleteBranchArgs = {
  branchId: Scalars['ID']['input'];
};


export type MutationDeleteCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCostCenterArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDocumentCategoryArgs = {
  documentCategoryIdForFiles?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationDeleteDocumentTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDocumentTemplateItemArgs = {
  id: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};


export type MutationDeleteDocumentVersionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmployeeGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteExposureArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFitnessTestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFitnessTestDeviceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteHealthCheckArgs = {
  healthCheckId: Scalars['ID']['input'];
};


export type MutationDeleteHealthCheckContentConfigurationArgs = {
  contentConfigurationId: Scalars['ID']['input'];
};


export type MutationDeleteHealthcareTeamArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInvoiceInterfaceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLaboratoryCatalogArgs = {
  catalogId: Scalars['ID']['input'];
};


export type MutationDeleteLaboratoryOrderArgs = {
  laboratoryOrderId: Scalars['ID']['input'];
};


export type MutationDeleteLaboratorySalesPriceArgs = {
  catalogId: Scalars['ID']['input'];
  modelId: Scalars['ID']['input'];
  modelTypename: LaboratorySalesPriceModelTypenameChoices;
};


export type MutationDeleteLaboratorySupplierArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMedicalApiTokenArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMedicalFileArgs = {
  fileId: Scalars['ID']['input'];
};


export type MutationDeleteNodeArgs = {
  deleteFollowing?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationDeleteNorrePackageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePartnerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePaymentCommitmentArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeletePaymentCommitmentPurchaseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProcedureArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProcedurePartnerPriceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProfessionalGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProfileArgs = {
  profileId: Scalars['ID']['input'];
};


export type MutationDeleteReimbursementConversionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSalesCatalogArgs = {
  catalogId: Scalars['ID']['input'];
};


export type MutationDeleteSalesInvoiceDraftArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSickLeaveCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSickLeaveHandlerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSickLeaveNoticeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSickLeavePeriodSettingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSickLeaveRecurrentAbsenceThresholdArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSickLeaveSelfReportReasonArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSupplierPackageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTitletemplateArgs = {
  titleTemplateId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteTreeArgs = {
  treeId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteUnmatchedCalendarBookingArgs = {
  unmatchedBookingId: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationDeleteViewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEndCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGetDigestsForMultiSignatureArgs = {
  documentOidCodes: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationGetPdfFormSv98tthArgs = {
  accountingPeriodEnd: Scalars['Date']['input'];
  accountingPeriodStart: Scalars['Date']['input'];
  breakdown?: InputMaybe<Scalars['Boolean']['input']>;
  customerId: Scalars['ID']['input'];
  maximumCosts?: InputMaybe<Scalars['Decimal']['input']>;
};


export type MutationGrantSuitabilityStatementEmployerViewArgs = {
  suitabilityStatementId: Scalars['ID']['input'];
};


export type MutationHandleSickLeaveNoticeArgs = {
  accepted: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationImportPaymentCommitmentsFromExcelArgs = {
  defaultPartnerId?: InputMaybe<Scalars['ID']['input']>;
  file: Scalars['Upload']['input'];
  sheetIndex?: InputMaybe<Scalars['Int']['input']>;
  startRow?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationInsertTempStorageArgs = {
  data: Scalars['String']['input'];
  dataType: DataTypes;
};


export type MutationLinkCalendarBookingToInvitationArgs = {
  invitationId: Scalars['ID']['input'];
  unmatchedBookingId: Scalars['ID']['input'];
};


export type MutationLockLaboratoryCatalogArgs = {
  catalogId: Scalars['ID']['input'];
};


export type MutationLockSalesCatalogArgs = {
  catalogId: Scalars['ID']['input'];
};


export type MutationManualApproveAndSendSalesInvoiceArgs = {
  actualNet: Scalars['Decimal']['input'];
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationMarkHealthCheckBookedManuallyArgs = {
  appointmentEnd?: InputMaybe<Scalars['DateTime']['input']>;
  appointmentStart: Scalars['DateTime']['input'];
  healthCheckId: Scalars['ID']['input'];
};


export type MutationMarkSickLeaveNoticeHandledArgs = {
  id: Scalars['ID']['input'];
};


export type MutationNewSurveyAnswerArgs = {
  treeId: Scalars['ID']['input'];
};


export type MutationOpenHealthCheckInvitationArgs = {
  trackingToken: Scalars['String']['input'];
};


export type MutationPasskeyAuthenticationVerifyArgs = {
  credential: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};


export type MutationPasskeyRegistrationOptionsArgs = {
  passkeyName: Scalars['String']['input'];
};


export type MutationPasskeyRegistrationVerifyArgs = {
  credential: Scalars['String']['input'];
  passkeyName: Scalars['String']['input'];
};


export type MutationPasskeyRevokeArgs = {
  passkeyId: Scalars['Int']['input'];
};


export type MutationPermanentlyDeleteAuthUserArgs = {
  site: SiteType;
  uuid: Scalars['UUID']['input'];
};


export type MutationPermanentlyDeleteUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationPreparePrescriptionForSigningArgs = {
  prescriptionOid: Scalars['String']['input'];
  signatureId: Scalars['String']['input'];
  signatureType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPreparePrescriptionsForMultiSigningArgs = {
  digestOidPairs: Array<InputMaybe<OidDigestPairInput>>;
  signatureId: Scalars['String']['input'];
};


export type MutationQuestionToNodeArgs = {
  nodeId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
};


export type MutationRejectInvoicePurchaseArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRemoveCampaignSurveyRespondentArgs = {
  campaignSurveyId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationReplacePrescriptionArgs = {
  creationArguments: PrescriptionCreationArguments;
  replacingArguments: PrescriptionReplacingArguments;
};


export type MutationRepudiatePrescriptionsArgs = {
  consentType?: InputMaybe<Scalars['String']['input']>;
  exportToFile?: InputMaybe<Scalars['String']['input']>;
  prescriptionOidCodes: Array<InputMaybe<Scalars['String']['input']>>;
  repudiationExplanation?: InputMaybe<Scalars['String']['input']>;
  repudiationReason: Scalars['String']['input'];
  repudiationType: Scalars['String']['input'];
  serviceEventOid: Scalars['String']['input'];
};


export type MutationRequestMedicalFileUploadArgs = {
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  kind: MedicalFileKindChoices;
  ownerRefs: MedicalFileOwnerRefs;
  size: Scalars['Int']['input'];
};


export type MutationRequestSickLeaveCertificateSubmissionArgs = {
  sickLeaveCertificateId: Scalars['ID']['input'];
};


export type MutationResendLaboratoryOrderArgs = {
  laboratoryOrderId: Scalars['ID']['input'];
};


export type MutationRevokeSuitabilityStatementEmployerViewArgs = {
  suitabilityStatementId: Scalars['ID']['input'];
};


export type MutationSaveAnswersArgs = {
  answers: Scalars['JSONString']['input'];
  treeId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSendDocumentToKantaArgs = {
  documentOid: Scalars['String']['input'];
  documentType: KantaDocumentType;
};


export type MutationSendHealthCheckInvitationArgs = {
  healthCheckId: Scalars['ID']['input'];
};


export type MutationSendPrescriptionRepudiationsArgs = {
  repudiationOidCodes: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationSendUserToAcuteArgs = {
  nationalId: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationSetConditionArgs = {
  branchId: Scalars['ID']['input'];
  condition?: InputMaybe<Array<InputMaybe<StatementGroupInput>>>;
  formula?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  shorthand?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetMoontalkCredentialsArgs = {
  token: Scalars['String']['input'];
  tokenName: Scalars['String']['input'];
};


export type MutationSetOwnHealthCheckBookingUrlArgs = {
  bookingPageUrl: Scalars['String']['input'];
  calendarId: Scalars['String']['input'];
};


export type MutationSetPermissionsEqualArgs = {
  anyCompany?: InputMaybe<Scalars['Boolean']['input']>;
  anyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  corporate?: InputMaybe<Scalars['Boolean']['input']>;
  permissionIds: Array<InputMaybe<Scalars['ID']['input']>>;
  profileId: Scalars['ID']['input'];
};


export type MutationSmartCardLoginArgs = {
  cert: Scalars['String']['input'];
  digestMethod: Scalars['String']['input'];
  signatureValue: Scalars['String']['input'];
};


export type MutationStartCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSubmitSickLeaveCertificateToEmployerArgs = {
  sickLeaveCertificateId: Scalars['ID']['input'];
};


export type MutationSyncInvoicesSaleExternalArgs = {
  addRemote: Scalars['Boolean']['input'];
  approve: Scalars['Boolean']['input'];
  invoiceSaleIds: Array<InputMaybe<Scalars['ID']['input']>>;
  sendToCustomer: Scalars['Boolean']['input'];
};


export type MutationTerminateContractArgs = {
  changeReasonExtraInfo: Scalars['String']['input'];
  changeReasonId: Scalars['ID']['input'];
  contractEndDate: Scalars['Date']['input'];
  customerId: Scalars['ID']['input'];
};


export type MutationUnlinkHealthCheckInvitationBookingArgs = {
  invitationId: Scalars['ID']['input'];
};


export type MutationUpdateActionPlanArgs = {
  dateAccepted?: InputMaybe<Scalars['Date']['input']>;
  dateValidFrom?: InputMaybe<Scalars['Date']['input']>;
  dateValidTo?: InputMaybe<Scalars['Date']['input']>;
  exposureAccident?: InputMaybe<Scalars['Boolean']['input']>;
  exposureBiological?: InputMaybe<Scalars['Boolean']['input']>;
  exposureChemical?: InputMaybe<Scalars['Boolean']['input']>;
  exposureErgonomic?: InputMaybe<Scalars['Boolean']['input']>;
  exposureNightWork?: InputMaybe<Scalars['Boolean']['input']>;
  exposurePhysical?: InputMaybe<Scalars['Boolean']['input']>;
  exposurePsychological?: InputMaybe<Scalars['Boolean']['input']>;
  exposureSocial?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  relatedWorkPlaceAssessmentUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationUpdateAuthUserArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  calledByName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstNames?: InputMaybe<Array<Scalars['String']['input']>>;
  gender?: InputMaybe<Scalars['String']['input']>;
  isCustomerUser?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  nationalId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postArea?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  restoreUser?: InputMaybe<Scalars['Boolean']['input']>;
  site: SiteType;
  uuid: Scalars['UUID']['input'];
};


export type MutationUpdateCampaignArgs = {
  end?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  start?: InputMaybe<Scalars['Date']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateClosestSupervisorArgs = {
  setNull?: InputMaybe<Scalars['Boolean']['input']>;
  supervisorId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateCompanyAndSetAddressesArgs = {
  addresses: Array<InputMaybe<OrgAddressInputType>>;
  businessId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCostCenterArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  remoteId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCustomerArgs = {
  accountingPeriodEnd?: InputMaybe<Scalars['Date']['input']>;
  accountingPeriodStart?: InputMaybe<Scalars['Date']['input']>;
  addedToAcuteAt?: InputMaybe<Scalars['DateTime']['input']>;
  addresses?: InputMaybe<Array<InputMaybe<OrgAddressInputType>>>;
  attachmentAddressCity?: InputMaybe<Scalars['String']['input']>;
  attachmentAddressEmail?: InputMaybe<Scalars['String']['input']>;
  attachmentAddressPostCode?: InputMaybe<Scalars['String']['input']>;
  attachmentAddressStreetAddress?: InputMaybe<Scalars['String']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  businessId?: InputMaybe<Scalars['String']['input']>;
  contactPersons?: InputMaybe<ContactPersonsInputType>;
  descriptionOfOperations?: InputMaybe<Scalars['String']['input']>;
  descriptionOfOrganization?: InputMaybe<Scalars['String']['input']>;
  descriptionOfStaff?: InputMaybe<Scalars['String']['input']>;
  dueDateWorkplaceAssessment?: InputMaybe<Scalars['Date']['input']>;
  eInvoicingAddress?: InputMaybe<Scalars['String']['input']>;
  eInvoicingOperator?: InputMaybe<Scalars['String']['input']>;
  entrepreneurInsuranceType?: InputMaybe<EntrepreneurInsuranceType>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  industryCode?: InputMaybe<Scalars['String']['input']>;
  industryName?: InputMaybe<Scalars['String']['input']>;
  insurances?: InputMaybe<Array<InsuranceInputType>>;
  invoicingAddressCity?: InputMaybe<Scalars['String']['input']>;
  invoicingAddressPostCode?: InputMaybe<Scalars['String']['input']>;
  invoicingAddressStreetAddress?: InputMaybe<Scalars['String']['input']>;
  marketingName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  occupationalHealthNeeds?: InputMaybe<Scalars['String']['input']>;
  occupationalSafetyNeeds?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  responsibleDoctorId?: InputMaybe<Scalars['ID']['input']>;
  responsibleNurseId?: InputMaybe<Scalars['ID']['input']>;
  responsibleTeamId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  taxFreeBenefitsInstructionsGiven?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateCustomerInsurancesArgs = {
  entrepreneurInsuranceType?: InputMaybe<EntrepreneurInsuranceType>;
  id: Scalars['ID']['input'];
  insurances?: InputMaybe<Array<InsuranceInputType>>;
  processed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateCustomerInternalNotesArgs = {
  customerId: Scalars['ID']['input'];
  nursing: Scalars['String']['input'];
  occupationalHealthCare: Scalars['String']['input'];
  sales: Scalars['String']['input'];
};


export type MutationUpdateCustomerInvoicingInformationArgs = {
  bic?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<ContactPersonInputType>;
  eInvoicingAddress?: InputMaybe<Scalars['String']['input']>;
  eInvoicingOperator?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  invoicingAddressCity?: InputMaybe<Scalars['String']['input']>;
  invoicingAddressPostCode?: InputMaybe<Scalars['String']['input']>;
  invoicingAddressStreetAddress?: InputMaybe<Scalars['String']['input']>;
  invoicingEmail?: InputMaybe<Scalars['String']['input']>;
  invoicingMethod?: InputMaybe<CustomerInvoicingMethod>;
};


export type MutationUpdateCustomerNameArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateCustomerServiceSettingsArgs = {
  customerId: Scalars['ID']['input'];
  partnerNetworkUsage: Scalars['String']['input'];
  partnerServiceSettings: Array<InputMaybe<PartnerServiceSettingInputType>>;
  processedWith: Scalars['ID']['input'];
  voluntaryHealthCheck: Scalars['Boolean']['input'];
};


export type MutationUpdateCustomerTasksArgs = {
  tasks: Array<CreateTaskInput>;
};


export type MutationUpdateDocumentArgs = {
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDocumentCategoryArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  documentCategoryParentId?: InputMaybe<Scalars['ID']['input']>;
  hideOldVersions?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  showForCustomerUsers?: InputMaybe<Scalars['Boolean']['input']>;
  showForCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDocumentTemplateArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  treeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationUpdateDocumentTemplateItemArgs = {
  condition?: InputMaybe<Array<InputMaybe<StatementGroupInput>>>;
  id: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  templateId: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateEmailNotificationSettingsByTokenArgs = {
  emailSickLeaveCertificateSubmissionRequest?: InputMaybe<Scalars['Boolean']['input']>;
  emailSickLeaveCertificateSubmitted?: InputMaybe<Scalars['Boolean']['input']>;
  emailSickLeaveNoticeCreated?: InputMaybe<Scalars['Boolean']['input']>;
  emailSickLeaveNoticeDecision?: InputMaybe<Scalars['Boolean']['input']>;
  emailSickLeaveNoticePendingApproval?: InputMaybe<Scalars['Boolean']['input']>;
  emailSickLeaveNoticePendingHandling?: InputMaybe<Scalars['Boolean']['input']>;
  emailSickLeaveRecurrentAbsenceThreshold?: InputMaybe<Scalars['Boolean']['input']>;
  token: Scalars['String']['input'];
};


export type MutationUpdateEmployeeGroupArgs = {
  exposureIdsToAdd?: InputMaybe<Array<Scalars['ID']['input']>>;
  exposureIdsToRemove?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateEmployeeInternalNotesArgs = {
  nursing?: InputMaybe<Scalars['String']['input']>;
  occupationalHealthCare?: InputMaybe<Scalars['String']['input']>;
  sales?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateExposureArgs = {
  exposureInput: ExposureInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateFitnessTestArgs = {
  bodyCompositionMeasurementResultInfo: BodyCompositionMeasurementResultInfo;
  fitnessDeviceResultInfo: FitnessDeviceResultInfo;
  id: Scalars['ID']['input'];
  testDate: Scalars['Date']['input'];
};


export type MutationUpdateFitnessTestDeviceArgs = {
  deviceType?: InputMaybe<DeviceTypes>;
  id: Scalars['ID']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateHealthcareTeamArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  healthcareWorkerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id: Scalars['ID']['input'];
};


export type MutationUpdateInsuranceArgs = {
  areInsurancesUpToDate?: InputMaybe<Scalars['Boolean']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  insurance: InsuranceInputType;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userUuid?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateInsuranceCompanyArgs = {
  businessId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  instructions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateInvoiceInterfaceArgs = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  apiUser?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationUpdateInvoicePurchaseArgs = {
  id: Scalars['ID']['input'];
  paymentCommitmentId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateInvoicePurchaseRowArgs = {
  id: Scalars['ID']['input'];
  kelaOneServiceId?: InputMaybe<Scalars['ID']['input']>;
  kelaTwoServiceId?: InputMaybe<Scalars['ID']['input']>;
  serviceId?: InputMaybe<Scalars['ID']['input']>;
  sumGrossOverride?: InputMaybe<Scalars['Decimal']['input']>;
};


export type MutationUpdateLaboratoryCatalogArgs = {
  activeFrom?: InputMaybe<Scalars['Date']['input']>;
  catalogId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateLaboratorySalesPriceAvailabilityArgs = {
  catalogId: Scalars['ID']['input'];
  isAvailable: Scalars['Boolean']['input'];
  modelId: Scalars['ID']['input'];
  modelTypename: LaboratorySalesPriceModelTypenameChoices;
};


export type MutationUpdateLaboratorySupplierArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  discountPercent?: InputMaybe<Scalars['Decimal']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  pricePerVisit?: InputMaybe<Scalars['Decimal']['input']>;
  supplierId: Scalars['ID']['input'];
};


export type MutationUpdateLaboratoryTestArgs = {
  codeId: Scalars['ID']['input'];
  descriptionLong?: InputMaybe<Scalars['String']['input']>;
  descriptionShort?: InputMaybe<Scalars['String']['input']>;
  pricesAndSuppliers: Array<InputMaybe<SupplierAndPrice>>;
};


export type MutationUpdateMedicalApiTokenArgs = {
  id: Scalars['ID']['input'];
  permissions: Array<Scalars['ID']['input']>;
};


export type MutationUpdateMedicalPermissionArgs = {
  medicalPermissionId: Scalars['ID']['input'];
  profileIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationUpdateMyEmailNotificationSettingsArgs = {
  emailSickLeaveCertificateSubmissionRequest?: InputMaybe<Scalars['Boolean']['input']>;
  emailSickLeaveCertificateSubmitted?: InputMaybe<Scalars['Boolean']['input']>;
  emailSickLeaveNoticeCreated?: InputMaybe<Scalars['Boolean']['input']>;
  emailSickLeaveNoticeDecision?: InputMaybe<Scalars['Boolean']['input']>;
  emailSickLeaveNoticePendingApproval?: InputMaybe<Scalars['Boolean']['input']>;
  emailSickLeaveNoticePendingHandling?: InputMaybe<Scalars['Boolean']['input']>;
  emailSickLeaveRecurrentAbsenceThreshold?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateNodeArgs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  groupLabelsToCreate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id: Scalars['ID']['input'];
  nodeIdLink?: InputMaybe<Scalars['ID']['input']>;
  questionOverride?: InputMaybe<Scalars['String']['input']>;
  shorthand?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateNorrePackageArgs = {
  contents: Array<InputMaybe<NorrePackageItem>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateOwnPersonalInformationArgs = {
  ownPersonalInformation?: InputMaybe<UserOwnPersonalInformationInputType>;
  userId: Scalars['ID']['input'];
};


export type MutationUpdatePartnerArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  businessId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdatePaymentCommitmentArgs = {
  costLimit: Scalars['Decimal']['input'];
  instructionsForPartner?: InputMaybe<Scalars['String']['input']>;
  invoicesForwardingToCustomer: Scalars['Boolean']['input'];
  kelaActionCategory?: InputMaybe<KelaActionCategoryInput>;
  partnerId: Scalars['ID']['input'];
  paymentCommitmentId: Scalars['ID']['input'];
  proceduresInput: Array<InputMaybe<PaymentCommitmentProcedureInputType>>;
  reimbursementClass: ReimbursementClasses;
  validUntil: Scalars['Date']['input'];
};


export type MutationUpdatePaymentCommitmentPatientInfoArgs = {
  costLimit: Scalars['Decimal']['input'];
  instructionsForPartner: Scalars['String']['input'];
  kelaActionCategory: KelaActionCategoryInput;
  paymentCommitmentId: Scalars['String']['input'];
  procedures: Array<InputMaybe<PaymentCommitmentProcedureInputType>>;
  reimbursementClass: ReimbursementClasses;
};


export type MutationUpdatePermissionsArgs = {
  deniedPermissionIds: Array<InputMaybe<Scalars['ID']['input']>>;
  grantedPermissionIds: Array<InputMaybe<Scalars['ID']['input']>>;
  profileId: Scalars['ID']['input'];
};


export type MutationUpdateProcedureArgs = {
  customerCanDisableUsage?: InputMaybe<Scalars['Boolean']['input']>;
  customerCanLimitTreatmentSeriesLength?: InputMaybe<Scalars['Boolean']['input']>;
  customerCanLimitYearlyUsage?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  isEmployeeBenefit?: InputMaybe<Scalars['Boolean']['input']>;
  isKela0?: InputMaybe<Scalars['Boolean']['input']>;
  isKela1?: InputMaybe<Scalars['Boolean']['input']>;
  isKela2?: InputMaybe<Scalars['Boolean']['input']>;
  isRemote?: InputMaybe<Scalars['Boolean']['input']>;
  kelaReportResourceCategory?: InputMaybe<KelaReportResourceCategoryChoices>;
  name?: InputMaybe<Scalars['String']['input']>;
  usageLimitControlledByCustomer?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateProcedurePartnerPriceArgs = {
  addAlv?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  price?: InputMaybe<Scalars['Decimal']['input']>;
};


export type MutationUpdateProfessionalGroupArgs = {
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateProfileColorArgs = {
  color?: InputMaybe<Scalars['String']['input']>;
  profileId: Scalars['ID']['input'];
};


export type MutationUpdateProfileNameArgs = {
  name: Scalars['String']['input'];
  profileId: Scalars['ID']['input'];
};


export type MutationUpdateProfileParentArgs = {
  parentId?: InputMaybe<Scalars['ID']['input']>;
  profileId: Scalars['ID']['input'];
};


export type MutationUpdateQuestionArgs = {
  answerChoices?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  answerLimitMaximum?: InputMaybe<Scalars['Int']['input']>;
  answerLimitMinimum?: InputMaybe<Scalars['Int']['input']>;
  answerMultiplier?: InputMaybe<Scalars['Decimal']['input']>;
  answerScores?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  answerType?: InputMaybe<QuestionAnswerTypeChoices>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['ID']['input'];
  identifier?: InputMaybe<Scalars['String']['input']>;
  isSlider?: InputMaybe<Scalars['Boolean']['input']>;
  keyType?: InputMaybe<QuestionKeyTypeChoices>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  matrixQuestionFactors?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  matrixQuestions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  settingsReady?: InputMaybe<Scalars['Boolean']['input']>;
  sliderStep?: InputMaybe<Scalars['Decimal']['input']>;
  textHelp?: InputMaybe<Scalars['String']['input']>;
  textInfo?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateReimbursementConversionArgs = {
  acuteEventName?: InputMaybe<Scalars['String']['input']>;
  acutePriceListId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  ignoreInKelaReport?: InputMaybe<Scalars['Boolean']['input']>;
  invoicingProductName?: InputMaybe<Scalars['String']['input']>;
  invoicingProductNoExternal?: InputMaybe<Scalars['String']['input']>;
  invoicingUnit?: InputMaybe<Scalars['String']['input']>;
  invoicingUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  invoicingUnitPriceRemote?: InputMaybe<Scalars['Decimal']['input']>;
  isRemote?: InputMaybe<Scalars['Boolean']['input']>;
  kelaOneActionCategory?: InputMaybe<KelaOneActionCategories>;
  kelaOneActivityReportType?: InputMaybe<ActivityReportedChoices>;
  kelaReportResourceCategory?: InputMaybe<KelaReportResourceCategoryChoices>;
  kelaTwoActionCategory?: InputMaybe<KelaTwoActionCategories>;
  kelaTwoActivityReportType?: InputMaybe<ActivityReportedChoices>;
  priceForKela?: InputMaybe<Scalars['Decimal']['input']>;
  reimbursementClass?: InputMaybe<ReimbursementClasses>;
  showInCustomerReport?: InputMaybe<Scalars['Boolean']['input']>;
  titleForCustomer?: InputMaybe<Scalars['String']['input']>;
  useBillableReimbursementClass?: InputMaybe<Scalars['Boolean']['input']>;
  useQuantityMultiplier?: InputMaybe<Scalars['Boolean']['input']>;
  useTimeMultiplier?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateSalesCatalogArgs = {
  activeFrom?: InputMaybe<Scalars['Date']['input']>;
  catalogId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateSalesPriceArgs = {
  customerPricePerMonth?: InputMaybe<Scalars['Decimal']['input']>;
  discountType?: InputMaybe<Scalars['String']['input']>;
  salesPriceId: Scalars['ID']['input'];
  userPricePerMonth?: InputMaybe<Scalars['Decimal']['input']>;
};


export type MutationUpdateSickLeaveCategoryArgs = {
  icd10Codes: Array<InputMaybe<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  overwriteExistingCategoriesCodes?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateSickLeaveCertificateArgs = {
  icd10Code?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationUpdateSickLeaveHandlerArgs = {
  handlingStartDate?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  organization?: InputMaybe<Scalars['String']['input']>;
  reasons: Array<SickLeaveHandlerReasonChoices>;
};


export type MutationUpdateSickLeaveNoticeArgs = {
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  acceptedById?: InputMaybe<Scalars['ID']['input']>;
  endDate: Scalars['Date']['input'];
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  reasonId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Date']['input'];
  typeId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUpdateSickLeavePeriodSettingArgs = {
  allowedSelfReportPeriodMonths?: InputMaybe<Scalars['Int']['input']>;
  allowedSelfReportTimesPerPeriod?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationUpdateSickLeaveRecurrentAbsenceThresholdArgs = {
  id: Scalars['ID']['input'];
  months?: InputMaybe<Scalars['Int']['input']>;
  periods?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateSickLeaveSelfReportReasonArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  sickLeaveCategoryId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateSickLeaveSettingsCustomerArgs = {
  allowedSelfReportDurationContinuously?: InputMaybe<Scalars['Int']['input']>;
  allowedSelfReportDurationPerNotification?: InputMaybe<Scalars['Int']['input']>;
  allowedSelfReportReasonIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  alwaysRequestCertificateSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  customerId: Scalars['ID']['input'];
  prolongedAbsenceThresholdDays?: InputMaybe<Scalars['Int']['input']>;
  selfReportAdditionalInstructions?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateSupplierPackageArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  priceSupplierAndMainTestList: Array<InputMaybe<PriceSupplierAndMainTest>>;
  tests: Array<InputMaybe<TestAndOrder>>;
};


export type MutationUpdateTreeArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  endText?: InputMaybe<Scalars['String']['input']>;
  endTitle?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  welcomeText?: InputMaybe<Scalars['String']['input']>;
  welcomeTitle?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserArgs = {
  additionalInfo?: InputMaybe<CustomerUserAdditionalInfo>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  contactInfo?: InputMaybe<UserContactInfoInput>;
  contactPerson?: InputMaybe<CustomerUserContactPersonInput>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  employmentInfo?: InputMaybe<UserEmploymentInformationInput>;
  healthCheckInfo?: InputMaybe<CustomerUserHealthCheckInfo>;
  healthcareServices?: InputMaybe<CustomerUserHealthcareServices>;
  healthcareWorkerAdditionalInfo?: InputMaybe<HealthcareWorkerAdditionalInfo>;
  isCorporateUser?: InputMaybe<Scalars['Boolean']['input']>;
  isHealthcareWorker?: InputMaybe<Scalars['Boolean']['input']>;
  personalInfo?: InputMaybe<UserPersonalInfoInput>;
  restoreUser?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateUserExposureArgs = {
  hasExposure: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUpdateUserInsurancesArgs = {
  insurances?: InputMaybe<Array<InsuranceInputType>>;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateUserRolesArgs = {
  corporateProfileIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  roleCompanyIdsToRemove?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  roleCorporateIdsToRemove?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  roleCustomerIdsToRemove?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  rolesCompanyToAdd?: InputMaybe<Array<InputMaybe<CreateRoleInfoInputType>>>;
  rolesCustomerToAdd?: InputMaybe<Array<InputMaybe<CreateRoleInfoInputType>>>;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateViewArgs = {
  id: Scalars['ID']['input'];
  permissionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  viewType?: InputMaybe<ViewViewTypeChoices>;
};


export type MutationUpdateZefApiTokenArgs = {
  token: Scalars['String']['input'];
};

export type NewSurveyAnswer = {
  __typename?: 'NewSurveyAnswer';
  treeResult?: Maybe<TreeResultType>;
};

export type NodeGroupType = {
  __typename?: 'NodeGroupType';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  nodes: Array<NodeType>;
  tag: Scalars['String']['output'];
};

export type NodeType = {
  __typename?: 'NodeType';
  groups: Array<NodeGroupType>;
  id: Scalars['ID']['output'];
  link?: Maybe<NodeType>;
  links: Array<NodeType>;
  nextBranches: Array<BranchType>;
  previousBranch?: Maybe<BranchType>;
  question?: Maybe<QuestionType>;
  questionOverride: Scalars['String']['output'];
  rootOfTree?: Maybe<TreeType>;
  shorthand: Scalars['String']['output'];
  tag: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type NorrePackageItem = {
  codeId?: InputMaybe<Scalars['ID']['input']>;
  order: Scalars['Int']['input'];
  supplierPackageId?: InputMaybe<Scalars['ID']['input']>;
};

export type NorrePackagePrice = {
  __typename?: 'NorrePackagePrice';
  price?: Maybe<Scalars['Decimal']['output']>;
  supplier: LaboratorySupplierType;
};

export type NorrePackagePriceWithPackage = AddNorrePackageInterface & {
  __typename?: 'NorrePackagePriceWithPackage';
  norrePackage: NorrePackageType;
  prices: Array<NorrePackagePrice>;
};

export type NorrePackageTestType = {
  __typename?: 'NorrePackageTestType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  laboratoryTest?: Maybe<LaboratoryTestType>;
  norrePackage: NorrePackageType;
  order: Scalars['Int']['output'];
  supplierPackage?: Maybe<SupplierPackageType>;
};

export type NorrePackageType = {
  __typename?: 'NorrePackageType';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  norrepackagetestSet: Array<NorrePackageTestType>;
  salesPrices: Array<LaboratoryCatalogSalesPriceType>;
};

export type OidDigestPair = {
  __typename?: 'OIDDigestPair';
  /** Digest of the document. */
  digest: Scalars['String']['output'];
  /** Unique identifier of the document. */
  oid: Scalars['String']['output'];
};

export type OidDigestPairInput = {
  /** Digest of the document. */
  digest: Scalars['String']['input'];
  /** Unique identifier of the document. */
  oid: Scalars['String']['input'];
};

export type OfficeInput = {
  city: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orderNumber: Scalars['Int']['input'];
  postalCode: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
};

export type OfficeOutput = {
  __typename?: 'OfficeOutput';
  city: Scalars['String']['output'];
  name: Scalars['String']['output'];
  orderNumber: Scalars['Int']['output'];
  postalCode: Scalars['String']['output'];
  streetAddress: Scalars['String']['output'];
};

/**
 * Anonymous mutation behind the emailed invitation link.
 *
 * No authenticated user: possession of the unguessable tracking token is the
 * authorization. Writes only the plain-model tracking row (no permission machinery)
 * and reveals nothing but the booking page URL.
 */
export type OpenHealthCheckInvitation = {
  __typename?: 'OpenHealthCheckInvitation';
  bookingUrl?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type OrgAddressInputType = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isPrimary: Scalars['Boolean']['input'];
  phone: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
};

export type Organization = {
  __typename?: 'Organization';
  businessId: Scalars['String']['output'];
  businessName: Scalars['String']['output'];
  city: Scalars['String']['output'];
  offices?: Maybe<Array<Maybe<OfficeOutput>>>;
  postalCode: Scalars['String']['output'];
  professionals: Array<Professional>;
  serviceeventSet: Array<ServiceEvent>;
  streetAddress: Scalars['String']['output'];
};

/** An enumeration. */
export enum OrganizationsContactPersonContactTypeChoices {
  /** Contract */
  Contract = 'CONTRACT',
  /** Invoicing */
  Invoicing = 'INVOICING',
  /** Occupational Health */
  OccupationalHealth = 'OCCUPATIONAL_HEALTH'
}

/** An enumeration. */
export enum OrganizationsCustomerEntrepreneurInsuranceTypeChoices {
  /** Myel */
  Myel = 'MYEL',
  /** Yel */
  Yel = 'YEL'
}

/** An enumeration. */
export enum OrganizationsCustomerInvoicingMethodChoices {
  /** Email */
  Email = 'EMAIL',
  /** E Invoice */
  EInvoice = 'E_INVOICE',
  /** Post */
  Post = 'POST'
}

/** Value belongs to codesystem 1.2.246.537.5.40118 values. */
export type PkvType = {
  __typename?: 'PKVType';
  code: Scalars['String']['output'];
  codeSystem?: Maybe<CodeSystemType>;
  displayName: Scalars['String']['output'];
};

export type PackageAmountArguments = {
  /** Specifies assigned drug packages amount. */
  packageAmount: Scalars['Int']['input'];
};

export type PackageDetailsArguments = {
  /** Specifies drug amount in package or package size. */
  quantity: Scalars['Float']['input'];
  /** Specifies unit for drug quantity. */
  unit: Scalars['String']['input'];
};

export type PartnerInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  businessId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentBusinessId?: InputMaybe<Scalars['String']['input']>;
  parentPartnerName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerOrError = {
  __typename?: 'PartnerOrError';
  created: Scalars['Boolean']['output'];
  error?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<PartnerType>;
  updated: Scalars['Boolean']['output'];
};

/** An enumeration. */
export enum PartnerServiceChoices {
  Dental = 'DENTAL',
  ExaminationsConsultations = 'EXAMINATIONS_CONSULTATIONS',
  Other = 'OTHER',
  Physiotherapist = 'PHYSIOTHERAPIST',
  Procedure = 'PROCEDURE',
  Psychologist = 'PSYCHOLOGIST',
  Psychotherapy = 'PSYCHOTHERAPY'
}

export type PartnerServiceSettingInputType = {
  id: Scalars['ID']['input'];
  maximumLengthTreatmentSeries?: InputMaybe<Scalars['Int']['input']>;
  maximumUsagePerYear?: InputMaybe<Scalars['Int']['input']>;
  usageAllowed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartnerServiceSettingType = {
  __typename?: 'PartnerServiceSettingType';
  createdAt: Scalars['DateTime']['output'];
  customerServiceSetting: CustomerServiceSettingsType;
  id: Scalars['ID']['output'];
  maximumLengthTreatmentSeries?: Maybe<Scalars['Int']['output']>;
  maximumUsagePerYear?: Maybe<Scalars['Int']['output']>;
  procedure: ProcedureType;
  usageAllowed: Scalars['Boolean']['output'];
};

export type PartnerServiceType = {
  __typename?: 'PartnerServiceType';
  id: Scalars['ID']['output'];
  procedureSet: Array<ProcedureType>;
  serviceType: PartnerservicesPartnerServiceServiceTypeChoices;
};

export type PartnerServiceUsage = {
  __typename?: 'PartnerServiceUsage';
  amountUsed: Scalars['Int']['output'];
  ongoingTreatmentSeriesLength?: Maybe<Scalars['Int']['output']>;
  procedureId?: Maybe<Scalars['ID']['output']>;
  serviceType?: Maybe<PartnerServiceChoices>;
  treatmentSeriesLimit?: Maybe<Scalars['Int']['output']>;
  treatmentSeriesMaxLength?: Maybe<Scalars['Int']['output']>;
  treatmentSeriesUsed: Scalars['Int']['output'];
};

export type PartnerType = {
  __typename?: 'PartnerType';
  address: Scalars['String']['output'];
  businessId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  partnerChildren: Array<PartnerType>;
  partnerParent?: Maybe<PartnerType>;
  paymentCommitments: Array<PaymentCommitmentType>;
  phone: Scalars['String']['output'];
  procedurepartnerpriceSet: Array<ProcedurePartnerPriceType>;
};

/** An enumeration. */
export enum PartnerservicesCustomerServiceSettingsPartnerNetworkUsageChoices {
  /** Full */
  Full = 'FULL',
  /** Limited */
  Limited = 'LIMITED'
}

/** An enumeration. */
export enum PartnerservicesPartnerServiceServiceTypeChoices {
  /** Dental */
  Dental = 'DENTAL',
  /** Examinations Consultations */
  ExaminationsConsultations = 'EXAMINATIONS_CONSULTATIONS',
  /** Other */
  Other = 'OTHER',
  /** Physiotherapist */
  Physiotherapist = 'PHYSIOTHERAPIST',
  /** Procedure */
  Procedure = 'PROCEDURE',
  /** Psychologist */
  Psychologist = 'PSYCHOLOGIST',
  /** Psychotherapy */
  Psychotherapy = 'PSYCHOTHERAPY'
}

/** An enumeration. */
export enum PartnerservicesProcedureKelaReportResourceCategoryChoices {
  /** Agriculture */
  Agriculture = 'AGRICULTURE',
  /** Doctor */
  Doctor = 'DOCTOR',
  /** Ergonomics */
  Ergonomics = 'ERGONOMICS',
  /** Exercise */
  Exercise = 'EXERCISE',
  /** Hygiene */
  Hygiene = 'HYGIENE',
  /** Imaging */
  Imaging = 'IMAGING',
  /** Laboratory */
  Laboratory = 'LABORATORY',
  /** Nurse */
  Nurse = 'NURSE',
  /** Nutrition */
  Nutrition = 'NUTRITION',
  /** Other Costs */
  OtherCosts = 'OTHER_COSTS',
  /** Physiotherapist */
  Physiotherapist = 'PHYSIOTHERAPIST',
  /** Psychologist */
  Psychologist = 'PSYCHOLOGIST',
  /** Social */
  Social = 'SOCIAL',
  /** Specialist */
  Specialist = 'SPECIALIST',
  /** Speech Therapy */
  SpeechTherapy = 'SPEECH_THERAPY',
  /** Technical */
  Technical = 'TECHNICAL',
  /** Vision */
  Vision = 'VISION'
}

export type PasskeyAuthResult = {
  __typename?: 'PasskeyAuthResult';
  accessExpires: Scalars['String']['output'];
  refreshExpires: Scalars['String']['output'];
};

export type PasskeyType = {
  __typename?: 'PasskeyType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type PatientGeneralInfo = {
  __typename?: 'PatientGeneralInfo';
  birthDate?: Maybe<Scalars['Date']['output']>;
  familyName: Scalars['String']['output'];
  firstNames: Array<Maybe<Scalars['String']['output']>>;
};

export type PatientIdentificationInput = {
  /** Gives a free explanation of the identification method. Required if method code is 9(=custom method) */
  explanation?: InputMaybe<Scalars['String']['input']>;
  /** Identification method, the value belongs to codeserver 1.2.246.537.5.40109 codes. */
  methodCode: Scalars['String']['input'];
};

export type PatientIdentificationOutput = {
  __typename?: 'PatientIdentificationOutput';
  /** Gives a free explanation of the identification method. Required if method code is 9(=custom method) */
  explanation?: Maybe<Scalars['String']['output']>;
  /** Identification method, the value belongs to codeserver 1.2.246.537.5.40109 codes. */
  methodCode: Scalars['String']['output'];
};

/** Value belongs to codesystem 1.2.246.537.5.40109 values. */
export type PatientIdentificationType = {
  __typename?: 'PatientIdentificationType';
  code: Scalars['String']['output'];
  codeSystem?: Maybe<CodeSystemType>;
  displayName: Scalars['String']['output'];
};

/** An enumeration. */
export enum PatientPatientGenderChoices {
  /** male */
  A_1 = 'A_1',
  /** female */
  A_2 = 'A_2',
  /** unknown */
  A_3 = 'A_3',
  /** undefined */
  A_9 = 'A_9'
}

export type PatientType = {
  __typename?: 'PatientType';
  billableEvents: Array<BillablePatientType>;
  birthDate?: Maybe<Scalars['Date']['output']>;
  calledByName?: Maybe<Scalars['String']['output']>;
  firstNames: Array<Scalars['String']['output']>;
  fitnessTests: Array<FitnessTestType>;
  gender: PatientPatientGenderChoices;
  id: Scalars['ID']['output'];
  laboratoryorderSet: Array<LaboratoryOrderType>;
  lastName: Scalars['String']['output'];
  paymentCommitmentInfos: Array<PaymentCommitmentPatientInfoType>;
  personalId?: Maybe<Scalars['String']['output']>;
  serviceeventSet: Array<ServiceEvent>;
  user: MedicalUserType;
};

export type PaymentCommitmentActionLogType = {
  __typename?: 'PaymentCommitmentActionLogType';
  action: PaymentcommitmentsPaymentCommitmentActionLogActionChoices;
  id: Scalars['ID']['output'];
  paymentCommitment: PaymentCommitmentType;
  reason: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  user: UserType;
};

export type PaymentCommitmentPatientInfoType = {
  __typename?: 'PaymentCommitmentPatientInfoType';
  costLimit: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  instructionsForPartner: Scalars['String']['output'];
  kelaActionCategory?: Maybe<PaymentcommitmentPaymentCommitmentPatientInfoKelaActionCategoryChoices>;
  patient?: Maybe<PatientType>;
  paymentCommitmentId?: Maybe<Scalars['ID']['output']>;
  procedures: Array<PaymentCommitmentProcedureType>;
  reimbursementClass: PaymentcommitmentPaymentCommitmentPatientInfoReimbursementClassChoices;
};

export type PaymentCommitmentProcedureInputType = {
  amount: Scalars['Int']['input'];
  procedureId: Scalars['String']['input'];
  procedureName?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentCommitmentProcedureType = {
  __typename?: 'PaymentCommitmentProcedureType';
  amount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  paymentCommitmentPatientInfo: PaymentCommitmentPatientInfoType;
  procedure: ProcedureType;
  procedureId: Scalars['Int']['output'];
};

/**
 * Aggregate type, no direct model — one stats row (dict) carrying the queried company_id;
 * every field resolver verifies the company report permission before returning a value.
 */
export type PaymentCommitmentPurchaseCategoryStatsType = {
  __typename?: 'PaymentCommitmentPurchaseCategoryStatsType';
  averageAmount: Scalars['Decimal']['output'];
  category: Scalars['String']['output'];
  medianAmount: Scalars['Decimal']['output'];
  purchaseCount: Scalars['Int']['output'];
  totalAmount: Scalars['Decimal']['output'];
};

export type PaymentCommitmentPurchaseInputType = {
  amount: Scalars['Decimal']['input'];
  customerId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  invoiceDate: Scalars['Date']['input'];
  paymentCommitmentId: Scalars['ID']['input'];
};

export type PaymentCommitmentPurchaseType = {
  __typename?: 'PaymentCommitmentPurchaseType';
  amount: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer: CustomerType;
  id: Scalars['ID']['output'];
  invoiceDate: Scalars['Date']['output'];
  invoiceDescription: Scalars['String']['output'];
  paymentCommitment: PaymentCommitmentType;
  paymentCommitmentSalesInvoiceRow?: Maybe<PaymentCommitmentSalesInvoiceRowType>;
};

export type PaymentCommitmentSalesInvoiceRowType = {
  __typename?: 'PaymentCommitmentSalesInvoiceRowType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invoiceRow: InvoiceSaleRowType;
  paymentCommitmentPurchase: PaymentCommitmentPurchaseType;
};

export type PaymentCommitmentType = {
  __typename?: 'PaymentCommitmentType';
  addVat: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  invoicedAmount: Scalars['Decimal']['output'];
  invoicedFromCustomerAmount: Scalars['Decimal']['output'];
  invoicesForwardingToCustomer: Scalars['Boolean']['output'];
  parent?: Maybe<PaymentCommitmentType>;
  partner: PartnerType;
  paymentCommitmentPatientInfo: PaymentCommitmentPatientInfoType;
  paymentcommitmentSet: Array<PaymentCommitmentType>;
  paymentcommitmentactionlogSet: Array<PaymentCommitmentActionLogType>;
  paymentcommitmentpurchaseSet: Array<PaymentCommitmentPurchaseType>;
  referenceNumber: Scalars['String']['output'];
  user: UserType;
  validUntil: Scalars['Date']['output'];
};

/** An enumeration. */
export enum PaymentcommitmentPaymentCommitmentPatientInfoKelaActionCategoryChoices {
  /** Custom Health Check */
  CustomHealthCheck = 'CUSTOM_HEALTH_CHECK',
  /** Exposure Health Check */
  ExposureHealthCheck = 'EXPOSURE_HEALTH_CHECK',
  /** Group Advice And Guidance */
  GroupAdviceAndGuidance = 'GROUP_ADVICE_AND_GUIDANCE',
  /** Individual Advice And Guidance */
  IndividualAdviceAndGuidance = 'INDIVIDUAL_ADVICE_AND_GUIDANCE',
  /** Medical Care */
  MedicalCare = 'MEDICAL_CARE',
  /** Other Healthcare */
  OtherHealthcare = 'OTHER_HEALTHCARE',
  /** Workplace Assessment */
  WorkplaceAssessment = 'WORKPLACE_ASSESSMENT'
}

/** An enumeration. */
export enum PaymentcommitmentPaymentCommitmentPatientInfoReimbursementClassChoices {
  /** Kela One */
  KelaOne = 'KELA_ONE',
  /** Kela Two */
  KelaTwo = 'KELA_TWO',
  /** Kela Zero */
  KelaZero = 'KELA_ZERO'
}

/** An enumeration. */
export enum PaymentcommitmentsPaymentCommitmentActionLogActionChoices {
  /** Copy Text */
  CopyText = 'COPY_TEXT',
  /** Create Pdf */
  CreatePdf = 'CREATE_PDF',
  /** Edit */
  Edit = 'EDIT',
  /** Send Email */
  SendEmail = 'SEND_EMAIL'
}

export type PermanentlyDeleteUser = {
  __typename?: 'PermanentlyDeleteUser';
  userId?: Maybe<Scalars['ID']['output']>;
};

/** An enumeration. */
export enum PermissionChoices {
  AddActionplan = 'add_actionplan',
  AddAcuteeventconversion = 'add_acuteeventconversion',
  AddAllSickLeaveNotices = 'add_all_sick_leave_notices',
  AddAlv = 'add_alv',
  AddApitoken = 'add_apitoken',
  AddCampaign = 'add_campaign',
  AddCdadocument = 'add_cdadocument',
  AddCertificateSickLeaveNotices = 'add_certificate_sick_leave_notices',
  AddCompany = 'add_company',
  AddContenttype = 'add_contenttype',
  AddCostbenchmark = 'add_costbenchmark',
  AddCostcenter = 'add_costcenter',
  AddCustomer = 'add_customer',
  AddCustomerinternalnotes = 'add_customerinternalnotes',
  AddDocument = 'add_document',
  AddDocumenttemplate = 'add_documenttemplate',
  AddEmployeegroup = 'add_employeegroup',
  AddEmployeeinternalnotes = 'add_employeeinternalnotes',
  AddExposure = 'add_exposure',
  AddExternalSickLeaveCertificate = 'add_external_sick_leave_certificate',
  AddFitnesstestdevice = 'add_fitnesstestdevice',
  AddGroup = 'add_group',
  AddHealthcareteam = 'add_healthcareteam',
  AddHealthcheckinvitationtracking = 'add_healthcheckinvitationtracking',
  AddInsurance = 'add_insurance',
  AddInvoiceinterface = 'add_invoiceinterface',
  AddInvoicelogpurchase = 'add_invoicelogpurchase',
  AddInvoicelogsale = 'add_invoicelogsale',
  AddInvoicepurchase = 'add_invoicepurchase',
  AddInvoicesale = 'add_invoicesale',
  AddLaboratorycatalog = 'add_laboratorycatalog',
  AddLaboratorysupplier = 'add_laboratorysupplier',
  AddLaboratorytest = 'add_laboratorytest',
  AddLogentry = 'add_logentry',
  AddPartner = 'add_partner',
  AddPaymentcommitment = 'add_paymentcommitment',
  AddPermission = 'add_permission',
  AddPreviousHealthCheckInfo = 'add_previous_health_check_info',
  AddProcedure = 'add_procedure',
  AddProfile = 'add_profile',
  AddSalescatalog = 'add_salescatalog',
  AddSalescontract = 'add_salescontract',
  AddSickleavecategory = 'add_sickleavecategory',
  AddSickleavecertificate = 'add_sickleavecertificate',
  AddSickleavenotice = 'add_sickleavenotice',
  AddSickleavesettingscustomer = 'add_sickleavesettingscustomer',
  AddSickleavetype = 'add_sickleavetype',
  AddSubordinateSickLeaveNotices = 'add_subordinate_sick_leave_notices',
  AddSubordinateUser = 'add_subordinate_user',
  AddSuitabilitystatement = 'add_suitabilitystatement',
  AddTask = 'add_task',
  AddTempstorage = 'add_tempstorage',
  AddTitletemplate = 'add_titletemplate',
  AddTree = 'add_tree',
  AddTreeresult = 'add_treeresult',
  AddUser = 'add_user',
  AddUsernotificationsettingstoken = 'add_usernotificationsettingstoken',
  AddView = 'add_view',
  ChangeActionplan = 'change_actionplan',
  ChangeAcuteeventconversion = 'change_acuteeventconversion',
  ChangeAlv = 'change_alv',
  ChangeCampaign = 'change_campaign',
  ChangeCdadocument = 'change_cdadocument',
  ChangeCertificateSickLeaveNotices = 'change_certificate_sick_leave_notices',
  ChangeCompany = 'change_company',
  ChangeContenttype = 'change_contenttype',
  ChangeCostcenter = 'change_costcenter',
  ChangeCustomer = 'change_customer',
  ChangeCustomerinternalnotes = 'change_customerinternalnotes',
  ChangeCustomerservicesettings = 'change_customerservicesettings',
  ChangeDocument = 'change_document',
  ChangeDocumenttemplate = 'change_documenttemplate',
  ChangeEmployeegroup = 'change_employeegroup',
  ChangeEmployeeinternalnotes = 'change_employeeinternalnotes',
  ChangeExposure = 'change_exposure',
  ChangeFitnesstestdevice = 'change_fitnesstestdevice',
  ChangeGroup = 'change_group',
  ChangeHealthcareteam = 'change_healthcareteam',
  ChangeHealthcheck = 'change_healthcheck',
  ChangeHealthcheckinvitationtracking = 'change_healthcheckinvitationtracking',
  ChangeInsurance = 'change_insurance',
  ChangeInsurancecompany = 'change_insurancecompany',
  ChangeInvoicePurchaseRowSumOverride = 'change_invoice_purchase_row_sum_override',
  ChangeInvoiceinterface = 'change_invoiceinterface',
  ChangeInvoicelogpurchase = 'change_invoicelogpurchase',
  ChangeInvoicelogsale = 'change_invoicelogsale',
  ChangeInvoicepurchase = 'change_invoicepurchase',
  ChangeInvoicesale = 'change_invoicesale',
  ChangeLaboratorycatalog = 'change_laboratorycatalog',
  ChangeLaboratorysupplier = 'change_laboratorysupplier',
  ChangeLaboratorytest = 'change_laboratorytest',
  ChangeLogentry = 'change_logentry',
  ChangePartner = 'change_partner',
  ChangePaymentcommitment = 'change_paymentcommitment',
  ChangePermission = 'change_permission',
  ChangeProcedure = 'change_procedure',
  ChangeProfile = 'change_profile',
  ChangeSalescatalog = 'change_salescatalog',
  ChangeSalescontract = 'change_salescontract',
  ChangeSickleavecategory = 'change_sickleavecategory',
  ChangeSickleavecertificate = 'change_sickleavecertificate',
  ChangeSickleavenotice = 'change_sickleavenotice',
  ChangeSickleavesettingscustomer = 'change_sickleavesettingscustomer',
  ChangeSickleavetype = 'change_sickleavetype',
  ChangeSubordinateSickLeaveNotices = 'change_subordinate_sick_leave_notices',
  ChangeSubordinateUser = 'change_subordinate_user',
  ChangeTask = 'change_task',
  ChangeTitletemplate = 'change_titletemplate',
  ChangeTree = 'change_tree',
  ChangeTreeresult = 'change_treeresult',
  ChangeUser = 'change_user',
  ChangeUsernotificationsettingstoken = 'change_usernotificationsettingstoken',
  ChangeView = 'change_view',
  ChangeZefapitoken = 'change_zefapitoken',
  CompleteAssignedTasks = 'complete_assigned_tasks',
  ComputeCostBenchmarks = 'compute_cost_benchmarks',
  ConfigureHealthChecks = 'configure_health_checks',
  ConfigureZefSurveys = 'configure_zef_surveys',
  DeleteActionplan = 'delete_actionplan',
  DeleteAcuteeventconversion = 'delete_acuteeventconversion',
  DeleteAlv = 'delete_alv',
  DeleteApitoken = 'delete_apitoken',
  DeleteCampaign = 'delete_campaign',
  DeleteCdadocument = 'delete_cdadocument',
  DeleteCertificateSickLeaveNotices = 'delete_certificate_sick_leave_notices',
  DeleteCompany = 'delete_company',
  DeleteContenttype = 'delete_contenttype',
  DeleteCostbenchmark = 'delete_costbenchmark',
  DeleteCostcenter = 'delete_costcenter',
  DeleteCustomer = 'delete_customer',
  DeleteCustomerinternalnotes = 'delete_customerinternalnotes',
  DeleteDocument = 'delete_document',
  DeleteDocumenttemplate = 'delete_documenttemplate',
  DeleteEmployeegroup = 'delete_employeegroup',
  DeleteEmployeeinternalnotes = 'delete_employeeinternalnotes',
  DeleteExposure = 'delete_exposure',
  DeleteFitnesstestdevice = 'delete_fitnesstestdevice',
  DeleteGroup = 'delete_group',
  DeleteHealthcareteam = 'delete_healthcareteam',
  DeleteHealthcheckinvitationtracking = 'delete_healthcheckinvitationtracking',
  DeleteInsurance = 'delete_insurance',
  DeleteInvoiceinterface = 'delete_invoiceinterface',
  DeleteInvoicelogpurchase = 'delete_invoicelogpurchase',
  DeleteInvoicelogsale = 'delete_invoicelogsale',
  DeleteInvoicepurchase = 'delete_invoicepurchase',
  DeleteInvoicesale = 'delete_invoicesale',
  DeleteLaboratorycatalog = 'delete_laboratorycatalog',
  DeleteLaboratorysupplier = 'delete_laboratorysupplier',
  DeleteLaboratorytest = 'delete_laboratorytest',
  DeleteLogentry = 'delete_logentry',
  DeletePartner = 'delete_partner',
  DeletePaymentcommitment = 'delete_paymentcommitment',
  DeletePermission = 'delete_permission',
  DeleteProcedure = 'delete_procedure',
  DeleteProfile = 'delete_profile',
  DeleteSalescatalog = 'delete_salescatalog',
  DeleteSalescontract = 'delete_salescontract',
  DeleteSickleavecategory = 'delete_sickleavecategory',
  DeleteSickleavecertificate = 'delete_sickleavecertificate',
  DeleteSickleavenotice = 'delete_sickleavenotice',
  DeleteSickleavesettingscustomer = 'delete_sickleavesettingscustomer',
  DeleteSickleavetype = 'delete_sickleavetype',
  DeleteSubordinateSickLeaveNotices = 'delete_subordinate_sick_leave_notices',
  DeleteSubordinateUser = 'delete_subordinate_user',
  DeleteSuitabilitystatement = 'delete_suitabilitystatement',
  DeleteTask = 'delete_task',
  DeleteTitletemplate = 'delete_titletemplate',
  DeleteTree = 'delete_tree',
  DeleteTreeresult = 'delete_treeresult',
  DeleteUser = 'delete_user',
  DeleteUsernotificationsettingstoken = 'delete_usernotificationsettingstoken',
  DeleteView = 'delete_view',
  DeleteZefapitoken = 'delete_zefapitoken',
  HandleAllSickLeaveNotices = 'handle_all_sick_leave_notices',
  ManageChildRolesUser = 'manage_child_roles_user',
  ManageCustomerAddresses = 'manage_customer_addresses',
  ManageMoontalkCredentials = 'manage_moontalk_credentials',
  ManageUserRoles = 'manage_user_roles',
  ManageZefsurveycampaign = 'manage_zefsurveycampaign',
  MarkHealthCheckBooked = 'mark_health_check_booked',
  ViewActionplan = 'view_actionplan',
  ViewAcuteeventconversion = 'view_acuteeventconversion',
  ViewAllSickLeaveNotices = 'view_all_sick_leave_notices',
  ViewAlv = 'view_alv',
  ViewApitoken = 'view_apitoken',
  ViewAssignedTasks = 'view_assigned_tasks',
  ViewCampaign = 'view_campaign',
  ViewCareGuidance = 'view_care_guidance',
  ViewCdadocument = 'view_cdadocument',
  ViewCompany = 'view_company',
  ViewContenttype = 'view_contenttype',
  ViewCostReport = 'view_cost_report',
  ViewCostbenchmark = 'view_costbenchmark',
  ViewCostcenter = 'view_costcenter',
  ViewCustomer = 'view_customer',
  ViewCustomerinternalnotes = 'view_customerinternalnotes',
  ViewCustomerservicesettings = 'view_customerservicesettings',
  ViewDocument = 'view_document',
  ViewDocumenttemplate = 'view_documenttemplate',
  ViewEmployeePermittedSuitabilityStatements = 'view_employee_permitted_suitability_statements',
  ViewEmployeegroup = 'view_employeegroup',
  ViewEmployeeinternalnotes = 'view_employeeinternalnotes',
  ViewExposure = 'view_exposure',
  ViewFitnesstestdevice = 'view_fitnesstestdevice',
  ViewGroup = 'view_group',
  ViewHealthcareteam = 'view_healthcareteam',
  ViewHealthcheck = 'view_healthcheck',
  ViewHealthcheckinvitationtracking = 'view_healthcheckinvitationtracking',
  ViewInsurance = 'view_insurance',
  ViewInvoiceinterface = 'view_invoiceinterface',
  ViewInvoicelogpurchase = 'view_invoicelogpurchase',
  ViewInvoicelogsale = 'view_invoicelogsale',
  ViewInvoicepurchase = 'view_invoicepurchase',
  ViewInvoicesale = 'view_invoicesale',
  ViewLaboratorycatalog = 'view_laboratorycatalog',
  ViewLaboratorysupplier = 'view_laboratorysupplier',
  ViewLaboratorytest = 'view_laboratorytest',
  ViewLogacutebillableentry = 'view_logacutebillableentry',
  ViewLogacuteusersync = 'view_logacuteusersync',
  ViewLogentry = 'view_logentry',
  ViewLogmoontalkusersync = 'view_logmoontalkusersync',
  ViewLogzefsurveysusersync = 'view_logzefsurveysusersync',
  ViewMoontalkReports = 'view_moontalk_reports',
  ViewPartner = 'view_partner',
  ViewPaymentcommitment = 'view_paymentcommitment',
  ViewPermission = 'view_permission',
  ViewProcedure = 'view_procedure',
  ViewProfile = 'view_profile',
  ViewRolecompany = 'view_rolecompany',
  ViewRolecorporate = 'view_rolecorporate',
  ViewRolecustomer = 'view_rolecustomer',
  ViewSalescatalog = 'view_salescatalog',
  ViewSalescontract = 'view_salescontract',
  ViewSalespackage = 'view_salespackage',
  ViewSickleavecertificate = 'view_sickleavecertificate',
  ViewSickleavenotice = 'view_sickleavenotice',
  ViewSickleavesettingscustomer = 'view_sickleavesettingscustomer',
  ViewSubordinateSickLeaveNotices = 'view_subordinate_sick_leave_notices',
  ViewSubordinateUser = 'view_subordinate_user',
  ViewSuitabilitystatement = 'view_suitabilitystatement',
  ViewTask = 'view_task',
  ViewTitletemplate = 'view_titletemplate',
  ViewTree = 'view_tree',
  ViewTreeresult = 'view_treeresult',
  ViewUser = 'view_user',
  ViewUserinformationviewlog = 'view_userinformationviewlog',
  ViewUsernotificationsettingstoken = 'view_usernotificationsettingstoken',
  ViewView = 'view_view',
  ViewZefapitoken = 'view_zefapitoken',
  ViewZefsurveycampaign = 'view_zefsurveycampaign',
  ViewZefsurveycampaignstatus = 'view_zefsurveycampaignstatus'
}

export type PermissionType = {
  __typename?: 'PermissionType';
  codename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  profiles: Array<ProfileType>;
  views: Array<ViewType>;
};

export type PreparePrescriptionForSigning = {
  __typename?: 'PreparePrescriptionForSigning';
  /** Digest to be signed with a smartcard */
  digest: Scalars['String']['output'];
  /** Prepared prescription OID-code */
  oid: Scalars['String']['output'];
};

export type PreparePrescriptionsForMultiSigning = {
  __typename?: 'PreparePrescriptionsForMultiSigning';
  /** Digest of multisignature to be send to smartcard reader. */
  digest: Scalars['String']['output'];
  /** Prepared documents where signature value should added after signing digest in smartcard reader. */
  preparedDocumentOidCodes: Array<Maybe<Scalars['String']['output']>>;
};

export type PrepareSmartCardLogin = {
  __typename?: 'PrepareSmartCardLogin';
  challenge: Scalars['String']['output'];
};

/** An enumeration. */
export enum PrescriptionClassification {
  DrugRegisterExternal = 'DRUG_REGISTER_EXTERNAL',
  DrugRegisterInternal = 'DRUG_REGISTER_INTERNAL',
  Extempore = 'EXTEMPORE'
}

export type PrescriptionCreationArguments = {
  /** Arguments specified for each type of prescription. */
  commonArguments: PrescriptionCreationCommonArguments;
  /** Arguments that should be defined or undefined depending on prescription classification and assigned amount representation type. */
  specificArguments: PrescriptionCreationTypeSpecificArguments;
};

export type PrescriptionCreationCommonArguments = {
  /** Whether medicine is assigned by determining drug package amount, medicine total amount or for time period. */
  assignedAmountRepresentation: AssignedAmountRepresentation;
  /** The professional who is doing current replacing operation */
  authorId: Scalars['String']['input'];
  /** Whether medicine is dosed using dose distribution. */
  doseDistribution: Scalars['Boolean']['input'];
  /** Not related to kanta, specifies shorthand of dosing which is displayed in medicinelist to help professionals get good overview of medication quickly.. */
  dosingShorthand?: InputMaybe<Scalars['String']['input']>;
  /** Describes how should medicine being used/dosed */
  dosingText: Scalars['String']['input'];
  /** Whether is allowed to use different but similar drug instead of the assigned medicine. */
  drugExchangeProhibition: ProhibitionInput;
  drugIsUnderInfectiousDiseaseLaw: Scalars['Boolean']['input'];
  /** Expiration date of the new prescription */
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  /** Specifies filename where prescription is exported in CDAR2 format (as xml file). */
  exportToFile?: InputMaybe<Scalars['String']['input']>;
  /** Describes the desirable effect of medicine. */
  indication: Scalars['String']['input'];
  /** Specifies medication repetition details if repetition wanted. */
  iteration?: InputMaybe<IterationInput>;
  /** Free text for pharmacy. */
  messageToPharmacy?: InputMaybe<Scalars['String']['input']>;
  /** Patient identification method. Required if drug is narcotic(if is_narcotic param is true or drug register internal medicine is marked as narcotic in medicine database). */
  patientIdentification?: InputMaybe<PatientIdentificationInput>;
  /** Whether medicine is planned to take permanently */
  permanentMedicine: Scalars['Boolean']['input'];
  /** Whether medicine is in drug register, not in drug register or custom mixture. */
  prescriptionClassification: PrescriptionClassification;
  /** Whether medicine can be renewed or not. */
  prohibitionOfRenewal: ProhibitionInput;
  /** The service event the current replacing is related to. */
  serviceEventOid: Scalars['String']['input'];
  /** If the dosing of the medicine is different for normal usage. */
  sic: Scalars['Boolean']['input'];
  startingOfUsage: Scalars['Boolean']['input'];
  /** Classifies a general reason of current caring operation, the value belongs to codeserver 1.2.246.537.5.40101 codes. */
  typeOfCaring: Scalars['String']['input'];
  /** Not related to kanta. Specifies if medicine is used continuously, fixed term or only if necessary. */
  usageType?: InputMaybe<MedicineUsageInputType>;
};

export type PrescriptionCreationTypeSpecificArguments = {
  /** Not necessary for drug register internal medicines, the value belongs to codeserver 1.2.246.537.5.40118 codes */
  PKV?: InputMaybe<Scalars['String']['input']>;
  /** Only necessary for drug register external products */
  drugRegisterExternal?: InputMaybe<DrugRegisterExternalPrescriptionCreationArguments>;
  /** Only necessary if prescription classification is DRUG_REGISTER_INTERNAL */
  drugRegisterInternal?: InputMaybe<DrugRegisterInternalPrescriptionCreationArguments>;
  /** Only necessary for extempore prescriptions */
  extempore?: InputMaybe<ExtemporePrescriptionCreationArguments>;
  /** Not necessary for drug register internal medicines. */
  isNarcotic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only necessary if assigned amount representation is PACKAGES. */
  packageAmount?: InputMaybe<PackageAmountArguments>;
  /** Only necessary if assigned amount representation is PACKAGES and prescription classification is not DRUG_REGISTER_EXTERNAL */
  packageDetails?: InputMaybe<PackageDetailsArguments>;
  /** Only necessary if assigned amount representation is TIME. */
  timePeriod?: InputMaybe<TimePeriodArguments>;
  /** Only necessary if assigned amount representation is TOTAL_AMOUNT. */
  totalAmount?: InputMaybe<TotalAmountArguments>;
};

/** Value belongs to codesystem 1.2.246.537.5.40105 values. */
export type PrescriptionMessageType = {
  __typename?: 'PrescriptionMessageType';
  code: Scalars['String']['output'];
  codeSystem?: Maybe<CodeSystemType>;
  displayName: Scalars['String']['output'];
};

export type PrescriptionMetadata = {
  __typename?: 'PrescriptionMetadata';
  /** VNR code of the assigned medicine. Only defined if specific drug package is assigned from drug register. */
  VNR?: Maybe<Scalars['String']['output']>;
  /** Medicine active status, the value belongs to codeserver 1.2.246.537.5.40300 values */
  activeStatus?: Maybe<Scalars['String']['output']>;
  /** The value belongs to codeserver 1.2.246.537.5.40301 values. */
  archiveStatus?: Maybe<Scalars['String']['output']>;
  assignedAmount?: Maybe<Scalars['String']['output']>;
  /** Whether prescription assigned amount is defined by total amount, time period of drug package amount. */
  assignedAmountRepresentation?: Maybe<AssignedAmountRepresentation>;
  /** General info of the author who has created the prescription. */
  assignedBy: AuthorGeneralInfo;
  /** The date prescription was created. */
  assignedOn?: Maybe<Scalars['DateTime']['output']>;
  /** ATC code of the assigned medicine main active ingredient. */
  atcCode?: Maybe<Scalars['String']['output']>;
  /** Current status of medicine delivery, the value belongs to codeserver 1.2.246.537.5.40123 codes */
  deliveryStatus?: Maybe<Scalars['String']['output']>;
  doseDistribution: Scalars['Boolean']['output'];
  /** Shorthand of the dosing text, for example 1x2 = One dose twice per day */
  dosingShorthand?: Maybe<Scalars['String']['output']>;
  dosingText?: Maybe<Scalars['String']['output']>;
  /** If assigned amount is defined by drug package, tells package size, unit etc. */
  drugPackage?: Maybe<DrugPackageInfo>;
  expirationDate?: Maybe<Scalars['Date']['output']>;
  /** If the assigned medicine is prepared in pharmacy(=extempore prescription) */
  extemporePrescription: Scalars['Boolean']['output'];
  /** Name of the assigned medicine main active ingredient. */
  ingredientName?: Maybe<Scalars['String']['output']>;
  /** Intensity of the assigned medicine. */
  intensity?: Maybe<Scalars['String']['output']>;
  /** If prescription iterated, defines iteration unit, iteration times and iteration width. */
  iteration?: Maybe<IterationOutput>;
  /** Date of the last dispense of the medicine. */
  lastDispensed?: Maybe<Scalars['Date']['output']>;
  /** Assigned medicine name. */
  medicineName?: Maybe<Scalars['String']['output']>;
  /** Prescription message type, the value belongs to codeserver 1.2.246.537.5.40105 codes */
  messageType: Scalars['String']['output'];
  /** OID code of the document. */
  oid: Scalars['String']['output'];
  /** Original document OID code. Also called set id. Tells the oid code of the first version of the prescription this document is related to. */
  originalDocument: Scalars['String']['output'];
  /** If assigned amount is defined by drug package, tells amount of assigned packages. */
  packageAmount?: Maybe<Scalars['Int']['output']>;
  /** If medication assigned by this prescription is meant to be permanent. */
  permanentMedicine: Scalars['Boolean']['output'];
  /** Pharmaceutical form of the assigned medicine. */
  pharmaceuticalForm?: Maybe<Scalars['String']['output']>;
  /** Information of the previous dispense. */
  previousDispense?: Maybe<Scalars['String']['output']>;
  /** Tells what for medicine is assigned. */
  purposeOfUsage?: Maybe<Scalars['String']['output']>;
  /** Unused amount of the prescription not given to patient. */
  remainingQuantity?: Maybe<Scalars['String']['output']>;
  /** Whether drug renewal is prohibited. */
  renewalProhibition: Scalars['Boolean']['output'];
  /** Value belongs to codeserver 1.2.246.537.5.40106 values. */
  renewalStatus?: Maybe<Scalars['String']['output']>;
  /** SIC should be set to true if drug dosing is unusual compared to normal way use of assigned medicine. */
  sic: Scalars['Boolean']['output'];
  /** If assigned amount is defined by time period, tells time period length and unit. */
  timePeriod?: Maybe<MedicationPeriodInfo>;
  /** If assigned amount is defined by total amount, tells assigned amount quantity and unit */
  totalAmount?: Maybe<TotalAmountInfo>;
  /** Tells whether medicine is assigned to use continuously, if necessary or fixed term */
  usageType?: Maybe<MedicineUsageType>;
  /** Version number of the document. */
  versionNumber: Scalars['String']['output'];
};

/** Value belongs to codesystem 1.2.246.537.6.600 values. */
export type PrescriptionRenewalProhibitionReasonType = {
  __typename?: 'PrescriptionRenewalProhibitionReasonType';
  code: Scalars['String']['output'];
  codeSystem?: Maybe<CodeSystemType>;
  displayName: Scalars['String']['output'];
};

export type PrescriptionReplacingArguments = {
  /** Replaced prescription id. */
  replacedPrescriptionOid: Scalars['String']['input'];
  /** Specify reason of presccription replaced, the value belongs to codeserver 1.2.246.537.6.600 codes. */
  replacementReasonCode: Scalars['String']['input'];
  /** Free explanation of the replacement reason. Should be decined if replacement reason code is 5(=custom reason) */
  replacementReasonExplanation?: InputMaybe<Scalars['String']['input']>;
};

/** Value belongs to codesystem 1.2.246.537.5.40103 values. */
export type PrescriptionRepudiationType = {
  __typename?: 'PrescriptionRepudiationType';
  code: Scalars['String']['output'];
  codeSystem?: Maybe<CodeSystemType>;
  displayName: Scalars['String']['output'];
};

export type PrescriptionState = {
  __typename?: 'PrescriptionState';
  PKV?: Maybe<Scalars['String']['output']>;
  argumentToNotUseCheapestBiologicalMedicine?: Maybe<Scalars['String']['output']>;
  assignedAmountRepresentation: AssignedAmountRepresentation;
  assignedBy?: Maybe<AuthorGeneralInfo>;
  doseDistribution: Scalars['Boolean']['output'];
  dosingShorthand?: Maybe<Scalars['String']['output']>;
  dosingText: Scalars['String']['output'];
  drugExchangeProhibition: Scalars['Boolean']['output'];
  drugIsUnderInfectiousDiseaseLaw: Scalars['Boolean']['output'];
  drugPackageDetails?: Maybe<DrugPackageDetailsState>;
  drugRegisterInternalMedicineAssignedType?: Maybe<DrugRegisterInternalMedicineAssign>;
  indication: Scalars['String']['output'];
  ingredients?: Maybe<Array<Maybe<IngredientOutput>>>;
  isNarcotic?: Maybe<Scalars['Boolean']['output']>;
  iteration?: Maybe<IterationOutput>;
  messageToPharmacy?: Maybe<Scalars['String']['output']>;
  messageType: Scalars['String']['output'];
  mixtureName?: Maybe<Scalars['String']['output']>;
  oid: Scalars['String']['output'];
  originalDocument: Scalars['String']['output'];
  packageAmount?: Maybe<Scalars['Int']['output']>;
  packageId?: Maybe<Scalars['Int']['output']>;
  patientIdentification?: Maybe<PatientIdentificationOutput>;
  permanentMedicine: Scalars['Boolean']['output'];
  preparationGuide?: Maybe<Scalars['String']['output']>;
  prescriptionClassification: PrescriptionClassification;
  productName?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  prohibitionOfRenewal: ProhibitionOutput;
  sic: Scalars['Boolean']['output'];
  specialClarificationCode?: Maybe<Scalars['String']['output']>;
  specialClarificationDate?: Maybe<Scalars['Date']['output']>;
  startingOfUsage: Scalars['Boolean']['output'];
  timePeriod?: Maybe<TimePeriodState>;
  totalAmount?: Maybe<TotalAmountState>;
  typeOfCaring: Scalars['String']['output'];
  usageType?: Maybe<MedicineUsageType>;
  validFrom: Scalars['DateTime']['output'];
  validTo?: Maybe<Scalars['DateTime']['output']>;
  versionNumber: Scalars['String']['output'];
};

/** Value belongs to codesystem 1.2.246.537.6.605 values. */
export type PrescriptionTypeDefinition = {
  __typename?: 'PrescriptionTypeDefinition';
  OID?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  codeSystem?: Maybe<CodeSystemType>;
  displayName: Scalars['String']['output'];
};

export type PriceSupplierAndMainTest = {
  mainTest: Scalars['Int']['input'];
  price?: InputMaybe<Scalars['Decimal']['input']>;
  supplierId: Scalars['ID']['input'];
};

export type ProcedurePartnerPriceInput = {
  allowKelaOne: Scalars['Boolean']['input'];
  allowKelaTwo: Scalars['Boolean']['input'];
  allowKelaZero: Scalars['Boolean']['input'];
  isRemote: Scalars['Boolean']['input'];
  kelaCategory?: InputMaybe<KelaReportResourceCategoryChoices>;
  name: Scalars['String']['input'];
  partnerBusinessId: Scalars['String']['input'];
  partnerName?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  serviceCategory: PartnerServiceChoices;
};

export type ProcedurePartnerPriceOrError = {
  __typename?: 'ProcedurePartnerPriceOrError';
  created: Scalars['Boolean']['output'];
  error?: Maybe<Scalars['String']['output']>;
  procedurePrice?: Maybe<ProcedurePartnerPriceType>;
  updated: Scalars['Boolean']['output'];
};

export type ProcedurePartnerPriceType = {
  __typename?: 'ProcedurePartnerPriceType';
  addAlv: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  partner: PartnerType;
  price: Scalars['Decimal']['output'];
  procedure: ProcedureType;
};

export type ProcedureType = {
  __typename?: 'ProcedureType';
  createdAt: Scalars['DateTime']['output'];
  customerCanDisableUsage: Scalars['Boolean']['output'];
  customerCanLimitTreatmentSeriesLength: Scalars['Boolean']['output'];
  customerCanLimitYearlyUsage: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isEmployeeBenefit: Scalars['Boolean']['output'];
  isKela0: Scalars['Boolean']['output'];
  isKela1: Scalars['Boolean']['output'];
  isKela2: Scalars['Boolean']['output'];
  isRemote: Scalars['Boolean']['output'];
  kelaReportResourceCategory?: Maybe<PartnerservicesProcedureKelaReportResourceCategoryChoices>;
  name: Scalars['String']['output'];
  partnerService: PartnerServiceType;
  partnerServiceSettings: Array<PartnerServiceSettingType>;
  procedurepartnerpriceSet: Array<ProcedurePartnerPriceType>;
  usageLimitControlledByCustomer: Scalars['Boolean']['output'];
};

export type Professional = {
  __typename?: 'Professional';
  credentials?: Maybe<MedicalUserType>;
  education?: Maybe<Array<Maybe<EducationOutput>>>;
  email?: Maybe<Scalars['String']['output']>;
  firstNames: Array<Scalars['String']['output']>;
  laboratoryorderSet: Array<LaboratoryOrderType>;
  lastName: Scalars['String']['output'];
  organizations: Array<Organization>;
  professionalId: Scalars['String']['output'];
  suffix: Scalars['String']['output'];
  svCode: Scalars['String']['output'];
  termsOfUseAgreement: Scalars['Boolean']['output'];
};

export type ProfessionalGroupType = {
  __typename?: 'ProfessionalGroupType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  taskSet: Array<TaskType>;
  title: Scalars['String']['output'];
  userSet: Array<UserType>;
};

/** Value belongs to codesystem 1.2.246.537.6.140 values. */
export type ProfessionalRightType = {
  __typename?: 'ProfessionalRightType';
  code: Scalars['String']['output'];
  codeSystem?: Maybe<CodeSystemType>;
  displayName: Scalars['String']['output'];
};

export type ProfileInfoInput = {
  companyProfileId?: InputMaybe<Scalars['ID']['input']>;
  corporateProfileId?: InputMaybe<Scalars['ID']['input']>;
  customerProfileId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProfileType = {
  __typename?: 'ProfileType';
  anyCompany: Scalars['Boolean']['output'];
  anyCustomer: Scalars['Boolean']['output'];
  /** Enter a color in hex format, like #RRGGBB. */
  color?: Maybe<Scalars['String']['output']>;
  company?: Maybe<CompanyType>;
  corporate: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<CustomerType>;
  directChildProfiles: Array<ProfileType>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<ProfileType>;
  permissions: Array<PermissionType>;
  rolecompanySet: Array<RoleCompanyType>;
  rolecorporateSet: Array<RoleCorporateType>;
  rolecustomerSet: Array<RoleCustomerType>;
};

export type ProhibitionInput = {
  isProhibited: Scalars['Boolean']['input'];
  reasonCode?: InputMaybe<Scalars['String']['input']>;
  reasonText?: InputMaybe<Scalars['String']['input']>;
};

export type ProhibitionOutput = {
  __typename?: 'ProhibitionOutput';
  isProhibited: Scalars['Boolean']['output'];
  reasonCode?: Maybe<Scalars['String']['output']>;
  reasonText?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /** Return all codes of codesystem 1.2.246.537.5.40118. */
  PKVs: Array<PkvType>;
  /** Apollo Federation typename */
  Query_Typename?: Maybe<Scalars['String']['output']>;
  _entities: Array<Maybe<_Entity>>;
  _service: _Service;
  actionPlan: ActionPlanType;
  actionPlans: Array<ActionPlanType>;
  activeLaboratoryCatalog?: Maybe<LaboratoryCatalogType>;
  activeSalesCatalog?: Maybe<SalesCatalogType>;
  /** Return all codes of codesystem 1.2.246.537.5.40300. */
  activeStatuses: Array<ActiveStatus>;
  /** Returns all the different package choices of the original medicine. Trade name and active ingredient do not change but package size can be varied. */
  alternativePackages: Array<DrugType>;
  alv: AlvType;
  apiTokens: Array<ApiTokenType>;
  /** Return all codes of codesystem 1.2.246.537.5.40301. */
  archiveStatuses: Array<ArchiveStatus>;
  availableBalanceForUser: Scalars['Decimal']['output'];
  availablePartnerServiceUsageForUser: UserPartnerServiceUsage;
  billableEventReportPeriods: Array<BillableReportPeriodType>;
  billablePatientReportPeriods: Array<BillableReportPeriodType>;
  billablePatientUserUuids: Array<Scalars['UUID']['output']>;
  billablePatientUsers: Array<BillablePatientUserRowType>;
  billablePatients: Array<Maybe<BillablePatientType>>;
  billableReportEvents: Array<BillableReportEventType>;
  billableReportPatients: Array<BillableReportPatientType>;
  billables: Array<Maybe<BillableType>>;
  billablesOfCustomers: Array<Maybe<BillableType>>;
  /** Return drug packages which belong to given medicinal groups. */
  biosimilars: Array<DrugType>;
  canCreateSickLeaveNoticesForAll: Scalars['Boolean']['output'];
  canViewCostReport: Scalars['Boolean']['output'];
  canViewSickLeaveHistory: Scalars['Boolean']['output'];
  canViewSickLeaveReports: Scalars['Boolean']['output'];
  /** Marketing site: read-only, non-personal care guidance summary of an employer of the person behind the email or phone number. Give exactly one of the two. */
  careGuidance?: Maybe<CareGuidanceType>;
  /** Marketing site: employers of the person behind the email or phone number that have an ongoing contract. Give exactly one of the two. */
  careGuidanceCustomers: Array<CareGuidanceCustomerType>;
  /** Return all codes of codesystem 1.2.246.537.5.40101. */
  caringtypes: Array<CaringType>;
  checkIcd10CodesUsedInOtherSickLeaveCategories: Scalars['Boolean']['output'];
  checkInfoForGeneratingSv98tth: Array<Maybe<Scalars['String']['output']>>;
  childProfilesForUser: ProfileType;
  companiesForCorporate: Array<CompanyType>;
  company: CompanyType;
  companyAddresses: Array<CompanyAddressType>;
  companyProfiles: Array<ProfileType>;
  companyReportToManagement: CompanyReportToManagementType;
  completedHealthChecks: Array<HealthCheckBasicInformation>;
  /** Return all codes of codesystem 1.2.246.537.5.40119. */
  consentTypes: Array<ConsentType>;
  contactPersonsOfOngoingCustomers: Array<ContactPersonExportRowType>;
  contractTerminationReasons?: Maybe<Array<ContractTerminationReasonType>>;
  corporateAdminViews: Array<ViewType>;
  corporateProfiles: Array<ProfileType>;
  costCenter: CostCenterType;
  costCentersForCompany: Array<CostCenterType>;
  costCentersForCustomer: Array<CostCenterType>;
  costReport: CostReportType;
  costReportLimits: CostReportLimitsType;
  customer: CustomerType;
  customerAddresses: Array<CustomerAddressType>;
  customerAdminViews: Array<ViewType>;
  customerAnnualPlanningStatuses: Array<CustomerAnnualPlanningStatus>;
  customerAnnualPlanningTaskStatuses: Array<CustomerTaskStatus>;
  customerBillingStatus: CustomerBillingStatus;
  customerContactPersonOfType?: Maybe<ContactPersonType>;
  customerDepartments: Array<DepartmentType>;
  customerEmployeeList: CustomerEmployeeList;
  /** Return all codes of codesystem 1.2.246.537.6.240. */
  customerInformationViewReasons: Array<CustomerInformationViewReasonType>;
  customerInternalNotes: CustomerInternalNotesType;
  customerProfiles: Array<ProfileType>;
  customerSalesPackage?: Maybe<SalesPackageType>;
  customerServiceSettings: CustomerServiceSettingsType;
  customerServicesOverview: CustomerServicesOverview;
  customerSupervisorUsers: Array<UserType>;
  customerUserAmounts: CustomerUserAmountsType;
  customersAccountingPeriodMissingOrExpired: Array<CustomerType>;
  customersBillingUncompleted: CustomerBillableUncompletedType;
  customersForCorporate: Array<CustomerType>;
  customersHealthcareSummary: CustomersHealthcareSummaryType;
  customersHealthcareTeamNotSpecified: Array<CustomerType>;
  customersKelaReportNotDone: Array<CustomerType>;
  customersTpsNotScheduled: Array<CustomerType>;
  customersTpsScheduled: Array<CustomerType>;
  customersWithOngoingContract: Array<CustomerType>;
  /** Return all codes of codesystem 1.2.246.537.5.40123. */
  dispenseStatuses: Array<DispenseStatus>;
  documentCategories: Array<DocumentCategoryType>;
  documentTemplate: DocumentTemplateType;
  documentTemplates: Array<DocumentTemplateType>;
  documentsForCustomer: Array<DocumentType>;
  documentsForRegional: Array<DocumentType>;
  /** Return all codes of codesystem 1.2.246.537.6.138. */
  doseUnits: Array<DoseUnit>;
  /** Return all codes of codesystem 1.2.246.537.5.40183. */
  drugExchangeProhibitionReasons: Array<DrugExchangeProhibitionReasonType>;
  emailNotificationSettingsByToken: EmailNotificationSettingsByTokenPayload;
  employeeGroup: EmployeeGroupType;
  employeeGroups: Array<EmployeeGroupType>;
  employeeHealthCheckStatuses: EmployeeHealthCheckStatuses;
  employeeInternalNotes: EmployeeInternalNotesType;
  exposure: ExposureType;
  exposures: Array<ExposureType>;
  fetchPrescriptions?: Maybe<Array<Maybe<PrescriptionState>>>;
  fetchUserQueue: Array<UserQueueType>;
  filterCustomers: Array<CustomerType>;
  fitnessTest: FitnessTestType;
  fitnessTestDevice: FitnessTestDeviceType;
  fitnessTestDevices: Array<FitnessTestDeviceType>;
  fitnessTests: Array<FitnessTestType>;
  functionality: Functionality;
  /** Return all codes of codesystem 1.2.246.537.5.1. */
  genders: Array<GenderType>;
  /** Return details of matching code in codesystem 1.2.246.537.5.40300. */
  getActiveStatusByCode: ActiveStatus;
  /** Return details of matching code in codesystem 1.2.246.537.5.40301. */
  getArchiveStatusByCode: ArchiveStatus;
  /** Return details of matching code in codesystem 1.2.246.537.6.32. */
  getAtcsByCodes: AtcCodesInfo;
  /** Return details of matching code in codesystem 1.2.246.537.5.40006. */
  getAuthorDefinerByCode: AuthorDefinerType;
  getCampaignResults?: Maybe<Scalars['String']['output']>;
  getCampaigns: Array<CampaignType>;
  /** Return details of matching code in codesystem 1.2.246.537.6.13. */
  getCarestageByCode: CareStageType;
  /** Return details of matching code in codesystem 1.2.246.537.5.40101. */
  getCaringTypeByCode: CaringType;
  /** Return details of matching code in codesystem 1.2.246.537.6.12. */
  getCdaViewByCode: CdaViewType;
  /** Returns closest ATC codes matching with provided test string. ATC codes belongs to codesystem 1.2.246.537.6.32. */
  getClosestAtcs: Array<AtcType>;
  getClosestCustomQuestionKeys?: Maybe<Array<QuestionKeyOutputType>>;
  /** Return closest medicines which active ingredient best match with provided test string. */
  getClosestDrugIngredients: Array<DrugType>;
  /** Return closest medicines which medicine name best match with provided test string. */
  getClosestDrugNames: Array<DrugType>;
  /** Return closest FinLoinc codesystem codes which name best match with provided test string. */
  getClosestFinloincNames: Array<FinLoincType>;
  /** Return closest ICD10 codes which name best match with provided test string. */
  getClosestIcd10Names: Array<Icd10Type>;
  /** Returns details of codesystem with matching name. */
  getCodeSystemByName: CodeSystemType;
  /** Return details of matching code in codesystem 1.2.246.537.5.40119. */
  getConsentTypeByCode: ConsentType;
  /** Return details of matching code in codesystem 1.2.246.537.6.240. */
  getCustomerInformationViewReasonByCode: CustomerInformationViewReasonType;
  /** Return details of matching code in codesystem 1.2.246.537.6.1. */
  getDiagnosisByCode: Icd10Type;
  /** Return details of matching code in codesystem 1.2.246.537.5.40123. */
  getDispenseStatusByCode: DispenseStatus;
  /** Return details of matching code in codesystem 1.2.246.537.6.138. */
  getDoseUnitByCode: DoseUnit;
  /** Returns details of medicine with matching package id. */
  getDrugByPackageId: DrugType;
  /** Return details of matching code in codesystem 1.2.246.537.5.40183. */
  getDrugExchangeProhibitionReasonByCode: DrugExchangeProhibitionReasonType;
  /** Return medicine with given VNR. If multiple medicines found return error. */
  getDrugPackageByVnr?: Maybe<DrugType>;
  /** Return details of matching code in codesystem 1.2.246.537.6.148. */
  getEducationByCode: EducationType;
  /** Return details of matching code in codesystem 1.2.246.537.5.1. */
  getGenderByCode: GenderType;
  /** Return details of matching code in codesystem 1.2.246.537.6.14. */
  getHeaderByCode: HeaderType;
  getLaboratoryByCodeId: LaboratoryType;
  getLaboratoryOrder?: Maybe<LaboratoryOrderType>;
  getLaboratoryOrderResults?: Maybe<Array<Maybe<LaboratoryResultType>>>;
  getLaboratoryOrders?: Maybe<Array<Maybe<LaboratoryOrderType>>>;
  getLaboratoryTestByCodeId: LaboratoryTestNomenclatureType;
  /** Return details of matching code in codesystem 1.2.246.537.6.604. */
  getMedicinalProductByCode: MedicinalProductType;
  getNorrePackagePricesAll: Array<NorrePackagePriceWithPackage>;
  getOrganizations?: Maybe<Array<Maybe<Organization>>>;
  getPackagePrices: Array<NorrePackagePrice>;
  getPackagePricesByPackageId: Array<NorrePackagePrice>;
  /** Return details of matching code in codesystem 1.2.246.537.5.40109. */
  getPatientIdentificationByCode: PatientIdentificationType;
  getPatients?: Maybe<Array<Maybe<PatientType>>>;
  /** Return details of matching code in codesystem 1.2.246.537.5.40118. */
  getPkvByCode: PkvType;
  /** Return details of matching code in codesystem 1.2.246.537.5.40105. */
  getPrescriptionMessageTypeByCode: PrescriptionMessageType;
  /** Return details of matching code in codesystem 1.2.246.537.6.600. */
  getPrescriptionRenewalProhibitionByCode: PrescriptionRenewalProhibitionReasonType;
  /** Return details of matching code in codesystem 1.2.246.537.5.40103. */
  getPrescriptionRepudiationTypeByCode: PrescriptionRepudiationType;
  /** Return details of matching code in codesystem 1.2.246.537.6.605. */
  getPrescriptionTypeByCode: PrescriptionTypeDefinition;
  getProfessional?: Maybe<Professional>;
  /** Return details of matching code in codesystem 1.2.246.537.6.140. */
  getProfessionalRightByCode: ProfessionalRightType;
  getProfessionals?: Maybe<Array<Maybe<Professional>>>;
  getRelatedSickLeaveCertificate?: Maybe<SickLeaveCertificateType>;
  getRelatedSuitabilityStatement?: Maybe<SuitabilityStatementType>;
  /** Return details of matching code in codesystem 1.2.246.537.5.40106. */
  getRenewalStatusByCode: RenewalStatus;
  /** Return details of matching code in codesystem 1.2.246.537.6.147. */
  getRestrictionByCode: RestrictionType;
  getServiceEventWithOid?: Maybe<ServiceEvent>;
  getServiceEvents?: Maybe<Array<Maybe<ServiceEvent>>>;
  /** Return details of matching code in codesystem 1.2.246.537.6.850. */
  getSpecialClarificationByCode: SpecialClarification;
  getSurveyAnswers: Array<TreeResultType>;
  getSurveyAnswersForTree: Array<TreeResultType>;
  /** Return details of matching code in codesystem 1.2.246.537.6.12.999. */
  getTechnicalStructureByCode: TechnicalStructureType;
  /** Return details of matching code in codesystem 1.2.246.537.6.112. */
  getToBeOrNotToBeByCode: ToBeOrNotToBe;
  getTrees: Array<TreeInfoDataType>;
  getTreesByName: Array<TreeInfoDataType>;
  googleCalendarServiceAccountEmail: Scalars['String']['output'];
  healthCareTeam: HealthcareTeamType;
  healthCheckContentOptions: Array<HealthCheckContentConfigurationType>;
  healthCheckInvitationMaxPerCheck: Scalars['Int']['output'];
  healthChecksWorkQueueSummary: HealthCheckWorkQueueSummary;
  healthcareTeams: Array<HealthcareTeamType>;
  icd10sForSickLeaveSettings: Array<Icd10Type>;
  insurance?: Maybe<InsuranceType>;
  insuranceAcknowledgmentForCustomer?: Maybe<AcknowledgmentType>;
  insuranceAcknowledgmentsForUser: Array<AcknowledgmentType>;
  insuranceCompanies: Array<InsuranceCompanyType>;
  insurancesForCustomer: Array<InsuranceType>;
  insurancesForUser: Array<InsuranceType>;
  /** Returns a list of drug package id:s filtered by the given parameters. */
  intelligentDrugPackageSearch: Array<Scalars['Int']['output']>;
  invoiceInterfaces: Array<InvoiceInterfaceType>;
  invoicePurchase: InvoicePurchaseType;
  invoicePurchaseAttachments: Array<InvoicePurchaseAttachmentType>;
  invoicePurchaseRowsForSales: Array<InvoicePurchaseRowType>;
  invoicePurchases: Array<InvoicePurchaseType>;
  isSickLeaveApprover: Scalars['Boolean']['output'];
  isSickLeavePostApprovalHandler: Scalars['Boolean']['output'];
  kelaSv98tthInvoicedCosts: KelaSv98TthInvoicedCostsType;
  laboratories: Array<LaboratoryType>;
  laboratoriesWithFilters: Array<LaboratoryType>;
  laboratoryBillableEventsOfCustomers: Array<Maybe<LaboratoryBillableEventType>>;
  laboratoryCatalog: LaboratoryCatalogType;
  laboratoryCatalogContents: LaboratoryCatalogContentsType;
  laboratoryCatalogs: Array<LaboratoryCatalogType>;
  laboratoryNomenclature: Array<LaboratoryTestNomenclatureType>;
  laboratorySuppliers: Array<LaboratorySupplierType>;
  laboratoryTestByCodeId: LaboratoryTestType;
  lastAcuteEvent?: Maybe<Scalars['DateTime']['output']>;
  lastLaboratoryPurchase?: Maybe<Scalars['Date']['output']>;
  latestActionPlan?: Maybe<ActionPlanType>;
  latestEmployeePermittedSuitabilityStatementsInCustomer: Array<SuitabilityStatementType>;
  logAcuteUserSyncs: Array<LogAcuteUserSyncType>;
  me: AuthUserType;
  medicalApiTokenPermissions: Array<MedicalPermissionType>;
  medicalApiTokens: Array<MedicalApiTokenType>;
  medicalFileSignedUrl: MedicalFileSignedUrl;
  medicalPermissions: Array<MedicalPermissionType>;
  medicalPermissionsForUser: Array<MedicalPermissionType>;
  medicalStaffForRegional: Array<UserType>;
  medicalStaffSearch: MedicalStaffSearchReturnType;
  /** Return all codes of codesystem 1.2.246.537.6.604. */
  medicinalProducts: Array<MedicinalProductType>;
  medicineList?: Maybe<MedicineList>;
  moontalkCredentials?: Maybe<MoontalkCredentialsType>;
  moontalkMonthlyReport: Array<MoontalkReport>;
  moontalkReport: MoontalkReport;
  multipleTreesRelatedData: Array<TreeDataType>;
  myPasskeys: Array<PasskeyType>;
  mySettings: UserSettingsType;
  mySickLeaveNotices: Array<SickLeaveNoticeType>;
  node: NodeType;
  nodeGroups: Array<NodeGroupType>;
  nodes: Array<NodeType>;
  nonNorreBackendUser: UserType;
  norreBackendUser: UserType;
  norrePackages: Array<NorrePackageType>;
  ownHealthCheckBookingSettings?: Maybe<HealthCheckBookingSettingsType>;
  ownUnmatchedCalendarBookings: Array<UnmatchedCalendarBookingType>;
  partner: PartnerType;
  partnerProcedures: Array<ProcedureType>;
  partnerServices: Array<PartnerServiceType>;
  partners: Array<PartnerType>;
  /** Return all codes of codesystem 1.2.246.537.5.40109. */
  patientIdentifications: Array<PatientIdentificationType>;
  patientInfo: PatientType;
  patientServiceEventsInOrganization?: Maybe<Array<Maybe<ServiceEvent>>>;
  paymentCommitment: PaymentCommitmentType;
  paymentCommitmentPatientInfo: PaymentCommitmentPatientInfoType;
  paymentCommitmentPatientInfos: Array<PaymentCommitmentPatientInfoType>;
  paymentCommitmentPdf: Scalars['String']['output'];
  paymentCommitmentPurchaseStatsByCategory: Array<PaymentCommitmentPurchaseCategoryStatsType>;
  paymentCommitmentPurchases: Array<PaymentCommitmentPurchaseType>;
  paymentCommitments: Array<PaymentCommitmentType>;
  paymentCommitmentsForCustomer: Array<PaymentCommitmentType>;
  paymentCommitmentsForPatient?: Maybe<Array<PaymentCommitmentPatientInfoType>>;
  paymentCommitmentsForUser: Array<PaymentCommitmentType>;
  permissions: Array<PermissionType>;
  permittedEmployeeSuitabilityStatements: Array<SuitabilityStatementType>;
  /** Return all codes of codesystem 1.2.246.537.5.40105. */
  prescriptionMessageTypes: Array<PrescriptionMessageType>;
  /** Return all codes of codesystem 1.2.246.537.6.600. */
  prescriptionRenewalProhibitions: Array<PrescriptionRenewalProhibitionReasonType>;
  /** Return all codes of codesystem 1.2.246.537.5.40103. */
  prescriptionRepudiations: Array<PrescriptionRepudiationType>;
  prescriptionState?: Maybe<PrescriptionState>;
  prescriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  procedure: ProcedureType;
  procedurePartnerPrices: Array<ProcedurePartnerPriceType>;
  procedureSearch: Array<ProcedureType>;
  professionalGroups: Array<ProfessionalGroupType>;
  profile: ProfileType;
  question?: Maybe<QuestionType>;
  questions: Array<QuestionType>;
  recurrentAbsenceAlertsForSupervisor: Array<SickLeaveRecurrentAbsenceAlertType>;
  regionalAdminViews: Array<ViewType>;
  reimbursementConversion: ReimbursementConversionType;
  reimbursementConversions: Array<ReimbursementConversionType>;
  /** Return all codes of codesystem 1.2.246.537.5.40106. */
  renewalStatuses: Array<RenewalStatus>;
  rolesCompany?: Maybe<Array<RoleCompanyType>>;
  rolesCorporate?: Maybe<Array<RoleCorporateType>>;
  rolesCustomer?: Maybe<Array<RoleCustomerType>>;
  rolesForCustomer?: Maybe<Array<RoleCustomerType>>;
  salesCatalog?: Maybe<SalesCatalogType>;
  salesCatalogs: Array<SalesCatalogType>;
  salesContract: SalesContractType;
  salesContracts: Array<SalesContractType>;
  salesExtraServices: Array<SalesExtraServiceType>;
  salesInvoice: InvoiceSaleType;
  salesInvoiceRow: InvoiceSaleRowType;
  salesInvoices: Array<InvoiceSaleType>;
  salesPackages: Array<SalesPackageType>;
  salesPricesForSalesCatalog: Array<SalesPriceType>;
  scheduledHealthChecks: Array<HealthCheckBasicInformation>;
  searchIcd10sForSickLeaveForm: Array<Icd10Type>;
  searchPatients?: Maybe<Array<Maybe<PatientType>>>;
  searchPaymentCommitments: Array<PaymentCommitmentType>;
  searchQuestion?: Maybe<Array<QuestionType>>;
  searchUser: AuthUserType;
  sickLeaveCategories: Array<SickLeaveCategoryType>;
  sickLeaveCertificate: SickLeaveCertificateType;
  sickLeaveCertificateViewers: Array<SickLeaveCertificateViewerType>;
  sickLeaveHandlers: Array<SickLeaveHandlerType>;
  sickLeaveHistory: SickLeaveHistoryType;
  sickLeaveNotice: SickLeaveNoticeType;
  sickLeaveNoticeRecipients: SickLeaveNoticeRecipientListType;
  sickLeaveNoticeTypesAndReasonsForUser: Array<Maybe<SickLeaveNoticeTypeAndReasonType>>;
  sickLeaveNoticesForCustomer: Array<SickLeaveNoticeType>;
  sickLeaveNoticesForHandler: Array<SickLeaveNoticeType>;
  sickLeaveNoticesForUser: Array<SickLeaveNoticeType>;
  sickLeaveReport: SickLeaveReportType;
  sickLeaveReportLimits: Array<SickLeaveReportRangeLimitType>;
  sickLeaveSelfReportReasonStatusForUser: Scalars['Boolean']['output'];
  sickLeaveSelfReportReasons: Array<SickLeaveSelfReportReasonType>;
  sickLeaveSelfReportReasonsAllowed: Array<SickLeaveSelfReportReasonType>;
  sickLeaveSelfReportReasonsWithoutCategory: Array<SickLeaveSelfReportReasonType>;
  sickLeaveSettingsCustomer: SickLeaveSettingsCustomerType;
  sickLeaveTypes: Array<SickLeaveTypeType>;
  /** Return all codes of codesystem 1.2.246.537.6.850. */
  specialClarifications: Array<SpecialClarification>;
  statutoryInsuranceTypes: Array<InsuranceTypeChoices>;
  /** Returns substitute packages. */
  substituteMedicines: Array<DrugType>;
  subtitles?: Maybe<Array<SubtitleType>>;
  suitabilityStatements: Array<SuitabilityStatementType>;
  supplierPackages: Array<SupplierPackageType>;
  taskScheduling?: Maybe<TaskSchedulingType>;
  titles?: Maybe<Array<TitleType>>;
  titletemplates?: Maybe<Array<TitleTemplateType>>;
  /** Return all codes of codesystem 1.2.246.537.6.112. */
  toBeOrNotToBeCodes: Array<ToBeOrNotToBe>;
  tpsCustomerData: Array<CustomerType>;
  treeRelatedData: TreeDataType;
  user: UserType;
  userCompanyRoles: Array<RoleCompanyType>;
  userCorporateRoles: Array<RoleCorporateType>;
  userCustomerRoles: Array<RoleCustomerType>;
  userEmailsAndPhoneNumbers: UserEmailPhoneNumberReturnType;
  userEmploymentHistory: Array<UserEmploymentInformationType>;
  userHealthCheckHistory: Array<HealthCheckBasicInformation>;
  userOwnPersonalInformation: UserType;
  userProfiles: Array<ProfileType>;
  userSubordinates: CustomerUserSuborganizationStructure;
  userTasks: Array<TaskType>;
  userWithUuid: UserType;
  usersForCorporate: Array<UserType>;
  usersForCustomer: Array<UserType>;
  usersForRegional: Array<UserType>;
  usersNextHealthCheckNotScheduledLegacy: Array<UserType>;
  usersNextHealthCheckUnscheduled: Array<HealthCheckBasicInformation>;
  usersPreviousHealthCheckNotClarified: Array<HealthCheckBasicInformation>;
  usersWithRoleOnlyInCompany: Array<UserType>;
  usersWithRoleOnlyInCustomer: Array<UserType>;
  validSalesContractVersionsForCustomer?: Maybe<Array<SalesContractVersionType>>;
  view?: Maybe<ViewType>;
  views: Array<ViewType>;
  voluntaryInsuranceTypes: Array<InsuranceTypeChoices>;
  zefApiToken?: Maybe<ZefapiTokenType>;
  zefQuestionConfigurations: Array<ZefQuestionConfigurationType>;
  zefSurveyConfigurationVersion?: Maybe<ZefSurveyConfigurationVersionType>;
  zefSurveyConfigurationVersions: Array<ZefSurveyConfigurationVersionType>;
  zefSurveyEmailInvitations: Array<ZefEmailInvitationType>;
  zefSurveyQuestions: Array<ZefQuestionType>;
  zefSurveySmsInvitations: Array<ZefsmsInvitationType>;
  zefSurveys: Array<ZefSurveyType>;
};


export type Query_EntitiesArgs = {
  representations: Array<Scalars['_Any']['input']>;
};


export type QueryActionPlanArgs = {
  id: Scalars['ID']['input'];
};


export type QueryActionPlansArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryAlternativePackagesArgs = {
  drugKey: Scalars['Int']['input'];
};


export type QueryAvailableBalanceForUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryAvailablePartnerServiceUsageForUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryBillableEventReportPeriodsArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryBillablePatientReportPeriodsArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryBillablePatientUserUuidsArgs = {
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
};


export type QueryBillablePatientUsersArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
};


export type QueryBillablePatientsArgs = {
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
  userUuids: Array<Scalars['UUID']['input']>;
};


export type QueryBillableReportEventsArgs = {
  customerId: Scalars['ID']['input'];
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
};


export type QueryBillableReportPatientsArgs = {
  customerId: Scalars['ID']['input'];
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
};


export type QueryBillablesArgs = {
  customerId: Scalars['ID']['input'];
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
};


export type QueryBillablesOfCustomersArgs = {
  customerIds: Array<Scalars['ID']['input']>;
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
};


export type QueryBiosimilarsArgs = {
  biologicalMedicineGroups: Array<Scalars['String']['input']>;
};


export type QueryCanCreateSickLeaveNoticesForAllArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryCanViewCostReportArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryCanViewSickLeaveHistoryArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryCanViewSickLeaveReportsArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryCareGuidanceArgs = {
  customerId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCareGuidanceCustomersArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCheckIcd10CodesUsedInOtherSickLeaveCategoriesArgs = {
  icd10Codes: Array<InputMaybe<Scalars['String']['input']>>;
  sickLeaveCategoryId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCheckInfoForGeneratingSv98tthArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryChildProfilesForUserArgs = {
  customerId: Scalars['ID']['input'];
  includeParentProfiles: Scalars['Boolean']['input'];
};


export type QueryCompanyArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryCompanyAddressesArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryCompanyProfilesArgs = {
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  includeCommon?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCompanyReportToManagementArgs = {
  companyId: Scalars['ID']['input'];
  time: Scalars['DateTime']['input'];
};


export type QueryCompletedHealthChecksArgs = {
  companyId: Scalars['ID']['input'];
  customerId?: InputMaybe<Scalars['ID']['input']>;
  healthcareTeamId?: InputMaybe<Scalars['ID']['input']>;
  responsibleNurseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryContactPersonsOfOngoingCustomersArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  contactType: Scalars['String']['input'];
  responsibleNurseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  serviceFilter?: InputMaybe<ServiceSettingsFilterInput>;
};


export type QueryCorporateProfilesArgs = {
  includeAllCommon?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCostCenterArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCostCentersForCompanyArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryCostCentersForCustomerArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryCostReportArgs = {
  bucket: CostReportBucket;
  byCostCenter?: InputMaybe<Scalars['Boolean']['input']>;
  customerId: Scalars['ID']['input'];
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
};


export type QueryCustomerArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryCustomerAddressesArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryCustomerAnnualPlanningStatusesArgs = {
  adminCompanyId: Scalars['ID']['input'];
  responsibleNurseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryCustomerAnnualPlanningTaskStatusesArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryCustomerBillingStatusArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryCustomerContactPersonOfTypeArgs = {
  contactType: Scalars['String']['input'];
  customerId: Scalars['ID']['input'];
};


export type QueryCustomerDepartmentsArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryCustomerEmployeeListArgs = {
  customerId: Scalars['ID']['input'];
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCustomerInternalNotesArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryCustomerProfilesArgs = {
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  includeCommon?: InputMaybe<Scalars['Boolean']['input']>;
  limitCustomers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCustomerSalesPackageArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryCustomerServiceSettingsArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryCustomerServicesOverviewArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryCustomerSupervisorUsersArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryCustomerUserAmountsArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryCustomersAccountingPeriodMissingOrExpiredArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryCustomersBillingUncompletedArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryCustomersHealthcareSummaryArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryCustomersHealthcareTeamNotSpecifiedArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryCustomersKelaReportNotDoneArgs = {
  companyId: Scalars['ID']['input'];
  responsibleNurseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryCustomersTpsNotScheduledArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryCustomersTpsScheduledArgs = {
  companyId: Scalars['ID']['input'];
  responsibleNurseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryCustomersWithOngoingContractArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDocumentCategoriesArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  showForCustomerUsers?: InputMaybe<Scalars['Boolean']['input']>;
  showForCustomers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDocumentTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentsForCustomerArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryDocumentsForRegionalArgs = {
  companyId: Scalars['ID']['input'];
  customerId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEmailNotificationSettingsByTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryEmployeeGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmployeeGroupsArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryEmployeeHealthCheckStatusesArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryEmployeeInternalNotesArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryExposureArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFetchPrescriptionsArgs = {
  oidCodes: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryFetchUserQueueArgs = {
  site: SiteType;
};


export type QueryFilterCustomersArgs = {
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryFitnessTestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFitnessTestDeviceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFitnessTestsArgs = {
  patientUuid: Scalars['UUID']['input'];
};


export type QueryFunctionalityArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetActiveStatusByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetArchiveStatusByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetAtcsByCodesArgs = {
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetAuthorDefinerByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetCampaignResultsArgs = {
  id: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetCampaignsArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryGetCarestageByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetCaringTypeByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetCdaViewByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetClosestAtcsArgs = {
  max?: InputMaybe<Scalars['Int']['input']>;
  test?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetClosestCustomQuestionKeysArgs = {
  max?: InputMaybe<Scalars['Int']['input']>;
  test?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetClosestDrugIngredientsArgs = {
  drugExchangeRequiredLast?: InputMaybe<Scalars['Boolean']['input']>;
  max?: InputMaybe<Scalars['Int']['input']>;
  notAvailableLast?: InputMaybe<Scalars['Boolean']['input']>;
  test?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetClosestDrugNamesArgs = {
  drugExchangeRequiredLast?: InputMaybe<Scalars['Boolean']['input']>;
  max?: InputMaybe<Scalars['Int']['input']>;
  notAvailableLast?: InputMaybe<Scalars['Boolean']['input']>;
  test?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetClosestFinloincNamesArgs = {
  max?: InputMaybe<Scalars['Int']['input']>;
  test?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetClosestIcd10NamesArgs = {
  max?: InputMaybe<Scalars['Int']['input']>;
  test?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCodeSystemByNameArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetConsentTypeByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetCustomerInformationViewReasonByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetDiagnosisByCodeArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDispenseStatusByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetDoseUnitByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetDrugByPackageIdArgs = {
  packageId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetDrugExchangeProhibitionReasonByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetDrugPackageByVnrArgs = {
  VNR: Scalars['String']['input'];
};


export type QueryGetEducationByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetGenderByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetHeaderByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetLaboratoryByCodeIdArgs = {
  codeId: Scalars['String']['input'];
};


export type QueryGetLaboratoryOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetLaboratoryOrderResultsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetLaboratoryTestByCodeIdArgs = {
  codeId: Scalars['String']['input'];
};


export type QueryGetMedicinalProductByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetPackagePricesArgs = {
  laboratoryTests?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  supplierPackages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryGetPackagePricesByPackageIdArgs = {
  norrePackageId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetPatientIdentificationByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetPkvByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetPrescriptionMessageTypeByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetPrescriptionRenewalProhibitionByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetPrescriptionRepudiationTypeByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetPrescriptionTypeByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetProfessionalRightByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetRelatedSickLeaveCertificateArgs = {
  taskId: Scalars['ID']['input'];
};


export type QueryGetRelatedSuitabilityStatementArgs = {
  taskId: Scalars['ID']['input'];
};


export type QueryGetRenewalStatusByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetRestrictionByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetServiceEventWithOidArgs = {
  oid: Scalars['String']['input'];
};


export type QueryGetSpecialClarificationByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetSurveyAnswersForTreeArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetTechnicalStructureByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetToBeOrNotToBeByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetTreesByNameArgs = {
  nameSearch?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHealthCareTeamArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHealthChecksWorkQueueSummaryArgs = {
  companyId: Scalars['ID']['input'];
  time: Scalars['DateTime']['input'];
};


export type QueryHealthcareTeamsArgs = {
  companyId: Scalars['ID']['input'];
  professionalGroupId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryInsuranceArgs = {
  insuranceId: Scalars['ID']['input'];
};


export type QueryInsuranceAcknowledgmentForCustomerArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryInsuranceAcknowledgmentsForUserArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
  userUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryInsurancesForCustomerArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryInsurancesForUserArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
  userUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryIntelligentDrugPackageSearchArgs = {
  VNR?: InputMaybe<Scalars['String']['input']>;
  atcCode?: InputMaybe<Scalars['String']['input']>;
  intensity?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['Int']['input']>;
  packageAdditionalInfo?: InputMaybe<Scalars['String']['input']>;
  packageSizeText?: InputMaybe<Scalars['String']['input']>;
  tradeName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInvoicePurchaseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInvoicePurchaseAttachmentsArgs = {
  invoicePurchaseId: Scalars['ID']['input'];
};


export type QueryInvoicePurchaseRowsForSalesArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryInvoicePurchasesArgs = {
  companyId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<InputMaybe<InvoicePurchaseState>>>;
};


export type QueryIsSickLeaveApproverArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryIsSickLeavePostApprovalHandlerArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryKelaSv98tthInvoicedCostsArgs = {
  accountingPeriodEnd: Scalars['Date']['input'];
  accountingPeriodStart: Scalars['Date']['input'];
  customerId: Scalars['ID']['input'];
};


export type QueryLaboratoriesWithFiltersArgs = {
  businessId?: InputMaybe<Scalars['String']['input']>;
  hideExpired?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLaboratoryBillableEventsOfCustomersArgs = {
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
  userUuids: Array<Scalars['UUID']['input']>;
};


export type QueryLaboratoryCatalogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLaboratoryCatalogContentsArgs = {
  catalogId: Scalars['ID']['input'];
};


export type QueryLaboratoryTestByCodeIdArgs = {
  codeId: Scalars['ID']['input'];
};


export type QueryLastAcuteEventArgs = {
  customerIds: Array<Scalars['ID']['input']>;
};


export type QueryLastLaboratoryPurchaseArgs = {
  userUuids: Array<Scalars['UUID']['input']>;
};


export type QueryLatestActionPlanArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryLatestEmployeePermittedSuitabilityStatementsInCustomerArgs = {
  customerId: Scalars['ID']['input'];
  subordinatesOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLogAcuteUserSyncsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryMedicalApiTokenPermissionsArgs = {
  apiTokenId: Scalars['ID']['input'];
};


export type QueryMedicalFileSignedUrlArgs = {
  fileId: Scalars['ID']['input'];
};


export type QueryMedicalStaffForRegionalArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryMedicalStaffSearchArgs = {
  searchTerm: Scalars['String']['input'];
};


export type QueryMedicineListArgs = {
  patientEmail: Scalars['String']['input'];
  professionalId: Scalars['String']['input'];
};


export type QueryMoontalkMonthlyReportArgs = {
  months: Scalars['Int']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryMoontalkReportArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryMultipleTreesRelatedDataArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type QueryMySickLeaveNoticesArgs = {
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPartnerArgs = {
  partnerId: Scalars['ID']['input'];
};


export type QueryPartnersArgs = {
  onlyParents?: InputMaybe<Scalars['Boolean']['input']>;
  partnerParentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPatientInfoArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryPatientServiceEventsInOrganizationArgs = {
  businessId: Scalars['String']['input'];
  patientEmail: Scalars['String']['input'];
};


export type QueryPaymentCommitmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPaymentCommitmentPatientInfoArgs = {
  paymentCommitmentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPaymentCommitmentPatientInfosArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type QueryPaymentCommitmentPdfArgs = {
  paymentCommitmentId: Scalars['ID']['input'];
};


export type QueryPaymentCommitmentPurchaseStatsByCategoryArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
};


export type QueryPaymentCommitmentPurchasesArgs = {
  paymentCommitmentId: Scalars['ID']['input'];
};


export type QueryPaymentCommitmentsForCustomerArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryPaymentCommitmentsForPatientArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryPaymentCommitmentsForUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryPermittedEmployeeSuitabilityStatementsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryPrescriptionStateArgs = {
  oid: Scalars['String']['input'];
};


export type QueryProcedureArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProcedurePartnerPricesArgs = {
  procedureId: Scalars['ID']['input'];
};


export type QueryProcedureSearchArgs = {
  partnerId?: InputMaybe<Scalars['ID']['input']>;
  reimbursementClass?: InputMaybe<Scalars['String']['input']>;
  searchTerm: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryProfileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReimbursementConversionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReimbursementConversionsArgs = {
  ignoreInKelaReport?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRolesForCustomerArgs = {
  customerId: Scalars['ID']['input'];
};


export type QuerySalesCatalogArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySalesContractArgs = {
  customerId: Scalars['ID']['input'];
};


export type QuerySalesContractsArgs = {
  companyId: Scalars['ID']['input'];
};


export type QuerySalesInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySalesInvoiceRowArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySalesInvoicesArgs = {
  approved: Scalars['Boolean']['input'];
  companyId: Scalars['ID']['input'];
  localDrafts: Scalars['Boolean']['input'];
  max?: InputMaybe<Scalars['Int']['input']>;
  remoteDrafts: Scalars['Boolean']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sent: Scalars['Boolean']['input'];
};


export type QuerySalesPricesForSalesCatalogArgs = {
  salesCatalogId: Scalars['ID']['input'];
};


export type QueryScheduledHealthChecksArgs = {
  companyId: Scalars['ID']['input'];
  customerId?: InputMaybe<Scalars['ID']['input']>;
  healthcareTeamId?: InputMaybe<Scalars['ID']['input']>;
  invitationFilter?: InputMaybe<HealthCheckInvitationFilter>;
  responsibleNurseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QuerySearchIcd10sForSickLeaveFormArgs = {
  searchTerm: Scalars['String']['input'];
};


export type QuerySearchPatientsArgs = {
  max?: InputMaybe<Scalars['Int']['input']>;
  test?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchPaymentCommitmentsArgs = {
  customerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  max?: InputMaybe<Scalars['Int']['input']>;
  referenceNumberContains?: InputMaybe<Scalars['String']['input']>;
  userNameContains?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchQuestionArgs = {
  max?: InputMaybe<Scalars['Int']['input']>;
  test?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchUserArgs = {
  includeDeleted?: Scalars['Boolean']['input'];
  nationalId: Scalars['String']['input'];
};


export type QuerySickLeaveCertificateArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySickLeaveCertificateViewersArgs = {
  sickLeaveCertificateId: Scalars['ID']['input'];
};


export type QuerySickLeaveHandlersArgs = {
  customerId: Scalars['ID']['input'];
};


export type QuerySickLeaveHistoryArgs = {
  customerId: Scalars['ID']['input'];
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySickLeaveNoticeArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySickLeaveNoticeRecipientsArgs = {
  customerId: Scalars['ID']['input'];
};


export type QuerySickLeaveNoticeTypesAndReasonsForUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QuerySickLeaveNoticesForCustomerArgs = {
  customerId: Scalars['ID']['input'];
};


export type QuerySickLeaveNoticesForHandlerArgs = {
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status: SickLeaveNoticeStatus;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySickLeaveNoticesForUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QuerySickLeaveReportArgs = {
  bucket: SickLeaveReportBucket;
  customerId: Scalars['ID']['input'];
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
  dimension: SickLeaveReportDimension;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QuerySickLeaveSelfReportReasonStatusForUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QuerySickLeaveSelfReportReasonsAllowedArgs = {
  customerId: Scalars['ID']['input'];
};


export type QuerySickLeaveSettingsCustomerArgs = {
  customerId: Scalars['ID']['input'];
};


export type QuerySubstituteMedicinesArgs = {
  matchPackageSize?: InputMaybe<Scalars['Boolean']['input']>;
  substituteDrugPackagesCode: Scalars['String']['input'];
  substituteMedicinesCode: Scalars['String']['input'];
};


export type QuerySuitabilityStatementsArgs = {
  healthCheckId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryTaskSchedulingArgs = {
  customerId: Scalars['ID']['input'];
  taskType: TaskTypeChoices;
};


export type QueryTpsCustomerDataArgs = {
  businessId: Scalars['String']['input'];
};


export type QueryTreeRelatedDataArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryUserCompanyRolesArgs = {
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  userId: Scalars['ID']['input'];
};


export type QueryUserCorporateRolesArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryUserCustomerRolesArgs = {
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  userId: Scalars['ID']['input'];
};


export type QueryUserEmploymentHistoryArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryUserHealthCheckHistoryArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryUserOwnPersonalInformationArgs = {
  userUuid: Scalars['UUID']['input'];
};


export type QueryUserProfilesArgs = {
  userId: Scalars['String']['input'];
};


export type QueryUserSubordinatesArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryUserTasksArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  includeCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  includeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  includeUncompleted?: InputMaybe<Scalars['Boolean']['input']>;
  taskTypes?: InputMaybe<Array<TaskTypeChoices>>;
  userId: Scalars['ID']['input'];
};


export type QueryUserWithUuidArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryUsersForCustomerArgs = {
  customerId: Scalars['ID']['input'];
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryUsersForRegionalArgs = {
  companyId: Scalars['ID']['input'];
  healthcareTeamId?: InputMaybe<Scalars['ID']['input']>;
  isHealthcareWorker?: InputMaybe<Scalars['Boolean']['input']>;
  professionalGroupId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUsersNextHealthCheckNotScheduledLegacyArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryUsersNextHealthCheckUnscheduledArgs = {
  companyId: Scalars['ID']['input'];
  responsibleNurseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryUsersPreviousHealthCheckNotClarifiedArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryUsersWithRoleOnlyInCompanyArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryUsersWithRoleOnlyInCustomerArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryValidSalesContractVersionsForCustomerArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryViewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryZefQuestionConfigurationsArgs = {
  questionKeyFilter?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryZefSurveyConfigurationVersionArgs = {
  surveyKey?: InputMaybe<Scalars['String']['input']>;
  surveyType: SurveyType;
};


export type QueryZefSurveyEmailInvitationsArgs = {
  surveyKey: Scalars['String']['input'];
};


export type QueryZefSurveyQuestionsArgs = {
  surveyKey: Scalars['String']['input'];
};


export type QueryZefSurveySmsInvitationsArgs = {
  surveyKey: Scalars['String']['input'];
};

/** An enumeration. */
export enum QuestionAnswerTypeChoices {
  LongText = 'LONG_TEXT',
  Matrix = 'MATRIX',
  Multiscored = 'MULTISCORED',
  Multiselect = 'MULTISELECT',
  Number = 'NUMBER',
  Scored = 'SCORED',
  Select = 'SELECT',
  Text = 'TEXT'
}

export type QuestionKeyOutputType = {
  __typename?: 'QuestionKeyOutputType';
  createdAt: Scalars['DateTime']['output'];
  finloinc?: Maybe<FinLoincType>;
  freeString?: Maybe<Scalars['String']['output']>;
  icd10?: Maybe<Icd10Type>;
  id: Scalars['ID']['output'];
  questions: Array<QuestionType>;
};

/** An enumeration. */
export enum QuestionKeyTypeChoices {
  Custom = 'CUSTOM',
  Finloinc = 'FINLOINC',
  Icd10 = 'ICD10'
}

export type QuestionToNode = {
  __typename?: 'QuestionToNode';
  node: NodeType;
};

export type QuestionType = {
  __typename?: 'QuestionType';
  answerChoices: Array<Scalars['String']['output']>;
  answerLimitMaximum?: Maybe<Scalars['Int']['output']>;
  answerLimitMinimum?: Maybe<Scalars['Int']['output']>;
  answerMultiplier: Scalars['Decimal']['output'];
  answerScores: Array<Scalars['Int']['output']>;
  answerType: QuestionsQuestionAnswerTypeChoices;
  createdAt: Scalars['DateTime']['output'];
  file?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isSlider: Scalars['Boolean']['output'];
  key?: Maybe<QuestionKeyOutputType>;
  keyName?: Maybe<Scalars['String']['output']>;
  mandatory: Scalars['Boolean']['output'];
  matrixQuestionFactors: Array<Scalars['Int']['output']>;
  matrixQuestions: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nodes: Array<NodeType>;
  question: Scalars['String']['output'];
  settingsReady: Scalars['Boolean']['output'];
  sliderStep: Scalars['Decimal']['output'];
  textHelp: Scalars['String']['output'];
  textInfo: Scalars['String']['output'];
};

/** An enumeration. */
export enum QuestionsQuestionAnswerTypeChoices {
  /** Long text */
  LongText = 'LONG_TEXT',
  /** Matrix */
  Matrix = 'MATRIX',
  /** Scored multi */
  Multiscored = 'MULTISCORED',
  /** Multiselect */
  Multiselect = 'MULTISELECT',
  /** Number */
  Number = 'NUMBER',
  /** Scored */
  Scored = 'SCORED',
  /** Select */
  Select = 'SELECT',
  /** Text */
  Text = 'TEXT'
}

/** An enumeration. */
export enum ReceptionChoices {
  LocalAndRemote = 'LOCAL_AND_REMOTE',
  RemoteOnly = 'REMOTE_ONLY'
}

/** An enumeration. */
export enum ReimbursementClasses {
  KelaOne = 'KELA_ONE',
  KelaTwo = 'KELA_TWO',
  KelaZero = 'KELA_ZERO'
}

export type ReimbursementConversionInputType = {
  acuteEventName: Scalars['String']['input'];
  acutePriceListId: Scalars['String']['input'];
  ignoreInKelaReport: Scalars['Boolean']['input'];
  invoicingProductName?: InputMaybe<Scalars['String']['input']>;
  invoicingProductNoExternal?: InputMaybe<Scalars['String']['input']>;
  invoicingUnit?: InputMaybe<Scalars['String']['input']>;
  invoicingUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  invoicingUnitPriceRemote?: InputMaybe<Scalars['Decimal']['input']>;
  isRemote: Scalars['Boolean']['input'];
  kelaOneActionCategory?: InputMaybe<KelaOneActionCategories>;
  kelaOneActivityReportType?: InputMaybe<ActivityReportedChoices>;
  kelaReportResourceCategory?: InputMaybe<KelaReportResourceCategoryChoices>;
  kelaTwoActionCategory?: InputMaybe<KelaTwoActionCategories>;
  kelaTwoActivityReportType?: InputMaybe<ActivityReportedChoices>;
  priceForKela?: InputMaybe<Scalars['Decimal']['input']>;
  reimbursementClass?: InputMaybe<ReimbursementClasses>;
  showInCustomerReport: Scalars['Boolean']['input'];
  titleForCustomer?: InputMaybe<Scalars['String']['input']>;
  useBillableReimbursementClass: Scalars['Boolean']['input'];
  useQuantityMultiplier?: InputMaybe<Scalars['Boolean']['input']>;
  useTimeMultiplier?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReimbursementConversionType = {
  __typename?: 'ReimbursementConversionType';
  acuteEventName: Scalars['String']['output'];
  acutePriceListId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  ignoreInKelaReport: Scalars['Boolean']['output'];
  invoicingProductName: Scalars['String']['output'];
  invoicingProductNoExternal: Scalars['String']['output'];
  invoicingUnit: Scalars['String']['output'];
  invoicingUnitPrice: Scalars['Decimal']['output'];
  invoicingUnitPriceRemote: Scalars['Decimal']['output'];
  isRemote: Scalars['Boolean']['output'];
  kelaOneActionCategory?: Maybe<ReimbursementsAcuteEventConversionKelaOneActionCategoryChoices>;
  kelaOneActivityReportType?: Maybe<ReimbursementsAcuteEventConversionKelaOneActivityReportTypeChoices>;
  kelaReportResourceCategory?: Maybe<ReimbursementsAcuteEventConversionKelaReportResourceCategoryChoices>;
  kelaTwoActionCategory?: Maybe<ReimbursementsAcuteEventConversionKelaTwoActionCategoryChoices>;
  kelaTwoActivityReportType?: Maybe<ReimbursementsAcuteEventConversionKelaTwoActivityReportTypeChoices>;
  priceForKela?: Maybe<Scalars['Decimal']['output']>;
  reimbursementClass?: Maybe<ReimbursementsAcuteEventConversionReimbursementClassChoices>;
  showInCustomerReport: Scalars['Boolean']['output'];
  titleForCustomer: Scalars['String']['output'];
  useBillableReimbursementClass: Scalars['Boolean']['output'];
  useQuantityMultiplier: Scalars['Boolean']['output'];
  useTimeMultiplier: Scalars['Boolean']['output'];
};

/** An enumeration. */
export enum ReimbursementsAcuteEventConversionKelaOneActionCategoryChoices {
  /** Custom Health Check */
  CustomHealthCheck = 'CUSTOM_HEALTH_CHECK',
  /** Exposure Health Check */
  ExposureHealthCheck = 'EXPOSURE_HEALTH_CHECK',
  /** Group Advice And Guidance */
  GroupAdviceAndGuidance = 'GROUP_ADVICE_AND_GUIDANCE',
  /** Individual Advice And Guidance */
  IndividualAdviceAndGuidance = 'INDIVIDUAL_ADVICE_AND_GUIDANCE',
  /** Workplace Assessment */
  WorkplaceAssessment = 'WORKPLACE_ASSESSMENT'
}

/** An enumeration. */
export enum ReimbursementsAcuteEventConversionKelaOneActivityReportTypeChoices {
  /** Euros */
  Euros = 'EUROS',
  /** Euros and activity */
  EurosActivity = 'EUROS_ACTIVITY'
}

/** An enumeration. */
export enum ReimbursementsAcuteEventConversionKelaReportResourceCategoryChoices {
  /** Agriculture */
  Agriculture = 'AGRICULTURE',
  /** Doctor */
  Doctor = 'DOCTOR',
  /** Ergonomics */
  Ergonomics = 'ERGONOMICS',
  /** Exercise */
  Exercise = 'EXERCISE',
  /** Hygiene */
  Hygiene = 'HYGIENE',
  /** Imaging */
  Imaging = 'IMAGING',
  /** Laboratory */
  Laboratory = 'LABORATORY',
  /** Nurse */
  Nurse = 'NURSE',
  /** Nutrition */
  Nutrition = 'NUTRITION',
  /** Other Costs */
  OtherCosts = 'OTHER_COSTS',
  /** Physiotherapist */
  Physiotherapist = 'PHYSIOTHERAPIST',
  /** Psychologist */
  Psychologist = 'PSYCHOLOGIST',
  /** Social */
  Social = 'SOCIAL',
  /** Specialist */
  Specialist = 'SPECIALIST',
  /** Speech Therapy */
  SpeechTherapy = 'SPEECH_THERAPY',
  /** Technical */
  Technical = 'TECHNICAL',
  /** Vision */
  Vision = 'VISION'
}

/** An enumeration. */
export enum ReimbursementsAcuteEventConversionKelaTwoActionCategoryChoices {
  /** Medical Care */
  MedicalCare = 'MEDICAL_CARE',
  /** Other Healthcare */
  OtherHealthcare = 'OTHER_HEALTHCARE'
}

/** An enumeration. */
export enum ReimbursementsAcuteEventConversionKelaTwoActivityReportTypeChoices {
  /** Euros */
  Euros = 'EUROS',
  /** Euros and activity */
  EurosActivity = 'EUROS_ACTIVITY'
}

/** An enumeration. */
export enum ReimbursementsAcuteEventConversionReimbursementClassChoices {
  /** Kela One */
  KelaOne = 'KELA_ONE',
  /** Kela Two */
  KelaTwo = 'KELA_TWO',
  /** Kela Zero */
  KelaZero = 'KELA_ZERO'
}

export type RejectInvoicePurchase = {
  __typename?: 'RejectInvoicePurchase';
  invoicePurchase?: Maybe<InvoicePurchaseType>;
};

export type RemoveCampaignSurveyRespondent = {
  __typename?: 'RemoveCampaignSurveyRespondent';
  campaign?: Maybe<CampaignType>;
};

/** Value belongs to codesystem 1.2.246.537.5.40106 values. */
export type RenewalStatus = {
  __typename?: 'RenewalStatus';
  code: Scalars['String']['output'];
  codeSystem?: Maybe<CodeSystemType>;
  displayName: Scalars['String']['output'];
};

export type ReplacePrescription = {
  __typename?: 'ReplacePrescription';
  prescriptionOid?: Maybe<Scalars['String']['output']>;
};

/**
 * Mutation which creates prescription repudiation documents in medical-database.
 * Repudiation documents should still send to Kanta using sendDocumentToKanta mutation or sendPrescriptionRepudiations.
 */
export type RepudiatePrescriptions = {
  __typename?: 'RepudiatePrescriptions';
  /** Oid codes of the documents which repudiation failed. */
  failedToRepudiate?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Failure reasons for each failed repudiation. */
  failureReasons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Succesfully repudiated document oid codes */
  repudiatedDocumentOids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Repudiating document oid codes for each succesfully repudiated prescription. */
  repudiatingDocumentOids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type RequestMedicalFileUploadResult = {
  __typename?: 'RequestMedicalFileUploadResult';
  expiresAt: Scalars['String']['output'];
  fileId: Scalars['ID']['output'];
  requiredHeaders: Scalars['GenericScalar']['output'];
  uploadUrl: Scalars['String']['output'];
};

/**
 * A handler asks the employee to submit the certificate to the employer.
 *
 * Creates the submission task assigned to the employee and notifies them by email.
 * Idempotent: an existing, uncancelled task is returned without creating another.
 *
 * Returns the notice: the handler cannot view the certificate object until it is submitted,
 * so the submission state is exposed through the notice's certificate metadata fields.
 */
export type RequestSickLeaveCertificateSubmission = {
  __typename?: 'RequestSickLeaveCertificateSubmission';
  sickLeaveNotice: SickLeaveNoticeType;
};

export type ResendLaboratoryOrder = {
  __typename?: 'ResendLaboratoryOrder';
  laboratoryOrder?: Maybe<LaboratoryOrderType>;
};

export type RestrictedPrivilege = {
  __typename?: 'RestrictedPrivilege';
  intendedUse?: Maybe<Scalars['String']['output']>;
  prescriptionType?: Maybe<Scalars['String']['output']>;
  professionalGroup?: Maybe<Scalars['String']['output']>;
};

/** Value belongs to codesystem 1.2.246.537.6.147 values. */
export type RestrictionType = {
  __typename?: 'RestrictionType';
  code: Scalars['String']['output'];
  codeSystem?: Maybe<CodeSystemType>;
  displayName: Scalars['String']['output'];
};

export type RevokeSuitabilityStatementEmployerView = {
  __typename?: 'RevokeSuitabilityStatementEmployerView';
  suitabilityStatement: SuitabilityStatementType;
};

export type RoleCompanyType = {
  __typename?: 'RoleCompanyType';
  apiToken?: Maybe<ApiTokenType>;
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  profile: ProfileType;
  user?: Maybe<UserType>;
};

export type RoleCorporateType = {
  __typename?: 'RoleCorporateType';
  apiToken?: Maybe<ApiTokenType>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  profile: ProfileType;
  user?: Maybe<UserType>;
};

export type RoleCustomerType = {
  __typename?: 'RoleCustomerType';
  apiToken?: Maybe<ApiTokenType>;
  createdAt: Scalars['DateTime']['output'];
  customer: CustomerType;
  id: Scalars['ID']['output'];
  profile: ProfileType;
  user?: Maybe<UserType>;
};

export type SalesCatalogType = {
  __typename?: 'SalesCatalogType';
  activeFrom?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  salesPrices: Array<SalesPriceType>;
  state: SalescatalogsSalesCatalogStateChoices;
};

export type SalesContractDocumentType = {
  __typename?: 'SalesContractDocumentType';
  changeReasonExtraInfo: Scalars['String']['output'];
  changeType: SalescontractsSalesContractDocumentChangeTypeChoices;
  contractVersion: SalesContractVersionType;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  id: Scalars['ID']['output'];
};

/** An enumeration. */
export enum SalesContractState {
  Contract = 'CONTRACT',
  Finished = 'FINISHED',
  Offer = 'OFFER',
  SentForSignature = 'SENT_FOR_SIGNATURE',
  TerminationInProgress = 'TERMINATION_IN_PROGRESS'
}

export type SalesContractType = {
  __typename?: 'SalesContractType';
  contractContactPerson?: Maybe<ContactPersonType>;
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<CustomerType>;
  id: Scalars['ID']['output'];
  salesContractVersions: Array<SalesContractVersionType>;
  signatureRequestSentAt?: Maybe<Scalars['DateTime']['output']>;
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  state: SalesContractState;
  terminatedAt?: Maybe<Scalars['DateTime']['output']>;
  terminatedBy?: Maybe<UserType>;
  terminationPeriod: Scalars['Int']['output'];
  terminationReason?: Maybe<ContractTerminationReasonType>;
  validTo?: Maybe<Scalars['Date']['output']>;
};

export type SalesContractVersionPricesType = {
  __typename?: 'SalesContractVersionPricesType';
  costPerOffice: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  discounts: Array<DiscountType>;
  extraPriceExposure: Scalars['Decimal']['output'];
  firstHealthCheckPrice: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  initialCostExtraServicesPerCompany: Scalars['Decimal']['output'];
  initialCostExtraServicesPerPerson: Scalars['Decimal']['output'];
  initialCostPerCompany: Scalars['Decimal']['output'];
  initialCostPerPerson: Scalars['Decimal']['output'];
  numberOfOffices: Scalars['Int']['output'];
  salesContractVersion: SalesContractVersionType;
};

export type SalesContractVersionType = {
  __typename?: 'SalesContractVersionType';
  contract: SalesContractType;
  contractDocuments: Array<SalesContractDocumentType>;
  createdAt: Scalars['DateTime']['output'];
  customerReferenceAllowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isLegacyContract: Scalars['Boolean']['output'];
  legacyServicesDescription?: Maybe<Scalars['String']['output']>;
  legacyServicesName?: Maybe<Scalars['String']['output']>;
  numberOfPersons: Scalars['Int']['output'];
  numberOfPersonsExposure: Scalars['Int']['output'];
  numberOfPersonsNonExposure: Scalars['Int']['output'];
  prices?: Maybe<SalesContractVersionPricesType>;
  receptionChoice?: Maybe<SalescontractsSalesContractVersionReceptionChoiceChoices>;
  salesExtraServices: Array<SalesExtraServiceType>;
  salesPackage: SalesPackageType;
  urlToPdf: Scalars['String']['output'];
  userSeller: UserType;
  validFrom: Scalars['Date']['output'];
};

/** An enumeration. */
export enum SalesExtraServiceProductChoices {
  ExtraServicePackage = 'EXTRA_SERVICE_PACKAGE',
  ExtraServicePackageWithCoaching = 'EXTRA_SERVICE_PACKAGE_WITH_COACHING',
  MentalWellnessCoverage = 'MENTAL_WELLNESS_COVERAGE',
  OtherMedicalCareServicesNoSickLeavesSelfDeclaration = 'OTHER_MEDICAL_CARE_SERVICES_NO_SICK_LEAVES_SELF_DECLARATION',
  OtherMedicalCareServicesWithSickLeavesSelfDeclaration = 'OTHER_MEDICAL_CARE_SERVICES_WITH_SICK_LEAVES_SELF_DECLARATION',
  SeriousIllnessCoverage = 'SERIOUS_ILLNESS_COVERAGE'
}

export type SalesExtraServiceType = {
  __typename?: 'SalesExtraServiceType';
  billingPeriods: Array<BillingPeriodInvoiceRowType>;
  description: Scalars['String']['output'];
  group?: Maybe<SalescatalogsSalesExtraServiceGroupChoices>;
  id: Scalars['ID']['output'];
  locallyAvailable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  product: SalescatalogsSalesExtraServiceProductChoices;
  remotelyAvailable: Scalars['Boolean']['output'];
  salesPackages: Array<SalesPackageType>;
  salesPrices: Array<SalesPriceType>;
  salescontractversionSet: Array<SalesContractVersionType>;
};

/** An enumeration. */
export enum SalesPackageLevelChoices {
  Level1 = 'LEVEL1'
}

export type SalesPackageType = {
  __typename?: 'SalesPackageType';
  billingPeriods: Array<BillingPeriodInvoiceRowType>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  level: SalescatalogsSalesPackageLevelChoices;
  name: Scalars['String']['output'];
  salesPrices: Array<SalesPriceType>;
  salescontractversionSet: Array<SalesContractVersionType>;
  salesextraserviceSet: Array<SalesExtraServiceType>;
};

export type SalesPriceType = {
  __typename?: 'SalesPriceType';
  customerPricePerMonth: Scalars['Decimal']['output'];
  discountType?: Maybe<SalescatalogsSalesPriceDiscountTypeChoices>;
  id: Scalars['ID']['output'];
  salesCatalog: SalesCatalogType;
  salesExtraService?: Maybe<SalesExtraServiceType>;
  salesPackage?: Maybe<SalesPackageType>;
  userPricePerMonth: Scalars['Decimal']['output'];
};

/** An enumeration. */
export enum SalescatalogsDiscountDiscountTypeChoices {
  /** Extra Services */
  ExtraServices = 'EXTRA_SERVICES',
  /** Health Care Reception */
  HealthCareReception = 'HEALTH_CARE_RECEPTION',
  /** Sales Package */
  SalesPackage = 'SALES_PACKAGE'
}

/** An enumeration. */
export enum SalescatalogsSalesCatalogStateChoices {
  /** Luonnos */
  Draft = 'DRAFT',
  /** Lukittu */
  Locked = 'LOCKED'
}

/** An enumeration. */
export enum SalescatalogsSalesExtraServiceGroupChoices {
  /** Extra services */
  ExtraServices = 'EXTRA_SERVICES',
  /** Other medical care services */
  OtherMedicalCareServices = 'OTHER_MEDICAL_CARE_SERVICES'
}

/** An enumeration. */
export enum SalescatalogsSalesExtraServiceProductChoices {
  /** Extra service package */
  ExtraServicePackage = 'EXTRA_SERVICE_PACKAGE',
  /** Extra service package with coaching */
  ExtraServicePackageWithCoaching = 'EXTRA_SERVICE_PACKAGE_WITH_COACHING',
  /** Mental wellness coverage */
  MentalWellnessCoverage = 'MENTAL_WELLNESS_COVERAGE',
  /** Other medical care services - no sick leaves self declaration */
  OtherMedicalCareServicesNoSickLeavesSelfDeclaration = 'OTHER_MEDICAL_CARE_SERVICES_NO_SICK_LEAVES_SELF_DECLARATION',
  /** Other medical care services with sick leaves self declaration */
  OtherMedicalCareServicesWithSickLeavesSelfDeclaration = 'OTHER_MEDICAL_CARE_SERVICES_WITH_SICK_LEAVES_SELF_DECLARATION',
  /** Serious illness coverage */
  SeriousIllnessCoverage = 'SERIOUS_ILLNESS_COVERAGE'
}

/** An enumeration. */
export enum SalescatalogsSalesPackageLevelChoices {
  /** Service level 1 */
  Level1 = 'LEVEL1'
}

/** An enumeration. */
export enum SalescatalogsSalesPriceDiscountTypeChoices {
  /** Extra Services */
  ExtraServices = 'EXTRA_SERVICES',
  /** Health Care Reception */
  HealthCareReception = 'HEALTH_CARE_RECEPTION',
  /** Sales Package */
  SalesPackage = 'SALES_PACKAGE'
}

/** An enumeration. */
export enum SalescontractsSalesContractDocumentChangeTypeChoices {
  /** Sopimus allekirjoitettu */
  ContractSigned = 'CONTRACT_SIGNED',
  /** Sopimus irtisanottu */
  ContractTerminated = 'CONTRACT_TERMINATED',
  /** Ihmisen tekemä muutos */
  HumanMadeChange = 'HUMAN_MADE_CHANGE',
  /** Tarjous luotu */
  OfferCreated = 'OFFER_CREATED',
  /** Lähetetty allekirjoitettavaksi */
  SentForSignature = 'SENT_FOR_SIGNATURE',
  /** Järjestelmän tekemä muutos */
  SystemMadeChange = 'SYSTEM_MADE_CHANGE'
}

/** An enumeration. */
export enum SalescontractsSalesContractVersionReceptionChoiceChoices {
  /** Local and remote reception */
  LocalAndRemote = 'LOCAL_AND_REMOTE',
  /** Only remote reception */
  RemoteOnly = 'REMOTE_ONLY'
}

export type SaveAnswers = {
  __typename?: 'SaveAnswers';
  treeResult?: Maybe<TreeResultType>;
};

/** An enumeration. */
export enum SchedulingPrecisionChoices {
  Day = 'DAY',
  Time = 'TIME'
}

export type SendDocumentToKanta = {
  __typename?: 'SendDocumentToKanta';
  documentSent?: Maybe<Scalars['String']['output']>;
};

export type SendHealthCheckInvitation = {
  __typename?: 'SendHealthCheckInvitation';
  healthCheck: HealthCheckBasicInformation;
};

/** Mutation which send prescription repudiations to Kanta. */
export type SendPrescriptionRepudiations = {
  __typename?: 'SendPrescriptionRepudiations';
  /** Oid codes of the documents which repudiation failed. */
  failedToSendOids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Failure reasons for each failed document. */
  failureReasons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Succesfully sent document oid codes */
  succesfullySentOids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SendUserToAcute = {
  __typename?: 'SendUserToAcute';
  user: UserType;
};

export type ServiceEvent = {
  __typename?: 'ServiceEvent';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  laboratoryorderSet: Array<LaboratoryOrderType>;
  officeOrderNumber: Scalars['Int']['output'];
  oid: Scalars['String']['output'];
  organization: Organization;
  patient: PatientType;
  status: ServiceeventsServiceEventStatusChoices;
};

export enum ServiceEventStatusInputType {
  Closed = 'CLOSED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

/**
 * Customer service settings filter of the contact person export: only
 * enabled settings are matched, combined with match 'AND' or 'OR'.
 */
export type ServiceSettingsFilterInput = {
  /** 'AND' or 'OR' */
  match: Scalars['String']['input'];
  /** Procedures with usage allowed */
  procedureIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Voluntary health checks enabled */
  voluntaryHealthCheck?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An enumeration. */
export enum ServiceeventsServiceEventStatusChoices {
  /** Closed */
  Closed = 'CLOSED',
  /** In progress */
  InProgress = 'IN_PROGRESS',
  /** Not started */
  NotStarted = 'NOT_STARTED'
}

export type SetCondition = {
  __typename?: 'SetCondition';
  branch?: Maybe<BranchType>;
};

export type SetMoontalkCredentials = {
  __typename?: 'SetMoontalkCredentials';
  credentials: MoontalkCredentialsType;
};

export type SetOwnHealthCheckBookingUrl = {
  __typename?: 'SetOwnHealthCheckBookingUrl';
  bookingSettings: HealthCheckBookingSettingsType;
};

export type SetPermissionsEqual = {
  __typename?: 'SetPermissionsEqual';
  profile?: Maybe<ProfileType>;
};

export type SickLeaveCategoryIcd10Type = {
  __typename?: 'SickLeaveCategoryIcd10Type';
  icd10: Icd10Type;
  id: Scalars['ID']['output'];
  sickLeaveCategory: SickLeaveCategoryType;
};

export type SickLeaveCategoryType = {
  __typename?: 'SickLeaveCategoryType';
  icd10s: Array<Icd10Type>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  selfReportReasons: Array<SickLeaveSelfReportReasonType>;
  sickleavecategoryicd10Set: Array<SickLeaveCategoryIcd10Type>;
};

export type SickLeaveCertificateType = {
  __typename?: 'SickLeaveCertificateType';
  blobId?: Maybe<Scalars['ID']['output']>;
  categoryIcd10?: Maybe<Icd10Type>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  file?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  sickLeaveNotice: SickLeaveNoticeType;
  submissionTask?: Maybe<TaskType>;
};

/**
 * A person who will be able to see a submitted certificate, with the reasons why. Aggregate
 * of the supervisor / substitute (who have no handler row) and SickLeaveHandler rows, filtered by
 * the notice's state — no direct model. Access is checked in the query resolver: only the
 * employee the notice concerns may list the viewers.
 */
export type SickLeaveCertificateViewerType = {
  __typename?: 'SickLeaveCertificateViewerType';
  afterApproval: Scalars['Boolean']['output'];
  organization: Scalars['String']['output'];
  reasons: Array<SickLeaveHandlerReasonChoices>;
  userId: Scalars['ID']['output'];
  userName: Scalars['String']['output'];
};

/**
 * Aggregate report type, no direct model — one sick leave category class of the diagnosis
 * distribution (OTHER = merged small classes, NONE = uncategorised).
 */
export type SickLeaveDiagnosisClassType = {
  __typename?: 'SickLeaveDiagnosisClassType';
  days: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  merged: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  periods: Scalars['Int']['output'];
  persons: Scalars['Int']['output'];
};

/** Aggregate report type, no direct model — the whole-period diagnosis distribution of a group. */
export type SickLeaveDiagnosisGroupType = {
  __typename?: 'SickLeaveDiagnosisGroupType';
  classes: Array<SickLeaveDiagnosisClassType>;
  cohortSize: Scalars['Int']['output'];
  groupKey: Scalars['String']['output'];
  suppressed: Scalars['Boolean']['output'];
  suppressionReason?: Maybe<SickLeaveReportSuppressionReason>;
};

/**
 * Why a person handles sick leave notices / certificates. The reason decides which
 *     lifecycle states of a notice the person may act on and see the submitted certificate in.
 */
export enum SickLeaveHandlerReasonChoices {
  KelaSicknessAllowance = 'KELA_SICKNESS_ALLOWANCE',
  Payroll = 'PAYROLL',
  SickLeaveApproval = 'SICK_LEAVE_APPROVAL',
  SickLeaveHistory = 'SICK_LEAVE_HISTORY',
  SickLeaveNoticeCreation = 'SICK_LEAVE_NOTICE_CREATION',
  SickLeaveReports = 'SICK_LEAVE_REPORTS'
}

export type SickLeaveHandlerReasonType = {
  __typename?: 'SickLeaveHandlerReasonType';
  handler: SickLeaveHandlerType;
  id: Scalars['ID']['output'];
  reason: SickleavesSickLeaveHandlerReasonReasonChoices;
};

export type SickLeaveHandlerType = {
  __typename?: 'SickLeaveHandlerType';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  customer: CustomerType;
  handlingStartDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  organization: Scalars['String']['output'];
  reasons: Array<SickLeaveHandlerReasonType>;
  user: UserType;
};

/**
 * One approved notice of the sick leave history, no direct model — only the facts a
 * SICK_LEAVE_HISTORY handler may see (sickleaves/funcs.py compute_sick_leave_history). Access is
 * verified on the entries field of SickLeaveHistoryType, which is the only way to reach this.
 */
export type SickLeaveHistoryEntryType = {
  __typename?: 'SickLeaveHistoryEntryType';
  days: Scalars['Int']['output'];
  employeeName: Scalars['String']['output'];
  endDate: Scalars['Date']['output'];
  reference: Scalars['String']['output'];
  startDate: Scalars['Date']['output'];
  typeId: Scalars['ID']['output'];
  typeName: Scalars['String']['output'];
  typeType: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

/**
 * Aggregate type, no direct model — the customer's approved sick leave notices in basic form.
 * The query resolver verifies access and every field re-verifies it
 * (verify_permission_sick_leave_history via the default resolver), so the dict can never leak
 * through a re-used object.
 */
export type SickLeaveHistoryType = {
  __typename?: 'SickLeaveHistoryType';
  customerId: Scalars['ID']['output'];
  dateFrom: Scalars['Date']['output'];
  dateTo: Scalars['Date']['output'];
  entries: Array<SickLeaveHistoryEntryType>;
};

/**
 * Aggregate type, no direct model — the active employees of a customer a named
 * SICK_LEAVE_NOTICE_CREATION handler may add notices for. The query resolver only returns the
 * customer id; the list field verifies verify_permission_sick_leave_notice_creation.
 */
export type SickLeaveNoticeRecipientListType = {
  __typename?: 'SickLeaveNoticeRecipientListType';
  customerId: Scalars['ID']['output'];
  employees: Array<SickLeaveNoticeRecipientType>;
};

/**
 * Employee option for a named notice creator, no direct model — id, names and the approver
 * facts the notice form shows, as plain values. Never resolves the User object, so a creator
 * needs no view_user. Access is verified on the list field of SickLeaveNoticeRecipientListType.
 */
export type SickLeaveNoticeRecipientType = {
  __typename?: 'SickLeaveNoticeRecipientType';
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  supervisorId?: Maybe<Scalars['ID']['output']>;
  supervisorName?: Maybe<Scalars['String']['output']>;
  supervisorSubstituteId?: Maybe<Scalars['ID']['output']>;
  supervisorSubstituteName?: Maybe<Scalars['String']['output']>;
  supervisorSubstituteOngoing: Scalars['Boolean']['output'];
};

/** An enumeration. */
export enum SickLeaveNoticeStatus {
  Decided = 'DECIDED',
  PendingApproval = 'PENDING_APPROVAL',
  PendingHandling = 'PENDING_HANDLING'
}

export type SickLeaveNoticeType = {
  __typename?: 'SickLeaveNoticeType';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  acceptedBy?: Maybe<UserType>;
  canApprove: Scalars['Boolean']['output'];
  canEdit: Scalars['Boolean']['output'];
  canMarkHandled: Scalars['Boolean']['output'];
  canRequestCertificateSubmission: Scalars['Boolean']['output'];
  canViewCertificate: Scalars['Boolean']['output'];
  certificateId?: Maybe<Scalars['ID']['output']>;
  certificateSubmissionPending: Scalars['Boolean']['output'];
  certificateSubmittedToEmployer: Scalars['Boolean']['output'];
  certificates: Array<SickLeaveCertificateType>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  createdByCurrentUser: Scalars['Boolean']['output'];
  endDate: Scalars['Date']['output'];
  handledAt?: Maybe<Scalars['DateTime']['output']>;
  handledBy?: Maybe<UserType>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  pendingHandling: Scalars['Boolean']['output'];
  reason?: Maybe<SickLeaveSelfReportReasonType>;
  reference: Scalars['String']['output'];
  startDate: Scalars['Date']['output'];
  type: SickLeaveTypeType;
  user: UserType;
};

export type SickLeaveNoticeTypeAndReasonType = {
  __typename?: 'SickLeaveNoticeTypeAndReasonType';
  icd10Code?: Maybe<Icd10Type>;
  sickLeaveReason?: Maybe<SickLeaveSelfReportReasonType>;
  sickLeaveType: SickLeaveTypeType;
};

export type SickLeavePeriodSettingType = {
  __typename?: 'SickLeavePeriodSettingType';
  allowedSelfReportPeriodMonths: Scalars['Int']['output'];
  allowedSelfReportTimesPerPeriod: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  sickLeaveSetting: SickLeaveSettingsCustomerType;
};

/**
 * Early support alert for a supervisor, no direct model — a subordinate who meets one of the
 * customer's recurrent absence rules, as plain values (never the User object). Access is checked
 * in Query.resolve_recurrent_absence_alerts_for_supervisor.
 */
export type SickLeaveRecurrentAbsenceAlertType = {
  __typename?: 'SickLeaveRecurrentAbsenceAlertType';
  months: Scalars['Int']['output'];
  periodCount: Scalars['Int']['output'];
  periods: Scalars['Int']['output'];
  userId: Scalars['ID']['output'];
  userName: Scalars['String']['output'];
};

/**
 * A recurrent absence rule as echoed by the aggregate report (plain dict, no direct model);
 * the report resolver has already verified access.
 */
export type SickLeaveRecurrentAbsenceRuleType = {
  __typename?: 'SickLeaveRecurrentAbsenceRuleType';
  months: Scalars['Int']['output'];
  periods: Scalars['Int']['output'];
};

export type SickLeaveRecurrentAbsenceThresholdType = {
  __typename?: 'SickLeaveRecurrentAbsenceThresholdType';
  id: Scalars['ID']['output'];
  months: Scalars['Int']['output'];
  periods: Scalars['Int']['output'];
  sickLeaveSetting: SickLeaveSettingsCustomerType;
};

/** An enumeration. */
export enum SickLeaveReportBucket {
  Month = 'MONTH',
  Total = 'TOTAL',
  Week = 'WEEK',
  Year = 'YEAR'
}

/**
 * Aggregate report type, no direct model — one time bucket of the sick leave report. Access is
 * verified in the query resolver and re-verified on every list field of SickLeaveReportType.
 */
export type SickLeaveReportBucketRangeType = {
  __typename?: 'SickLeaveReportBucketRangeType';
  dateFrom: Scalars['Date']['output'];
  dateTo: Scalars['Date']['output'];
  key: Scalars['String']['output'];
};

/** Aggregate report type, no direct model — one bucket × group cell with its cohort size. */
export type SickLeaveReportCellType = {
  __typename?: 'SickLeaveReportCellType';
  bucketKey: Scalars['String']['output'];
  cohortSize: Scalars['Int']['output'];
  groupKey: Scalars['String']['output'];
  metrics: Array<SickLeaveReportMetricValueType>;
};

/** An enumeration. */
export enum SickLeaveReportDimension {
  CostCenter = 'COST_CENTER',
  EmployeeGroup = 'EMPLOYEE_GROUP',
  None = 'NONE',
  Office = 'OFFICE'
}

/** Aggregate report type, no direct model — one organisation group (ALL / NONE / dimension id). */
export type SickLeaveReportGroupType = {
  __typename?: 'SickLeaveReportGroupType';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** An enumeration. */
export enum SickLeaveReportMetric {
  AbsencePercent = 'ABSENCE_PERCENT',
  DaysPerEmployee = 'DAYS_PER_EMPLOYEE',
  ProlongedExceededCount = 'PROLONGED_EXCEEDED_COUNT',
  ProlongedExceededPercent = 'PROLONGED_EXCEEDED_PERCENT',
  RecurrentExceededCount = 'RECURRENT_EXCEEDED_COUNT',
  RecurrentExceededPercent = 'RECURRENT_EXCEEDED_PERCENT',
  SickLeaveDays = 'SICK_LEAVE_DAYS',
  SickLeavePeriods = 'SICK_LEAVE_PERIODS',
  SickLeaveWorkdays = 'SICK_LEAVE_WORKDAYS'
}

/**
 * Aggregate report type, no direct model — one disclosure-controlled metric of a cell. When
 * suppressed, value and contributor count are null and the reason tells why.
 */
export type SickLeaveReportMetricValueType = {
  __typename?: 'SickLeaveReportMetricValueType';
  contributorCount?: Maybe<Scalars['Int']['output']>;
  metricType: SickLeaveReportMetric;
  suppressed: Scalars['Boolean']['output'];
  suppressionReason?: Maybe<SickLeaveReportSuppressionReason>;
  value?: Maybe<Scalars['Float']['output']>;
};

/**
 * Aggregate configuration type, no direct model — the longest range allowed for one report
 * period type (sickleaves/reporting.py RANGE_LIMITS). Not sensitive; shown in the UI.
 */
export type SickLeaveReportRangeLimitType = {
  __typename?: 'SickLeaveReportRangeLimitType';
  bucket: SickLeaveReportBucket;
  limit: Scalars['Int']['output'];
  unit: SickLeaveReportRangeUnit;
};

/** An enumeration. */
export enum SickLeaveReportRangeUnit {
  Months = 'MONTHS',
  Weeks = 'WEEKS',
  Years = 'YEARS'
}

/** An enumeration. */
export enum SickLeaveReportSuppressionReason {
  BinaryFewExceeded = 'BINARY_FEW_EXCEEDED',
  BinaryFewNotExceeded = 'BINARY_FEW_NOT_EXCEEDED',
  CategoryTooSmall = 'CATEGORY_TOO_SMALL',
  CohortTooSmall = 'COHORT_TOO_SMALL',
  Complementary = 'COMPLEMENTARY',
  Dominance = 'DOMINANCE',
  TooFewContributors = 'TOO_FEW_CONTRIBUTORS'
}

/**
 * Aggregate report type, no direct model — the employer's disclosure-controlled sick leave
 * report (sickleaves/reporting.py). The query resolver verifies access and every field
 * re-verifies it (verify_permission_sick_leave_report via the default resolver), so the dict can
 * never leak through a cached or re-used object.
 */
export type SickLeaveReportType = {
  __typename?: 'SickLeaveReportType';
  bucket: SickLeaveReportBucket;
  buckets: Array<SickLeaveReportBucketRangeType>;
  cells: Array<SickLeaveReportCellType>;
  customerId: Scalars['ID']['output'];
  dateFrom: Scalars['Date']['output'];
  dateTo: Scalars['Date']['output'];
  diagnosis: Array<SickLeaveDiagnosisGroupType>;
  dimension: SickLeaveReportDimension;
  groups: Array<SickLeaveReportGroupType>;
  maxDominantShare: Scalars['Float']['output'];
  maxDominantShareCategories: Scalars['Float']['output'];
  minBinarySide: Scalars['Int']['output'];
  minCategoryPersons: Scalars['Int']['output'];
  minCohort: Scalars['Int']['output'];
  minCohortCategories: Scalars['Int']['output'];
  minContributors: Scalars['Int']['output'];
  prolongedAbsenceThresholdDays: Scalars['Int']['output'];
  recurrentAbsenceThresholds: Array<SickLeaveRecurrentAbsenceRuleType>;
};

export type SickLeaveSelfReportReasonType = {
  __typename?: 'SickLeaveSelfReportReasonType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sickLeaveCategory?: Maybe<SickLeaveCategoryType>;
  sickLeaveSettingsCustomers: Array<SickLeaveSettingsCustomerType>;
  sickLeaves: Array<SickLeaveNoticeType>;
};

export type SickLeaveSettingsCustomerType = {
  __typename?: 'SickLeaveSettingsCustomerType';
  allowedSelfReportDurationContinuously: Scalars['Int']['output'];
  allowedSelfReportDurationPerNotification: Scalars['Int']['output'];
  allowedSelfReportPeriodSettings: Array<SickLeavePeriodSettingType>;
  allowedSelfReportReasons: Array<SickLeaveSelfReportReasonType>;
  alwaysRequestCertificateSubmission: Scalars['Boolean']['output'];
  customer: CustomerType;
  prolongedAbsenceThresholdDays: Scalars['Int']['output'];
  recurrentAbsenceThresholds: Array<SickLeaveRecurrentAbsenceThresholdType>;
  selfReportAdditionalInstructions: Scalars['String']['output'];
};

export type SickLeaveTypeType = {
  __typename?: 'SickLeaveTypeType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sickLeaves: Array<SickLeaveNoticeType>;
  type: SickleavesSickLeaveTypeTypeChoices;
};

/** An enumeration. */
export enum SickleavesSickLeaveHandlerReasonReasonChoices {
  /** Kela Sickness Allowance */
  KelaSicknessAllowance = 'KELA_SICKNESS_ALLOWANCE',
  /** Payroll */
  Payroll = 'PAYROLL',
  /** Sick Leave Approval */
  SickLeaveApproval = 'SICK_LEAVE_APPROVAL',
  /** Sick Leave History */
  SickLeaveHistory = 'SICK_LEAVE_HISTORY',
  /** Sick Leave Notice Creation */
  SickLeaveNoticeCreation = 'SICK_LEAVE_NOTICE_CREATION',
  /** Sick Leave Reports */
  SickLeaveReports = 'SICK_LEAVE_REPORTS'
}

/** An enumeration. */
export enum SickleavesSickLeaveTypeTypeChoices {
  /** Doctor Certificate */
  DoctorCertificate = 'DOCTOR_CERTIFICATE',
  /** External Certificate */
  ExternalCertificate = 'EXTERNAL_CERTIFICATE',
  /** Nurse Certificate */
  NurseCertificate = 'NURSE_CERTIFICATE',
  /** Self Report */
  SelfReport = 'SELF_REPORT',
  /** Unpaid */
  Unpaid = 'UNPAID'
}

export enum SiteType {
  DoctorBackend = 'DOCTOR_BACKEND',
  MainBackend = 'MAIN_BACKEND'
}

export type SmartCardLogin = {
  __typename?: 'SmartCardLogin';
  loggedIn: Scalars['Boolean']['output'];
};

export type SmartCardLogout = {
  __typename?: 'SmartCardLogout';
  loggedOut: Scalars['Boolean']['output'];
};

/** Value belongs to codesystem 1.2.246.537.6.850 values. */
export type SpecialClarification = {
  __typename?: 'SpecialClarification';
  code: Scalars['String']['output'];
  codeSystem?: Maybe<CodeSystemType>;
  dateExplanation?: Maybe<Scalars['String']['output']>;
  dateRequired: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  guidance?: Maybe<Scalars['String']['output']>;
  kelaGuidanceUrl?: Maybe<Scalars['String']['output']>;
};

export type SpecialClarificationInfo = {
  __typename?: 'SpecialClarificationInfo';
  /** Codesystem 1.2.246.537.6.850 code. */
  clarification: SpecialClarification;
  compensationClass: Scalars['String']['output'];
  disease?: Maybe<Scalars['String']['output']>;
};

export type SpecialClarificationInput = {
  /** Value should exist in codeserver 1.2.246.537.6.850 codes. Selected value should be allowed for the assigned drug. */
  code: Scalars['String']['input'];
  /** Date related to special clarification code. Should be defined if selected code requires date. (Required status can be determined from codeserver) */
  date?: InputMaybe<Scalars['Date']['input']>;
};

export type StartCampaign = {
  __typename?: 'StartCampaign';
  campaign?: Maybe<CampaignType>;
};

export type StartUpCostsInvoiceRowType = {
  __typename?: 'StartUpCostsInvoiceRowType';
  createdAt: Scalars['DateTime']['output'];
  customer: CustomerType;
  id: Scalars['ID']['output'];
  invoiceRow: InvoiceSaleRowType;
  quantity: Scalars['Decimal']['output'];
  type: BillablesStartUpCostsInvoiceRowTypeChoices;
  unitPrice: Scalars['Decimal']['output'];
  user?: Maybe<UserType>;
};

/** An enumeration. */
export enum StatementGroupGroupTypeChoices {
  And = 'AND',
  Or = 'OR'
}

export type StatementGroupInput = {
  groupType: StatementGroupGroupTypeChoices;
  statements: Array<InputMaybe<StatementInput>>;
};

export type StatementGroupType = {
  __typename?: 'StatementGroupType';
  condition?: Maybe<ConditionType>;
  createdAt: Scalars['DateTime']['output'];
  documenttemplateitem?: Maybe<DocumentTemplateItemType>;
  groupType: StatementsStatementGroupGroupTypeChoices;
  id: Scalars['ID']['output'];
  statements: Array<StatementType>;
};

export type StatementInput = {
  compare: Scalars['String']['input'];
  operator: StatementOperatorChoices;
  variableKey: Scalars['String']['input'];
};

/** An enumeration. */
export enum StatementOperatorChoices {
  Equal = 'EQUAL',
  Greater = 'GREATER',
  Greaterorequal = 'GREATEROREQUAL',
  Less = 'LESS',
  Lessorequal = 'LESSOREQUAL',
  Nonequal = 'NONEQUAL'
}

export type StatementType = {
  __typename?: 'StatementType';
  compare: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  group?: Maybe<StatementGroupType>;
  id: Scalars['ID']['output'];
  operator: StatementsStatementOperatorChoices;
  variableKey: Scalars['String']['output'];
};

/** An enumeration. */
export enum StatementsStatementGroupGroupTypeChoices {
  /** And */
  And = 'AND',
  /** Or */
  Or = 'OR'
}

/** An enumeration. */
export enum StatementsStatementOperatorChoices {
  /** Equal with */
  Equal = 'EQUAL',
  /** Greater than */
  Greater = 'GREATER',
  /** Greater or equal with */
  Greaterorequal = 'GREATEROREQUAL',
  /** Less than */
  Less = 'LESS',
  /** Less or equal with */
  Lessorequal = 'LESSOREQUAL',
  /** Non-equal with */
  Nonequal = 'NONEQUAL'
}

/**
 * The employee submits the certificate to the employer, either by completing a pending
 * submission task or proactively (a completed task is then created). Who sees the certificate
 * is decided by the notice's state and the customer's named handlers.
 */
export type SubmitSickLeaveCertificateToEmployer = {
  __typename?: 'SubmitSickLeaveCertificateToEmployer';
  sickLeaveNotice: SickLeaveNoticeType;
};

export type SubtitleInputType = {
  show?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type SubtitleType = {
  __typename?: 'SubtitleType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  show?: Maybe<Scalars['Boolean']['output']>;
  title: TitleType;
  value: Scalars['String']['output'];
};

export type SuitabilityStatementType = {
  __typename?: 'SuitabilityStatementType';
  blobId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  file?: Maybe<Scalars['String']['output']>;
  followUpMeasures: Array<FollowUpMeasuresType>;
  healthCheckId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  permitTask?: Maybe<TaskType>;
  reference: Scalars['String']['output'];
  userFirstName: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
  userLastName: Scalars['String']['output'];
};

export type SupplierAndPrice = {
  price: Scalars['Decimal']['input'];
  supplierId: Scalars['ID']['input'];
};

export type SupplierPackagePriceType = {
  __typename?: 'SupplierPackagePriceType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mainTest: Scalars['Int']['output'];
  price: Scalars['Decimal']['output'];
  supplier: LaboratorySupplierType;
  supplierPackage: SupplierPackageType;
};

export type SupplierPackageTestType = {
  __typename?: 'SupplierPackageTestType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  laboratoryTest: LaboratoryTestType;
  order: Scalars['Int']['output'];
  supplierPackage: SupplierPackageType;
};

export type SupplierPackageType = {
  __typename?: 'SupplierPackageType';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  norrepackagetestSet: Array<NorrePackageTestType>;
  salesPrices: Array<LaboratoryCatalogSalesPriceType>;
  supplierpackagepriceSet: Array<SupplierPackagePriceType>;
  supplierpackagetestSet: Array<SupplierPackageTestType>;
};

export type SupplierTestPriceType = {
  __typename?: 'SupplierTestPriceType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  laboratoryTest: LaboratoryTestType;
  price: Scalars['Decimal']['output'];
  supplier: LaboratorySupplierType;
};

/** An enumeration. */
export enum SurveyType {
  HealthCheckInformation = 'HEALTH_CHECK_INFORMATION',
  PersonalInsurancesInformation = 'PERSONAL_INSURANCES_INFORMATION',
  QwlAndIndividualWellness = 'QWL_AND_INDIVIDUAL_WELLNESS'
}

export type SyncAuthUsersMedical = {
  __typename?: 'SyncAuthUsersMedical';
  success: Scalars['Boolean']['output'];
};

/**
 * Triggers the Google Calendar booking sync. Run by the Cloud Scheduler job with an
 * API token whose role grants only the narrow mark_health_check_booked permission.
 */
export type SyncHealthCheckBookings = {
  __typename?: 'SyncHealthCheckBookings';
  success: Scalars['Boolean']['output'];
};

export type SyncInvoicesSaleExternal = {
  __typename?: 'SyncInvoicesSaleExternal';
  invoicesSale?: Maybe<Array<Maybe<InvoiceSaleType>>>;
};

export type TaskAssignmentInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type TaskSchedulingInput = {
  due: Scalars['DateTime']['input'];
  precision: SchedulingPrecisionChoices;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  timeWindowStart?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TaskSchedulingType = {
  __typename?: 'TaskSchedulingType';
  due: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  precision: TasksTaskSchedulingPrecisionChoices;
  task: TaskType;
  taskTimeWindowStart?: Maybe<Scalars['DateTime']['output']>;
};

export type TaskType = {
  __typename?: 'TaskType';
  cancellationReason: Scalars['String']['output'];
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  cancelledBy?: Maybe<UserType>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<UserType>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  customer: CustomerType;
  descriptionExternal: Scalars['String']['output'];
  descriptionInternal: Scalars['String']['output'];
  durationEstimateSeconds?: Maybe<Scalars['Int']['output']>;
  followUpMeasures: Array<FollowUpMeasuresType>;
  healthcareTeam?: Maybe<HealthcareTeamType>;
  id: Scalars['ID']['output'];
  professionalGroup?: Maybe<ProfessionalGroupType>;
  scheduling?: Maybe<TaskSchedulingType>;
  sickLeaveCertificate?: Maybe<SickLeaveCertificateType>;
  subjectUser?: Maybe<UserType>;
  suitabilityStatement?: Maybe<SuitabilityStatementType>;
  taskParent?: Maybe<TaskType>;
  tasksChildren: Array<TaskType>;
  title: Scalars['String']['output'];
  type: TasksTaskTypeChoices;
};

/** An enumeration. */
export enum TaskTypeChoices {
  AccountingPeriodUpdate = 'ACCOUNTING_PERIOD_UPDATE',
  ActionPlanCheck = 'ACTION_PLAN_CHECK',
  Custom = 'CUSTOM',
  CustomerContactingAndInforming = 'CUSTOMER_CONTACTING_AND_INFORMING',
  CustomerInsurancesUpToDate = 'CUSTOMER_INSURANCES_UP_TO_DATE',
  CustomerServiceSettingsUpToDate = 'CUSTOMER_SERVICE_SETTINGS_UP_TO_DATE',
  EmployeesInforming = 'EMPLOYEES_INFORMING',
  EmployeeInsurancesUpToDate = 'EMPLOYEE_INSURANCES_UP_TO_DATE',
  EmployeeListUpToDate = 'EMPLOYEE_LIST_UP_TO_DATE',
  FollowUpMeasures = 'FOLLOW_UP_MEASURES',
  HealthCheck = 'HEALTH_CHECK',
  HealthChecksScheduling = 'HEALTH_CHECKS_SCHEDULING',
  KelaReportReceiptConfirmation = 'KELA_REPORT_RECEIPT_CONFIRMATION',
  PermitEmployerViewSuitabilityStatement = 'PERMIT_EMPLOYER_VIEW_SUITABILITY_STATEMENT',
  SubmitSickLeaveCertificateToEmployer = 'SUBMIT_SICK_LEAVE_CERTIFICATE_TO_EMPLOYER',
  WorkPlaceAssessmentScheduling = 'WORK_PLACE_ASSESSMENT_SCHEDULING',
  WorkPlaceAssessmentUpdate = 'WORK_PLACE_ASSESSMENT_UPDATE'
}

/** An enumeration. */
export enum TasksTaskSchedulingPrecisionChoices {
  /** Day */
  Day = 'DAY',
  /** Time */
  Time = 'TIME'
}

/** An enumeration. */
export enum TasksTaskTypeChoices {
  /** Accounting Period Update */
  AccountingPeriodUpdate = 'ACCOUNTING_PERIOD_UPDATE',
  /** Action Plan Check */
  ActionPlanCheck = 'ACTION_PLAN_CHECK',
  /** Custom */
  Custom = 'CUSTOM',
  /** Customer Contacting And Informing */
  CustomerContactingAndInforming = 'CUSTOMER_CONTACTING_AND_INFORMING',
  /** Customer Insurances Up To Date */
  CustomerInsurancesUpToDate = 'CUSTOMER_INSURANCES_UP_TO_DATE',
  /** Customer Service Settings Up To Date */
  CustomerServiceSettingsUpToDate = 'CUSTOMER_SERVICE_SETTINGS_UP_TO_DATE',
  /** Employees Informing */
  EmployeesInforming = 'EMPLOYEES_INFORMING',
  /** Employee Insurances Up To Date */
  EmployeeInsurancesUpToDate = 'EMPLOYEE_INSURANCES_UP_TO_DATE',
  /** Employee List Up To Date */
  EmployeeListUpToDate = 'EMPLOYEE_LIST_UP_TO_DATE',
  /** Follow Up Measures */
  FollowUpMeasures = 'FOLLOW_UP_MEASURES',
  /** Health Check */
  HealthCheck = 'HEALTH_CHECK',
  /** Health Checks Scheduling */
  HealthChecksScheduling = 'HEALTH_CHECKS_SCHEDULING',
  /** Kela Report Receipt Confirmation */
  KelaReportReceiptConfirmation = 'KELA_REPORT_RECEIPT_CONFIRMATION',
  /** Permit Employer View Suitability Statement */
  PermitEmployerViewSuitabilityStatement = 'PERMIT_EMPLOYER_VIEW_SUITABILITY_STATEMENT',
  /** Submit Sick Leave Certificate To Employer */
  SubmitSickLeaveCertificateToEmployer = 'SUBMIT_SICK_LEAVE_CERTIFICATE_TO_EMPLOYER',
  /** Work Place Assessment Scheduling */
  WorkPlaceAssessmentScheduling = 'WORK_PLACE_ASSESSMENT_SCHEDULING',
  /** Work Place Assessment Update */
  WorkPlaceAssessmentUpdate = 'WORK_PLACE_ASSESSMENT_UPDATE'
}

/** Value belongs to codesystem 1.2.246.537.6.12.999 values. */
export type TechnicalStructureType = {
  __typename?: 'TechnicalStructureType';
  OID?: Maybe<Scalars['String']['output']>;
  abbreviation: Scalars['String']['output'];
  code: Scalars['String']['output'];
  codeSystem?: Maybe<CodeSystemType>;
};

export type TerminateContract = {
  __typename?: 'TerminateContract';
  salesContractDocument: SalesContractDocumentType;
};

export type TestAndOrder = {
  codeId: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
};

export type TimePeriodArguments = {
  /** Specifies unit of time period. For example MONTH. */
  durationUnit: TimeUnit;
  /** Specifies value of time period. */
  durationValue: Scalars['Float']['input'];
};

export type TimePeriodState = {
  __typename?: 'TimePeriodState';
  /** Specifies unit of time period. For example MONTH. */
  durationUnit: TimeUnit;
  /** Specifies value of time period. */
  durationValue: Scalars['Float']['output'];
};

/** An enumeration. */
export enum TimeUnit {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE',
  Month = 'MONTH',
  Second = 'SECOND',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type TitleInputType = {
  careReasonChoices?: InputMaybe<Array<InputMaybe<SubtitleInputType>>>;
  findingsAndStudies?: InputMaybe<Array<InputMaybe<SubtitleInputType>>>;
  treatmentEvaluation?: InputMaybe<Array<InputMaybe<SubtitleInputType>>>;
  treatmentImplementation?: InputMaybe<Array<InputMaybe<SubtitleInputType>>>;
  treatmentPlanning?: InputMaybe<Array<InputMaybe<SubtitleInputType>>>;
  unclassifiedTitles?: InputMaybe<Array<InputMaybe<SubtitleInputType>>>;
};

export type TitleTemplateType = {
  __typename?: 'TitleTemplateType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  public?: Maybe<Scalars['Boolean']['output']>;
  titles: Array<TitleType>;
  user?: Maybe<UserType>;
};

export type TitleType = {
  __typename?: 'TitleType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  subtitles: Array<SubtitleType>;
  template: TitleTemplateType;
};

/** Value belongs to codesystem 1.2.246.537.6.112 values. */
export type ToBeOrNotToBe = {
  __typename?: 'ToBeOrNotToBe';
  code: Scalars['String']['output'];
  codeSystem?: Maybe<CodeSystemType>;
  displayName: Scalars['String']['output'];
};

export type TotalAmountArguments = {
  /** Specifies assigned amount value */
  quantity: Scalars['Float']['input'];
  /** Specifies assigned amount unit */
  unit: Scalars['String']['input'];
};

export type TotalAmountInfo = {
  __typename?: 'TotalAmountInfo';
  amount?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type TotalAmountState = {
  __typename?: 'TotalAmountState';
  /** Specifies assigned amount value */
  quantity: Scalars['Float']['output'];
  /** Specifies assigned amount unit */
  unit: Scalars['String']['output'];
};

export type TreeDataType = {
  __typename?: 'TreeDataType';
  branches: Array<BranchType>;
  id: Scalars['ID']['output'];
  nodes: Array<NodeType>;
  tree: TreeType;
};

export type TreeInfoDataType = {
  __typename?: 'TreeInfoDataType';
  treeId: Scalars['ID']['output'];
  treeName: Scalars['String']['output'];
};

export type TreeResultType = {
  __typename?: 'TreeResultType';
  answers?: Maybe<Scalars['String']['output']>;
  campaignResult?: Maybe<CampaignType>;
  createdAt: Scalars['DateTime']['output'];
  expires: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastAnswerAt?: Maybe<Scalars['DateTime']['output']>;
  nextNode?: Maybe<NodeType>;
  open: Scalars['Boolean']['output'];
  survey: TreeType;
  timestamp: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type TreeType = {
  __typename?: 'TreeType';
  answerSources: Array<Scalars['String']['output']>;
  answers: Array<TreeResultType>;
  campaignSurveys: Array<CampaignSurveyType>;
  category: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  documents: Array<DocumentTemplateType>;
  endText: Scalars['String']['output'];
  endTitle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  internalDescription: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rootNode: NodeType;
  welcomeText: Scalars['String']['output'];
  welcomeTitle: Scalars['String']['output'];
};

/**
 * Removes a (mis)attributed booking from an invitation; an active booking returns
 * to the unmatched list for re-linking or manual removal.
 */
export type UnlinkHealthCheckInvitationBooking = {
  __typename?: 'UnlinkHealthCheckInvitationBooking';
  healthCheck: HealthCheckBasicInformation;
};

export type UnmatchedCalendarBookingType = {
  __typename?: 'UnmatchedCalendarBookingType';
  appointmentEnd?: Maybe<Scalars['DateTime']['output']>;
  appointmentStart?: Maybe<Scalars['DateTime']['output']>;
  attendeeEmail: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  eventSummary: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type UpdateActionPlan = {
  __typename?: 'UpdateActionPlan';
  actionPlan: ActionPlanType;
};

export type UpdateCampaign = {
  __typename?: 'UpdateCampaign';
  campaign?: Maybe<CampaignType>;
};

export type UpdateClosestSupervisor = {
  __typename?: 'UpdateClosestSupervisor';
  newSupervisorId?: Maybe<Scalars['ID']['output']>;
};

export type UpdateCompanyAndSetAddresses = {
  __typename?: 'UpdateCompanyAndSetAddresses';
  company?: Maybe<CompanyType>;
};

export type UpdateCostCenter = {
  __typename?: 'UpdateCostCenter';
  costCenter?: Maybe<CostCenterType>;
};

export type UpdateCustomer = {
  __typename?: 'UpdateCustomer';
  customer?: Maybe<CustomerType>;
};

export type UpdateCustomerInsurances = {
  __typename?: 'UpdateCustomerInsurances';
  customer: CustomerType;
};

export type UpdateCustomerInternalNotes = {
  __typename?: 'UpdateCustomerInternalNotes';
  internalNotes: CustomerInternalNotesType;
};

export type UpdateCustomerInvoicingInformation = {
  __typename?: 'UpdateCustomerInvoicingInformation';
  customer: CustomerType;
};

export type UpdateCustomerName = {
  __typename?: 'UpdateCustomerName';
  customer: CustomerType;
};

export type UpdateCustomerServiceSettings = {
  __typename?: 'UpdateCustomerServiceSettings';
  customerServiceSettings?: Maybe<CustomerServiceSettingsType>;
};

export type UpdateCustomerTasks = {
  __typename?: 'UpdateCustomerTasks';
  taskStatuses: Array<CustomerTaskStatus>;
};

export type UpdateDocument = {
  __typename?: 'UpdateDocument';
  document?: Maybe<DocumentType>;
};

export type UpdateDocumentCategory = {
  __typename?: 'UpdateDocumentCategory';
  documentCategory?: Maybe<DocumentCategoryType>;
};

export type UpdateDocumentTemplate = {
  __typename?: 'UpdateDocumentTemplate';
  template?: Maybe<DocumentTemplateType>;
};

export type UpdateDocumentTemplateItem = {
  __typename?: 'UpdateDocumentTemplateItem';
  item?: Maybe<DocumentTemplateItemType>;
};

export type UpdateEmployeeGroup = {
  __typename?: 'UpdateEmployeeGroup';
  employeeGroup: EmployeeGroupType;
};

export type UpdateEmployeeInternalNotes = {
  __typename?: 'UpdateEmployeeInternalNotes';
  internalNotes: EmployeeInternalNotesType;
};

export type UpdateExposure = {
  __typename?: 'UpdateExposure';
  exposure: ExposureType;
};

export type UpdateFitnessTest = {
  __typename?: 'UpdateFitnessTest';
  fitnessTest: FitnessTestType;
};

export type UpdateFitnessTestDevice = {
  __typename?: 'UpdateFitnessTestDevice';
  fitnessTestDevice: FitnessTestDeviceType;
};

export type UpdateHealthcareTeam = {
  __typename?: 'UpdateHealthcareTeam';
  healthcareTeam?: Maybe<HealthcareTeamType>;
};

export type UpdateInsurance = {
  __typename?: 'UpdateInsurance';
  insurance: InsuranceType;
};

export type UpdateInsuranceCompany = {
  __typename?: 'UpdateInsuranceCompany';
  insuranceCompany: InsuranceCompanyType;
};

export type UpdateInvoiceInterface = {
  __typename?: 'UpdateInvoiceInterface';
  invoiceInterface?: Maybe<InvoiceInterfaceType>;
};

export type UpdateInvoicePurchase = {
  __typename?: 'UpdateInvoicePurchase';
  invoicePurchase?: Maybe<InvoicePurchaseType>;
};

export type UpdateInvoicePurchaseRow = {
  __typename?: 'UpdateInvoicePurchaseRow';
  invoicePurchaseRow?: Maybe<InvoicePurchaseRowType>;
};

export type UpdateLaboratoryCatalog = {
  __typename?: 'UpdateLaboratoryCatalog';
  laboratoryCatalog?: Maybe<LaboratoryCatalogType>;
};

export type UpdateLaboratorySalesPriceAvailability = {
  __typename?: 'UpdateLaboratorySalesPriceAvailability';
  laboratoryCatalogSalesPrice?: Maybe<LaboratoryCatalogSalesPriceType>;
};

export type UpdateLaboratorySupplier = {
  __typename?: 'UpdateLaboratorySupplier';
  laboratorySupplier?: Maybe<LaboratorySupplierType>;
};

export type UpdateLaboratoryTest = {
  __typename?: 'UpdateLaboratoryTest';
  laboratoryTest?: Maybe<LaboratoryTestType>;
};

export type UpdateMedicalApiToken = {
  __typename?: 'UpdateMedicalApiToken';
  id: Scalars['ID']['output'];
};

export type UpdateMedicalPermission = {
  __typename?: 'UpdateMedicalPermission';
  medicalPermission?: Maybe<MedicalPermissionType>;
};

/**
 * Updates the acting user's own email notification switches. Only arguments that are given
 * (non-null) are changed. The row's owner check runs in UserSettings.save().
 */
export type UpdateMyEmailNotificationSettings = {
  __typename?: 'UpdateMyEmailNotificationSettings';
  userSettings: UserSettingsType;
};

export type UpdateNode = {
  __typename?: 'UpdateNode';
  node: NodeType;
};

export type UpdateNorrePackage = {
  __typename?: 'UpdateNorrePackage';
  norrePackage?: Maybe<NorrePackageType>;
};

export type UpdateOwnPersonalInformation = {
  __typename?: 'UpdateOwnPersonalInformation';
  user: UserType;
};

export type UpdatePartner = {
  __typename?: 'UpdatePartner';
  partner?: Maybe<PartnerType>;
};

export type UpdatePaymentCommitment = {
  __typename?: 'UpdatePaymentCommitment';
  paymentCommitment?: Maybe<PaymentCommitmentType>;
};

export type UpdatePaymentCommitmentPatientInfo = {
  __typename?: 'UpdatePaymentCommitmentPatientInfo';
  paymentCommitmentPatientInfo: PaymentCommitmentPatientInfoType;
};

export type UpdatePermissions = {
  __typename?: 'UpdatePermissions';
  profile?: Maybe<ProfileType>;
};

export type UpdateProcedure = {
  __typename?: 'UpdateProcedure';
  procedure?: Maybe<ProcedureType>;
};

export type UpdateProcedurePartnerPrice = {
  __typename?: 'UpdateProcedurePartnerPrice';
  procedurePartnerPrice?: Maybe<ProcedurePartnerPriceType>;
};

export type UpdateProfessionalGroup = {
  __typename?: 'UpdateProfessionalGroup';
  professionalGroup?: Maybe<ProfessionalGroupType>;
};

export type UpdateProfileColor = {
  __typename?: 'UpdateProfileColor';
  profile: ProfileType;
};

export type UpdateProfileName = {
  __typename?: 'UpdateProfileName';
  profile: ProfileType;
};

export type UpdateProfileParent = {
  __typename?: 'UpdateProfileParent';
  profile: ProfileType;
};

export type UpdateQuestion = {
  __typename?: 'UpdateQuestion';
  question: QuestionType;
};

export type UpdateReimbursementConversion = {
  __typename?: 'UpdateReimbursementConversion';
  reimbursementConversion?: Maybe<ReimbursementConversionType>;
};

export type UpdateSalesCatalog = {
  __typename?: 'UpdateSalesCatalog';
  salesCatalog?: Maybe<SalesCatalogType>;
};

export type UpdateSalesPrice = {
  __typename?: 'UpdateSalesPrice';
  salesPrice?: Maybe<SalesPriceType>;
};

export type UpdateSickLeaveCategory = {
  __typename?: 'UpdateSickLeaveCategory';
  sickLeaveCategory?: Maybe<SickLeaveCategoryType>;
};

/**
 * Updates the diagnosis code of a certificate. Used by occupational health staff to edit
 * a certificate they uploaded without having to replace the file.
 */
export type UpdateSickLeaveCertificate = {
  __typename?: 'UpdateSickLeaveCertificate';
  sickLeaveCertificate: SickLeaveCertificateType;
};

export type UpdateSickLeaveHandler = {
  __typename?: 'UpdateSickLeaveHandler';
  sickLeaveHandler: SickLeaveHandlerType;
};

export type UpdateSickLeaveNotice = {
  __typename?: 'UpdateSickLeaveNotice';
  sickLeaveNotice?: Maybe<SickLeaveNoticeType>;
};

export type UpdateSickLeavePeriodSetting = {
  __typename?: 'UpdateSickLeavePeriodSetting';
  sickLeavePeriodSetting?: Maybe<SickLeavePeriodSettingType>;
};

export type UpdateSickLeaveRecurrentAbsenceThreshold = {
  __typename?: 'UpdateSickLeaveRecurrentAbsenceThreshold';
  sickLeaveRecurrentAbsenceThreshold: SickLeaveRecurrentAbsenceThresholdType;
};

export type UpdateSickLeaveSelfReportReason = {
  __typename?: 'UpdateSickLeaveSelfReportReason';
  sickLeaveSelfReportReason?: Maybe<SickLeaveSelfReportReasonType>;
};

export type UpdateSickLeaveSettingsCustomer = {
  __typename?: 'UpdateSickLeaveSettingsCustomer';
  sickLeaveSettingsCustomer?: Maybe<SickLeaveSettingsCustomerType>;
};

export type UpdateSupplierPackage = {
  __typename?: 'UpdateSupplierPackage';
  supplierPackage?: Maybe<SupplierPackageType>;
};

export type UpdateTree = {
  __typename?: 'UpdateTree';
  tree?: Maybe<TreeType>;
};

export type UpdateUser = {
  __typename?: 'UpdateUser';
  user: UserType;
};

export type UpdateUserExposure = {
  __typename?: 'UpdateUserExposure';
  employee: EmployeeForCustomerUserType;
};

export type UpdateUserInsurances = {
  __typename?: 'UpdateUserInsurances';
  user: UserType;
};

export type UpdateUserRoles = {
  __typename?: 'UpdateUserRoles';
  user: UserType;
};

export type UpdateView = {
  __typename?: 'UpdateView';
  view: ViewType;
};

export type UpdateZefapiToken = {
  __typename?: 'UpdateZEFAPIToken';
  zefApiToken: ZefapiTokenType;
};

export type UserContactInfoInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  homeTown?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberJob?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
};

export type UserContactPersonType = {
  __typename?: 'UserContactPersonType';
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  user: UserType;
};

export type UserEmailPhoneNumberReturnType = {
  __typename?: 'UserEmailPhoneNumberReturnType';
  emails: Array<Maybe<Scalars['String']['output']>>;
  phoneNumbers: Array<Maybe<Scalars['String']['output']>>;
};

export type UserEmploymentInformationInput = {
  companyAddressId?: InputMaybe<Scalars['ID']['input']>;
  customerAddressId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  endReason?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type UserEmploymentInformationType = {
  __typename?: 'UserEmploymentInformationType';
  companyAddress?: Maybe<CompanyAddressType>;
  customerAddress?: Maybe<CustomerAddressType>;
  endDate?: Maybe<Scalars['Date']['output']>;
  endReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  startDate?: Maybe<Scalars['Date']['output']>;
  user: UserType;
};

export type UserFileUploadFieldsInputType = {
  accidentInsuranceInfo?: InputMaybe<CustomerUserAccidentInsuranceInfoInput>;
  additionalInfo?: InputMaybe<CustomerUserAdditionalInfo>;
  contactInfo?: InputMaybe<UserContactInfoInput>;
  employmentInfo?: InputMaybe<UserEmploymentInformationInput>;
  medicalInsuranceInfo?: InputMaybe<CustomerUserMedicalInsuranceInfoInput>;
  personalInfo?: InputMaybe<UserPersonalInfoInput>;
  profileInfo?: InputMaybe<ProfileInfoInput>;
};

export type UserHealthCheckInformation = {
  __typename?: 'UserHealthCheckInformation';
  nextCheckDate?: Maybe<Scalars['Date']['output']>;
  previousCheckDate?: Maybe<Scalars['Date']['output']>;
  previousCheckUnknown?: Maybe<Scalars['Boolean']['output']>;
};

export type UserInformationViewLogType = {
  __typename?: 'UserInformationViewLogType';
  id: Scalars['ID']['output'];
  otherReason: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  viewReason: CustomerInformationViewReasonType;
  viewedBy: UserType;
  viewedUser: UserType;
};

export type UserOrError = {
  __typename?: 'UserOrError';
  error?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserType>;
};

export type UserOrganizationalStructureInfo = {
  __typename?: 'UserOrganizationalStructureInfo';
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isSupervisorSubstituteOngoing: Scalars['Boolean']['output'];
  jobTitle: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  nationalIdKnown: Scalars['Boolean']['output'];
  supervisorFirstName?: Maybe<Scalars['String']['output']>;
  supervisorId?: Maybe<Scalars['ID']['output']>;
  supervisorLastName?: Maybe<Scalars['String']['output']>;
  supervisorSubstituteEndDate?: Maybe<Scalars['Date']['output']>;
  supervisorSubstituteFirstName?: Maybe<Scalars['String']['output']>;
  supervisorSubstituteId?: Maybe<Scalars['ID']['output']>;
  supervisorSubstituteLastName?: Maybe<Scalars['String']['output']>;
  supervisorSubstituteStartDate?: Maybe<Scalars['Date']['output']>;
};

export type UserOwnPersonalInformationInputType = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<CustomerUserContactPersonInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  homeTown?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  nickName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberJob?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
};

export type UserPartnerServiceUsage = {
  __typename?: 'UserPartnerServiceUsage';
  id: Scalars['ID']['output'];
  usage: Array<PartnerServiceUsage>;
  userId: Scalars['ID']['output'];
};

export type UserPersonalInfoInput = {
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  nationalId?: InputMaybe<Scalars['String']['input']>;
  nickName?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
};

export type UserQueueType = {
  __typename?: 'UserQueueType';
  action: ActionType;
  address?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['Date']['output']>;
  gender?: Maybe<Scalars['Int']['output']>;
  isCustomerUser: Scalars['Boolean']['output'];
  nationalId?: Maybe<Scalars['String']['output']>;
  postArea?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  updatedFields: Array<Scalars['String']['output']>;
  user: AuthUserType;
};

export type UserRoleCompanyBaseInfo = {
  __typename?: 'UserRoleCompanyBaseInfo';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type UserRoleCustomerBaseInfo = {
  __typename?: 'UserRoleCustomerBaseInfo';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type UserSettingsType = {
  __typename?: 'UserSettingsType';
  emailSickLeaveCertificateSubmissionRequest: Scalars['Boolean']['output'];
  emailSickLeaveCertificateSubmitted: Scalars['Boolean']['output'];
  emailSickLeaveNoticeCreated: Scalars['Boolean']['output'];
  emailSickLeaveNoticeDecision: Scalars['Boolean']['output'];
  emailSickLeaveNoticePendingApproval: Scalars['Boolean']['output'];
  emailSickLeaveNoticePendingHandling: Scalars['Boolean']['output'];
  emailSickLeaveRecurrentAbsenceThreshold: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  termsAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  termsAcceptedVersion: Scalars['String']['output'];
  termsOfUseAccepted: Scalars['Boolean']['output'];
  termsOfUseVersion: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type UserType = {
  __typename?: 'UserType';
  acceptedSickLeaves: Array<SickLeaveNoticeType>;
  acknowledgments: Array<AcknowledgmentType>;
  address: Scalars['String']['output'];
  benefitsRestrictedUntil?: Maybe<Scalars['Date']['output']>;
  benefitsRestrictionCustomReason?: Maybe<Scalars['String']['output']>;
  benefitsRestrictionReason?: Maybe<UsersUserBenefitsRestrictionReasonChoices>;
  billingPeriods: Array<StartUpCostsInvoiceRowType>;
  campaignSurveys: Array<CampaignSurveyType>;
  city: Scalars['String']['output'];
  closestSupervisor?: Maybe<UserType>;
  company?: Maybe<CompanyType>;
  contactPerson?: Maybe<UserContactPersonType>;
  contactPersons: Array<ContactPersonType>;
  costCenter?: Maybe<CostCenterType>;
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdCampaigns: Array<CampaignType>;
  currentEmploymentInfo?: Maybe<UserEmploymentInformationType>;
  customer?: Maybe<CustomerType>;
  dateJoined: Scalars['DateTime']['output'];
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deletedBy?: Maybe<UserType>;
  deletedUsers: Array<UserType>;
  department?: Maybe<DepartmentType>;
  directSubordinates: Array<UserType>;
  documentSet: Array<DocumentType>;
  documentversionSet: Array<DocumentVersionType>;
  email?: Maybe<Scalars['String']['output']>;
  employeeAcknowledgments: Array<AcknowledgmentType>;
  employeeGroup?: Maybe<EmployeeGroupType>;
  employerName?: Maybe<Scalars['String']['output']>;
  employmentInformation: Array<UserEmploymentInformationType>;
  firstName: Scalars['String']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  handledSickLeaves: Array<SickLeaveNoticeType>;
  hasExposure: Scalars['Boolean']['output'];
  hasValidEmploymentRelationship: Scalars['Boolean']['output'];
  healthCheckBookingSettings?: Maybe<HealthCheckBookingSettingsType>;
  healthCheckInformation: UserHealthCheckInformation;
  healthcareteams: Array<HealthcareTeamType>;
  homeTown: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  idAcute: Scalars['String']['output'];
  idMoontalk?: Maybe<Scalars['Int']['output']>;
  idZef?: Maybe<Scalars['Int']['output']>;
  insurances: Array<InsuranceType>;
  internalNotes?: Maybe<EmployeeInternalNotesType>;
  invoicepurchaseSet: Array<InvoicePurchaseType>;
  invoicepurchasecommentSet: Array<InvoicePurchaseCommentType>;
  isActive: Scalars['Boolean']['output'];
  isEntrepreneurWithoutHealthcareUsage: Scalars['Boolean']['output'];
  isHealthcareWorker: Scalars['Boolean']['output'];
  isStaff: Scalars['Boolean']['output'];
  isSupervisor: Scalars['Boolean']['output'];
  isSupplier: Scalars['Boolean']['output'];
  jobTitle: Scalars['String']['output'];
  kelaTwoRestrictionReason?: Maybe<UsersUserKelaTwoRestrictionReasonChoices>;
  laboratorytestSet: Array<LaboratoryTestType>;
  language?: Maybe<LanguageEnum>;
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  logacuteusersyncSet: Array<LogAcuteUserSyncType>;
  nationalIdKnown: Scalars['Boolean']['output'];
  nickName?: Maybe<Scalars['String']['output']>;
  officeDescription?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  paymentcommitmentSet: Array<PaymentCommitmentType>;
  phoneNumber: Scalars['String']['output'];
  phoneNumberJob: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  professionalGroup?: Maybe<ProfessionalGroupType>;
  relatedCustomerHasValidContract: Scalars['Boolean']['output'];
  responsibleDoctorCustomers: Array<CustomerType>;
  responsibleNurseCustomers: Array<CustomerType>;
  rolesCompany: Array<RoleCompanyType>;
  rolesCorporate: Array<RoleCorporateType>;
  rolesCustomer: Array<RoleCustomerType>;
  salescontractversionSet: Array<SalesContractVersionType>;
  sex?: Maybe<UsersUserSexChoices>;
  sickLeaveHandlerRoles: Array<SickLeaveHandlerType>;
  sickLeaves: Array<SickLeaveNoticeType>;
  substituteSupervisors: Array<UserType>;
  suitabilityStatements: Array<SuitabilityStatementType>;
  supervisorName?: Maybe<Scalars['String']['output']>;
  supervisorSubstitute?: Maybe<UserType>;
  supervisorSubstituteEndDate?: Maybe<Scalars['Date']['output']>;
  supervisorSubstituteStartDate?: Maybe<Scalars['Date']['output']>;
  surveyAnswers: Array<TreeResultType>;
  tasksSubjectUser: Array<TaskType>;
  titletemplates: Array<TitleTemplateType>;
  unmatchedCalendarBookings: Array<UnmatchedCalendarBookingType>;
  userSettings?: Maybe<UserSettingsType>;
  uuid: Scalars['ID']['output'];
  views: Array<ViewType>;
};

/** An enumeration. */
export enum UsersUserBenefitsRestrictionReasonChoices {
  /** muu */
  Custom = 'CUSTOM',
  /** perhevapaa */
  FamilyLeave = 'FAMILY_LEAVE',
  /** lomautus */
  LayOff = 'LAY_OFF',
  /** koeaika */
  Probation = 'PROBATION',
  /** työsuhteen lyhytaikaisuus */
  ServiceTime = 'SERVICE_TIME',
  /** vuorotteluvapaa */
  WorkRotation = 'WORK_ROTATION'
}

/** An enumeration. */
export enum UsersUserKelaTwoRestrictionReasonChoices {
  /** perhevapaa */
  FamilyLeave = 'FAMILY_LEAVE',
  /** vuorotteluvapaa */
  WorkRotation = 'WORK_ROTATION'
}

/** An enumeration. */
export enum UsersUserLanguageChoices {
  /** English */
  En = 'EN',
  /** Finnish */
  Fi = 'FI'
}

/** An enumeration. */
export enum UsersUserSexChoices {
  /** nainen */
  Female = 'FEMALE',
  /** mies */
  Male = 'MALE'
}

export type ViewType = {
  __typename?: 'ViewType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  permissions: Array<PermissionType>;
  title: Scalars['String']['output'];
  users: Array<UserType>;
  viewType: ViewsViewViewTypeChoices;
};

/** An enumeration. */
export enum ViewViewTypeChoices {
  Corporateadmin = 'CORPORATEADMIN',
  Customeradmin = 'CUSTOMERADMIN',
  Healthcare = 'HEALTHCARE',
  Regionaladmin = 'REGIONALADMIN',
  Supplier = 'SUPPLIER'
}

/** An enumeration. */
export enum ViewsViewViewTypeChoices {
  /** Corporate admin */
  Corporateadmin = 'CORPORATEADMIN',
  /** Customer admin */
  Customeradmin = 'CUSTOMERADMIN',
  /** Healthcare */
  Healthcare = 'HEALTHCARE',
  /** Regional admin */
  Regionaladmin = 'REGIONALADMIN',
  /** Supplier */
  Supplier = 'SUPPLIER'
}

export type ZefapiTokenType = {
  __typename?: 'ZEFAPITokenType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  tokenStub: Scalars['String']['output'];
};

export type ZefCampaignCommonPropertiesInput = {
  autoAddCustomers: Scalars['Boolean']['input'];
  autoAddUsers: Scalars['Boolean']['input'];
  autoRepeatDays?: InputMaybe<Scalars['Int']['input']>;
  exposureOnly: Scalars['Boolean']['input'];
  responseTimeDays: Scalars['Int']['input'];
};

export type ZefEmailInvitationType = {
  __typename?: 'ZEFEmailInvitationType';
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<Scalars['String']['output']>;
  emailKey: Scalars['String']['output'];
  emailSenderTitle?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ZefInvitationConfigurationInput = {
  remindDelayDays?: InputMaybe<Scalars['Int']['input']>;
  reminder: Scalars['Boolean']['input'];
  zefEmailKey?: InputMaybe<Scalars['String']['input']>;
  zefSmsKey?: InputMaybe<Scalars['String']['input']>;
  zefSurveyConfigurationId?: InputMaybe<Scalars['ID']['input']>;
};

export type ZefInvitationConfigurationType = {
  __typename?: 'ZEFInvitationConfigurationType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  remindDelayDays?: Maybe<Scalars['Int']['output']>;
  reminder: Scalars['Boolean']['output'];
  surveyConfigurationVersion: ZefSurveyConfigurationVersionType;
  zefEmailKey?: Maybe<Scalars['String']['output']>;
  zefSmsKey?: Maybe<Scalars['String']['output']>;
};

export type ZefQuestionConfigurationInput = {
  recordType: ZefRecordType;
  zefQuestionKey: Scalars['String']['input'];
};

export type ZefQuestionConfigurationType = {
  __typename?: 'ZEFQuestionConfigurationType';
  id: Scalars['ID']['output'];
  record: ZefRecordConfigurationType;
  surveys: Array<ZefQuestionSurveyLinkType>;
  zefQuestionKey: Scalars['String']['output'];
};

export type ZefQuestionSurveyLinkType = {
  __typename?: 'ZEFQuestionSurveyLinkType';
  id: Scalars['ID']['output'];
  questionConfiguration: ZefQuestionConfigurationType;
  surveyConfigurationVersion: ZefSurveyConfigurationVersionType;
};

export type ZefQuestionType = {
  __typename?: 'ZEFQuestionType';
  answerType?: Maybe<Scalars['String']['output']>;
  hint?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
  questionKey: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ZefRecordConfigurationType = {
  __typename?: 'ZEFRecordConfigurationType';
  id: Scalars['ID']['output'];
  questions: Array<ZefQuestionConfigurationType>;
  recordType: ZefsurveysZefRecordConfigurationRecordTypeChoices;
};

/** An enumeration. */
export enum ZefRecordType {
  HealthCheckDay = 'HEALTH_CHECK_DAY',
  HealthCheckMonth = 'HEALTH_CHECK_MONTH',
  HealthCheckNotFoundReason = 'HEALTH_CHECK_NOT_FOUND_REASON',
  HealthCheckYear = 'HEALTH_CHECK_YEAR',
  IndividualWellnessQuestion_1 = 'INDIVIDUAL_WELLNESS_QUESTION_1',
  IndividualWellnessQuestion_2 = 'INDIVIDUAL_WELLNESS_QUESTION_2',
  IndividualWellnessQuestion_3 = 'INDIVIDUAL_WELLNESS_QUESTION_3',
  IndividualWellnessQuestion_4 = 'INDIVIDUAL_WELLNESS_QUESTION_4',
  IndividualWellnessQuestion_5 = 'INDIVIDUAL_WELLNESS_QUESTION_5',
  IndividualWellnessQuestion_6 = 'INDIVIDUAL_WELLNESS_QUESTION_6',
  IndividualWellnessQuestion_7 = 'INDIVIDUAL_WELLNESS_QUESTION_7',
  IndividualWellnessQuestion_8 = 'INDIVIDUAL_WELLNESS_QUESTION_8',
  IndividualWellnessQuestion_9 = 'INDIVIDUAL_WELLNESS_QUESTION_9',
  MedicalExpenseInsuranceCompany = 'MEDICAL_EXPENSE_INSURANCE_COMPANY',
  MedicalExpenseInsuranceDescription = 'MEDICAL_EXPENSE_INSURANCE_DESCRIPTION',
  MedicalExpenseInsuranceExist = 'MEDICAL_EXPENSE_INSURANCE_EXIST',
  PersonalAccidentInsuranceCompany = 'PERSONAL_ACCIDENT_INSURANCE_COMPANY',
  PersonalAccidentInsuranceDescription = 'PERSONAL_ACCIDENT_INSURANCE_DESCRIPTION',
  PersonalAccidentInsuranceExist = 'PERSONAL_ACCIDENT_INSURANCE_EXIST',
  QwlQuestion_1 = 'QWL_QUESTION_1',
  QwlQuestion_2 = 'QWL_QUESTION_2',
  QwlQuestion_3 = 'QWL_QUESTION_3',
  QwlQuestion_4 = 'QWL_QUESTION_4',
  QwlQuestion_5 = 'QWL_QUESTION_5',
  QwlQuestion_6 = 'QWL_QUESTION_6',
  QwlQuestion_7 = 'QWL_QUESTION_7',
  QwlQuestion_8 = 'QWL_QUESTION_8',
  QwlQuestion_9 = 'QWL_QUESTION_9',
  QwlQuestion_10 = 'QWL_QUESTION_10',
  QwlQuestion_11 = 'QWL_QUESTION_11',
  QwlQuestion_12 = 'QWL_QUESTION_12',
  QwlQuestion_13 = 'QWL_QUESTION_13',
  QwlQuestion_14 = 'QWL_QUESTION_14',
  QwlQuestion_15 = 'QWL_QUESTION_15'
}

export type ZefsmsInvitationType = {
  __typename?: 'ZEFSMSInvitationType';
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  senderName?: Maybe<Scalars['String']['output']>;
  smsKey: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ZefSurveyConfigurationVersionInput = {
  campaignProperties: ZefCampaignCommonPropertiesInput;
  invitations: Array<ZefInvitationConfigurationInput>;
  questionConfigurations: Array<ZefQuestionConfigurationInput>;
  type: SurveyType;
  zefSurveyKey: Scalars['String']['input'];
};

export type ZefSurveyConfigurationVersionType = {
  __typename?: 'ZEFSurveyConfigurationVersionType';
  autoAddCustomers: Scalars['Boolean']['output'];
  autoAddUsers: Scalars['Boolean']['output'];
  autoRepeatDays?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  exposureOnly: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  invitations: Array<ZefInvitationConfigurationType>;
  name: Scalars['String']['output'];
  questions: Array<ZefQuestionSurveyLinkType>;
  responseTimeDays: Scalars['Int']['output'];
  type?: Maybe<ZefsurveysZefSurveyConfigurationVersionTypeChoices>;
  zefSurveyKey: Scalars['String']['output'];
};

export type ZefSurveyType = {
  __typename?: 'ZEFSurveyType';
  created: Scalars['DateTime']['output'];
  key: Scalars['String']['output'];
  modified?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
};

/** An enumeration. */
export enum ZefsurveysZefRecordConfigurationRecordTypeChoices {
  /** Health Check Day */
  HealthCheckDay = 'HEALTH_CHECK_DAY',
  /** Health Check Month */
  HealthCheckMonth = 'HEALTH_CHECK_MONTH',
  /** Health Check Not Found Reason */
  HealthCheckNotFoundReason = 'HEALTH_CHECK_NOT_FOUND_REASON',
  /** Health Check Year */
  HealthCheckYear = 'HEALTH_CHECK_YEAR',
  /** Individual Wellness Question 1 */
  IndividualWellnessQuestion_1 = 'INDIVIDUAL_WELLNESS_QUESTION_1',
  /** Individual Wellness Question 2 */
  IndividualWellnessQuestion_2 = 'INDIVIDUAL_WELLNESS_QUESTION_2',
  /** Individual Wellness Question 3 */
  IndividualWellnessQuestion_3 = 'INDIVIDUAL_WELLNESS_QUESTION_3',
  /** Individual Wellness Question 4 */
  IndividualWellnessQuestion_4 = 'INDIVIDUAL_WELLNESS_QUESTION_4',
  /** Individual Wellness Question 5 */
  IndividualWellnessQuestion_5 = 'INDIVIDUAL_WELLNESS_QUESTION_5',
  /** Individual Wellness Question 6 */
  IndividualWellnessQuestion_6 = 'INDIVIDUAL_WELLNESS_QUESTION_6',
  /** Individual Wellness Question 7 */
  IndividualWellnessQuestion_7 = 'INDIVIDUAL_WELLNESS_QUESTION_7',
  /** Individual Wellness Question 8 */
  IndividualWellnessQuestion_8 = 'INDIVIDUAL_WELLNESS_QUESTION_8',
  /** Individual Wellness Question 9 */
  IndividualWellnessQuestion_9 = 'INDIVIDUAL_WELLNESS_QUESTION_9',
  /** Medical Expense Insurance Company */
  MedicalExpenseInsuranceCompany = 'MEDICAL_EXPENSE_INSURANCE_COMPANY',
  /** Medical Expense Insurance Description */
  MedicalExpenseInsuranceDescription = 'MEDICAL_EXPENSE_INSURANCE_DESCRIPTION',
  /** Medical Expense Insurance Exist */
  MedicalExpenseInsuranceExist = 'MEDICAL_EXPENSE_INSURANCE_EXIST',
  /** Personal Accident Insurance Company */
  PersonalAccidentInsuranceCompany = 'PERSONAL_ACCIDENT_INSURANCE_COMPANY',
  /** Personal Accident Insurance Description */
  PersonalAccidentInsuranceDescription = 'PERSONAL_ACCIDENT_INSURANCE_DESCRIPTION',
  /** Personal Accident Insurance Exist */
  PersonalAccidentInsuranceExist = 'PERSONAL_ACCIDENT_INSURANCE_EXIST',
  /** Qwl Question 1 */
  QwlQuestion_1 = 'QWL_QUESTION_1',
  /** Qwl Question 2 */
  QwlQuestion_2 = 'QWL_QUESTION_2',
  /** Qwl Question 3 */
  QwlQuestion_3 = 'QWL_QUESTION_3',
  /** Qwl Question 4 */
  QwlQuestion_4 = 'QWL_QUESTION_4',
  /** Qwl Question 5 */
  QwlQuestion_5 = 'QWL_QUESTION_5',
  /** Qwl Question 6 */
  QwlQuestion_6 = 'QWL_QUESTION_6',
  /** Qwl Question 7 */
  QwlQuestion_7 = 'QWL_QUESTION_7',
  /** Qwl Question 8 */
  QwlQuestion_8 = 'QWL_QUESTION_8',
  /** Qwl Question 9 */
  QwlQuestion_9 = 'QWL_QUESTION_9',
  /** Qwl Question 10 */
  QwlQuestion_10 = 'QWL_QUESTION_10',
  /** Qwl Question 11 */
  QwlQuestion_11 = 'QWL_QUESTION_11',
  /** Qwl Question 12 */
  QwlQuestion_12 = 'QWL_QUESTION_12',
  /** Qwl Question 13 */
  QwlQuestion_13 = 'QWL_QUESTION_13',
  /** Qwl Question 14 */
  QwlQuestion_14 = 'QWL_QUESTION_14',
  /** Qwl Question 15 */
  QwlQuestion_15 = 'QWL_QUESTION_15'
}

/** An enumeration. */
export enum ZefsurveysZefSurveyConfigurationVersionTypeChoices {
  /** Health Check Information */
  HealthCheckInformation = 'HEALTH_CHECK_INFORMATION',
  /** Personal Insurances Information */
  PersonalInsurancesInformation = 'PERSONAL_INSURANCES_INFORMATION',
  /** Qwl And Individual Wellness */
  QwlAndIndividualWellness = 'QWL_AND_INDIVIDUAL_WELLNESS'
}

export type _Entity = BillablePatientType | BillableType | BodyCompositionMeasurementResultType | CodeSystemType | ConsentType | CostCenterType | CustomerInformationViewReasonType | DispenseStatus | DoseUnit | DrugExchangeProhibitionReasonType | EducationType | FinLoincType | FitnessDeviceResultType | FitnessTestDeviceType | FitnessTestType | GenderType | Icd10Type | LaboratoryTestNomenclatureType | LaboratoryType | MedicalCustomerType | MedicalPermissionType | MedicinalProductType | PkvType | PatientIdentificationType | PatientType | PaymentCommitmentPatientInfoType | PaymentCommitmentProcedureType | PaymentCommitmentType | PrescriptionMessageType | PrescriptionRenewalProhibitionReasonType | PrescriptionRepudiationType | PrescriptionTypeDefinition | ProcedureType | ProfessionalRightType | ProfileType | RenewalStatus | RestrictionType | SpecialClarification | TechnicalStructureType | ToBeOrNotToBe | UserType | ViewType;

export type _Service = {
  __typename?: '_Service';
  sdl: Scalars['String']['output'];
};
